export default {
  translation: {

    // App
    'apartment_system': 'Sistema di Gestione Appartamenti',
    'apartment_management': 'Gestione Appartamenti',
    'building_management': 'Gestione Edifici',

    // Navigation - updated
    'dashboard': 'Cruscotto',
    'user_management': 'Gestione Utenti',
    'building_management': 'Gestione Edifici',
    'apartment_management': 'Gestione Appartamenti',
    'owner_management': 'Gestione Proprietari',
    'tenant_management': 'Gestione Inquilini',
    'payment_management': 'Gestione Pagamenti',
    'service_management': 'Gestione Servizi',
    'report_management': 'Report e Analisi',
    'log_management': 'Registri Attività',

    // Buildings
    'buildings': 'Edifici',
    'switch_building': 'Edificio attuale',
    'building_list': 'Lista Edifici',
    'add_building': 'Aggiungi Edificio',
    'edit_building': 'Modifica Edificio',
    'building_details': 'Dettagli Edificio',
    'building_name': 'Nome Edificio',
    'building_address': 'Indirizzo',
    'total_floors': 'Piani Totali',
    'total_apartments': 'Appartamenti Totali',

    // Apartments (renamed from Properties)
    'apartments': 'Appartamenti',
    'apartment_list': 'Lista Appartamenti',
    'add_apartment': 'Aggiungi Appartamento',
    'add_your_first_apartment': 'Aggiungi il tuo primo appartamento',
    'edit_apartment': 'Modifica Appartamento',
    'apartment_details': 'Dettagli Appartamento',
    'apartment_number': 'Numero Appartamento',
    'apartment_display': 'Stanza {{number}}',
    'apt': 'Apt',
    'floor_number': 'Numero Piano',
    'floor_display': 'Piano {{number}}',
    'monthly_rent': 'Affitto Mensile',
    'apartment_status': 'Stato',
    'vacant': 'Libero',
    'occupied': 'Occupato',
    'under_maintenance': 'In Manutenzione',
    'key_status': 'Stato chiavi',
    'at_office': 'In ufficio',
    'with_tenant': 'Al conduttore',
    'with_maintenance': 'In manutenzione',
    'lost': 'Smarrito',
    'key_handover': 'Consegna chiavi',
    'give_out_keys': 'Consegnare chiavi',
    'return_keys': 'Restituire chiavi',
    'keys': 'Chiavi',
    'remotes': 'Telecomandi',
    'fobs': 'Badge / Fobs',
    'possession_date': 'Data di possesso',
    'key_details': 'Dettagli chiavi',
    'key_history': 'Cronologia chiavi',
    'record_handover': 'Registra consegna',
    'confirm_and_record': 'Conferma consegna',
    'add_notes': 'Aggiungi eventuali note...',
    'no_key_history': 'Nessun storico consegna chiavi trovato.',
    'loading_history': 'Caricamento storico...',
    'by': 'da',
    'warning_handover_no_tenant': 'Registrazione consegna senza inquilino associato.',
    'key_handover_success': 'Consegna chiavi registrata con successo',
    'failed_to_record_handover': 'Impossibile registrare la consegna chiavi',
    'failed_to_load_history': 'Impossibile caricare lo storico chiavi',
    'key_management': 'Gestione chiavi',
    'manage_keys': 'Gestisci chiavi',
    'total_handovers': 'Totale eventi',
    'given_out': 'Consegnate',
    'returned': 'Restituite',
    'currently_out': 'Attualmente fuori',

    // Services
    'services': 'Servizi',
    'service_payments': 'Pagamenti Servizi',
    'generate_services': 'Genera Pagamenti Servizi',
    'service_statistics': 'Statistiche Servizi',
    'service_type': 'Tipo di Servizio',
    'service_amount': 'Importo',
    'service_date': 'Data Servizio',
    'service_status': 'Stato Pagamento',
    'service_paid': 'Pagato',
    'service_unpaid': 'Non Pagato',
    'total_service_fees': 'Totale Quote Servizio',

    // Reports - updated
    'revenue_report': 'Report Ricavi',
    'payment_logs': 'Registri Pagamenti',
    'occupancy_report': 'Report Occupazione',
    'monthly_payments_report': 'Report Pagamenti Mensili',
    'monthly_payments_subtitle': 'Vista consolidata di affitti e pagamenti di servizi degli inquilini',
    'all_paid': 'Tutto pagato',
    'try_adjusting_filters': 'Prova a regolare il mese, l\'anno o i filtri',
    'pending': 'In sospeso',
    'total': 'Totale',
    'print_receipt': 'Stampa Ricevuta',
    'monthly_revenue': 'Ricavi Mensili',
    'building_revenue': 'Ricavi per Edificio',
    'owner_revenue': 'Ricavi Proprietario',
    'paid_until': 'Pagato fino a',
    'tenant_payments': 'Stato Pagamenti Inquilino',
    'next_billing_date': 'Prossima Data Fatturazione',
    'current_tenant': 'Inquilino Attuale',
    'future_tenant_upcoming': 'Futuro Inquilino',

    // Logs
    'activity_logs': 'Registri Attività',
    'all_user_activities': 'Tutte le Attività Utente',
    'all_user_activities_desc': 'Visualizza tutte le attività e le modifiche dell\'utente',
    'tenant_logs': 'Cronologia Inquilini',
    'tenant_activity_desc': 'Visualizza tutte le attività relative agli inquilini',
    'revenue_by_user': 'Ricavi per Utente',
    'monthly_revenue_by_user': 'Ricavi Mensili per Utente',
    'revenue_breakdown_desc': 'Visualizza il dettaglio dei ricavi per utente per un mese specifico',
    'time': 'Orario',
    'entity': 'Entità',
    'details': 'Dettagli',
    'amount': 'Importo',
    'search_logs': 'Cerca nei log...',
    'filter_activities': 'Filtra attività',
    'action_type': 'Tipo di azione',
    'entity_type': 'Tipo di entità',
    'apply_filter': 'Applica filtro',
    'entries': 'voci',
    'no_logs_matching_search': 'Nessun log corrisponde ai criteri di ricerca',
    'no_logs_available': 'Nessun log di attività disponibile',
    'showing_range': 'Visualizzazione da {{start}} a {{end}} di {{total}} voci',
    'previous': 'Precedente',
    'next': 'Successivo',
    'select_month': 'Seleziona mese',
    'payment_count': 'Conteggio pagamenti',
    'total_amount': 'Importo totale',
    'percentage': 'Percentuale',
    'no_revenue_data': 'Nessun dato sui ricavi disponibile per questo mese',
    'january': 'Gennaio',
    'february': 'Febbraio',
    'march': 'Marzo',
    'april': 'Aprile',
    'may': 'Maggio',
    'june': 'Giugno',
    'july': 'Luglio',
    'august': 'Agosto',
    'september': 'Settembre',
    'october': 'Ottobre',
    'november': 'Novembre',
    'december': 'Dicembre',
    'notification_log': 'Log notifiche',
    'all_notifications': 'Tutte le notifiche',
    'all_channels': 'Tutti i canali',
    'all_statuses': 'Tutti gli stati',
    'all_recipients': 'Tutti i destinatari',
    'sent_at': 'Inviato il',
    'template_subject': 'Modello / Oggetto',
    'email_templates': 'Modelli email',
    'active_templates_count_one': 'Un modello attivo',
    'active_templates_count_other': '{{count}} modelli attivi',
    'new_template': 'Nuovo modello',
    'test_email_placeholder': 'Indirizzo email di prova (utilizzato per tutti i pulsanti di invio prova)',
    'no_email_templates': 'Non ci sono ancora modelli email',
    'create_first_template': 'Crea il primo modello',
    'rent_due': 'Affitto dovuto',
    'late_payment': 'Pagamento in ritardo',
    'lease_renewal': 'Rinnovo del contratto',
    'lease_expiry': 'Scadenza del contratto',
    'move_in': 'Trasloco in entrata',
    'move_out': 'Trasloco in uscita',
    'violation': 'Violazione',
    'maintenance': 'Manutenzione',
    'inspection': 'Ispezione',
    'owner_payout': 'Pagamento proprietario',
    'email_template_form_desc': 'Progetta email automatizzate per i tuoi inquilini e proprietari',
    'update_template': 'Aggiorna modello',
    'create_template': 'Crea modello',
    'visual': 'Visuale',
    'html': 'HTML',
    'live_preview': 'Anteprima dal vivo',
    'subject_line': 'Riga dell\'oggetto',
    'email_content': 'Contenuto dell\'email',
    'event_trigger': 'Attivatore dell\'evento',
    'internal_name': 'Nome interno',
    'dynamic_tags': 'Tag dinamici',
    'starter_templates': 'Modelli iniziali',
    'starter_templates_desc': 'Scegli una base per iniziare a progettare più velocemente',
    'apply_design': 'Applica design',
    'payment_settings': 'Impostazioni di pagamento',
    'accept_online_payments': 'Accetta pagamenti online',
    'stripe_connect_desc': 'Collega il tuo account Stripe per consentire agli inquilini di pagare l\'affitto direttamente tramite il portale. I fondi vengono depositati direttamente sul tuo conto bancario e il nostro sistema tiene traccia di tutto automaticamente.',
    'why_stripe_connect': 'Perché usare Stripe Connect?',
    'stripe_benefit_1': 'Riscossione e monitoraggio automatici dell\'affitto',
    'stripe_benefit_2': 'Depositi diretti sul tuo conto bancario',
    'stripe_benefit_3': 'Elaborazione sicura conforme a PCI',
    'stripe_benefit_4': 'Supporto per la ripartizione delle commissioni della piattaforma',
    'start_stripe_onboarding': 'Avvia l\'onboarding di Stripe',
    'stripe_account_status': 'Stato dell\'account Stripe',
    'active_verified': 'Attivo e verificato',
    'pending_onboarding': 'Azione richiesta: Onboarding in sospeso',
    'complete_setup': 'Completa la configurazione',
    'payments_enabled': 'Pagamenti abilitati',
    'payouts_enabled': 'Payout abilitati',
    'account_id': 'ID account',
    'payment_configuration': 'Configurazione del pagamento',
    'platform_fee_type': 'Tipo di commissione della piattaforma',
    'no_fee_direct': 'Nessuna commissione (pagamento diretto)',
    'percentage_soon': 'Percentuale (disponibile a breve)',
    'fixed_soon': 'Importo fisso (disponibile a breve)',
    'platform_fee_disabled': 'La commissione della piattaforma QuadCores è attualmente disabilitata per la tua organizzazione.',
    'yes': 'Sì',
    'no': 'No',

    // Common
    'loading': 'Caricamento...',
    'save': 'Salva',
    'cancel': 'Annulla',
    'edit': 'Modifica',
    'delete': 'Elimina',
    'add': 'Aggiungi',
    'view': 'Visualizza',
    'search': 'Cerca',
    'filter': 'Filtra',
    'actions': 'Azioni',
    'status': 'Stato',
    'refresh': 'Aggiorna',
    'active': 'Attivo',
    'inactive': 'Inattivo',
    'yes': 'Sì',
    'no': 'No',
    'confirm': 'Conferma',
    'success': 'Successo',
    'error': 'Errore',
    'warning': 'Avvertimento',
    'info': 'Informazioni',

    // App
    'apartment_system': 'Sistema de Apartamentos',
    'apartment_management': 'Gestión de Apartamentos',

    // Authentication
    'login': 'Iniciar Sesión',
    'logout': 'Cerrar Sesión',
    'login_to_continue': 'Inicia sesión para continuar',
    'dont_have_account': "¿No tienes una cuenta?",
    'register': 'Registrarse',
    'username': 'Nombre de usuario',
    'password': 'Contraseña',
    'email': 'Correo electrónico',
    'remember_me': 'Recordarme',
    'forgot_password': '¿Olvidaste tu contraseña?',
    'forgot_password_instructions': 'Ingresa tu nombre de usuario o correo electrónico para recibir un código de verificación',
    'send_code': 'Enviar código de verificación',
    'reset_password': 'Restablecer contraseña',
    'password_reset_success': 'Tu contraseña se ha restablecido correctamente',
    'password_min_length': 'La contraseña debe tener al menos 8 caracteres',
    'login_failed': 'Accesso non riuscito',
    'invalid_credentials': 'Credenziali non valide',
    'security_verification': 'Verifica di sicurezza',
    'verification_code_sent': 'Codice di verifica inviato al tuo dispositivo registrato.',
    'enter_valid_otp': 'Inserisci un codice di verifica valido',
    'verification_failed': 'Verifica fallita',
    'code_resent_success': 'Codice di verifica inviato nuovamente con successo.',
    'too_many_attempts': 'Troppi tentativi. Riprova più tardi.',
    'check_device_for_code': 'Controlla il tuo dispositivo per il codice',
    'verifying': 'Verifica in corso...',

    // Navigation
    'dashboard': 'Panel de Control',
    'core': 'Principal',
    "accounting": "Contabilidad",
    'user_management': 'Gestión de Usuarios',
    'property_management': 'Gestión de Propiedades',
    'maintenance_operations': 'Manutenzione e Operazioni',
    'financial_management': 'Gestione Finanziaria',
    'financial_payments': 'Pagamenti',
    'financial_accounting': 'Contabilità',
    'financial_portfolio': 'Portfolio & KPI',
    'portfolio_kpis': 'Portfolio & KPI',
    'reports_analytics': 'Informes y Análisis',
    'system': 'Sistema',

    // Users
    'system_users': 'Usuarios del Sistema',
    'user_list': 'Lista de Usuarios',
    'add_user': 'Añadir Usuario',
    'edit_user': 'Editar Usuario',
    'user_profile': 'Perfil de Usuario',
    'first_name': 'Nombre',
    'last_name': 'Apellido',
    'phone_number': 'Número de Teléfono',
    'role': 'Rol',
    'administrator': 'Administrador',
    'front_desk': 'Recepción',
    'created_at': 'Creado El',
    'last_login': 'Último Inicio de Sesión',
    'never': 'Nunca',

    // Properties
    'properties': 'Propiedades',
    'property_list': 'Lista de Propiedades',
    'add_property': 'Añadir Propiedad',
    'property_owners': 'Propietarios',
    'owner_list': 'Lista de Propietarios',
    'add_owner': 'Añadir Propietario',
    'owners': 'Propietarios',
    'owner_contracts': 'Contratos de Propietarios',
    'management_agreements': 'Acuerdos de Gestión',
    'add_contract': 'Añadir Contrato',
    'contract_details': 'Detalles del Contrato',
    'no_contracts_message': 'No se encontraron contratos de gestión para este propietario.',
    'contract_type': 'Tipo de Contrato',
    'total_contract_value': 'Valor Total del Contrato',
    'contract_progress': 'Progreso del Contrato',
    'installment_schedule': 'Calendario de Pagos',

    // Tenants
    'tenants': 'Inquilinos',
    'tenant_list': 'Lista de Inquilinos',
    'add_tenant': 'Añadir Inquilino',
    'owner_living': 'Propietario Residente',
    'future_tenant': 'Futuro Inquilino',

    // Payments
    'payments': 'Pagos',
    'all_payments': 'Todos los Pagos',
    'record_payment': 'Registrar Pago',
    'manage_services': 'Gestionar Servicios',
    'generate_payments': 'Generar Pagos',
    'overdue_payments': 'Pagos Atrasados',
    'receipts': 'Recibos',

    // Reports
    'reports': 'Informes',
    'all_reports': 'Todos los Informes',
    'reports_dashboard': 'Panel de Informes',
    'financial_reports': 'Report Finanziari',
    'payment_reports': 'Report Pagamenti',
    'property_reports': 'Report Immobiliari',
    'reports_1099_desc': 'Report IRS 1099-MISC per le distribuzioni ai proprietari',
    'vendor_1099_nec': 'Fornitore 1099-NEC',
    'vendor_1099_desc': 'Reporting annuale IRS – fornitori pagati ≥ $600 in compensi non da dipendente',
    'rent_roll_desc': 'Istantanea di tutte le unità, stato di occupazione, affitto e dettagli della locazione',
    'ar_aging_desc': 'Saldi inquilini in sospeso raggruppati per età (0, 1-30, 31-60, 61-90, 90+)',
    'total_vendors': 'Totale Fornitori',
    'require_1099': '1099 Richiesto',
    'total_reportable': 'Totale Rendicontabile',
    '1099_required': '1099 Richiesto',
    'below_threshold': 'Sotto la soglia',
    'occupancy_rate': 'Tasso di occupazione',
    'scheduled_rent': 'Affitto programmato',
    'aging_breakdown': 'Dettaglio Invecchiamento',

    // Settings
    'settings': 'Impostazioni',
    'profile_settings': 'Impostazioni Profilo',
    'system_settings': 'Impostazioni Sistema',
    'profile': 'Profilo',
    'personal_details': 'Dettagli Personali',
    'security_settings': 'Impostazioni Sicurezza',
    'change_password': 'Cambia Password',
    'current_password': 'Password Attuale',
    'new_password': 'Nuova Password',
    'confirm_new_password': 'Conferma Nuova Password',
    'organization_settings': 'Impostazioni Organizzazione',
    'organization_name': 'Nome Organizzazione',
    'timezone': 'Zona Oraria',
    'subscription_plan': 'Piano di Abbonamento',
    'trial_period': 'Periodo di Prova',
    'days_left': '{{days}} giorni rimasti',
    'subscription_required': 'Abbonamento Richiesto',
    'subscription_expired_message': 'L\'accesso al tuo spazio di lavoro è bloccato. Rinnova l\'abbonamento per continuare a gestire le tue proprietà.',
    'premium_experience_notice': 'Richiesto Spazio di Lavoro Premium',
    'feature_locked_message': 'Questa funzione non è disponibile nel tuo piano attuale. Aggiorna per accedere.',
    'renew_subscription': 'Rinnova Abbonamento',
    'update_profile_success': 'Profilo aggiornato con successo',
    'update_password_success': 'Password cambiata con successo',
    'update_system_success': 'Impostazioni sistema aggiornate con successo',
    'settings_subtitle': 'Gestisci il tuo account e le preferenze di sistema',
    'manage_your_account_and_system_preferences': 'Gestisci il tuo account e le preferenze di sistema',
    'standard_plan': 'Piano Standard',
    'enterprise_plan': 'Piano Enterprise',

    // Notifications
    'notifications': 'Notifiche',
    'view_all_notifications': 'Visualizza Tutte le Notifiche',
    'whatsapp_settings': 'Impostazioni WhatsApp',
    'whatsapp_settings_description': 'Configura i solleciti WhatsApp e SMS per inquilini e proprietari',
    'notification_settings': 'Impostazioni Notifiche',
    'notification_settings_desc': 'Configura i solleciti WhatsApp e SMS per inquilini e proprietari',
    'whatsapp_enable': 'Abilita Notifiche WhatsApp',
    'whatsapp_enable_sub': 'Attiva o disattiva tutti i messaggi WhatsApp automatizzati',
    'general_settings': 'Impostazioni Generali',
    'default_country_code': 'Prefisso Internazionale Predefinito',
    'tenant_rent_reminder': 'Sollecito Affitto Inquilino',
    'enable_tenant_rent_reminders': 'Abilita Solleciti Affitto',
    'rent_reminder': 'Sollecito Affitto',
    'rent_reminder_desc': 'Invia agli inquilini con pagamenti scaduti o imminenti',
    'tenant_rent_reminder_sub': 'Invia sollecito agli inquilini prima o dopo la data di scadenza del pagamento',
    'days_before_due': 'Giorni prima della scadenza',
    'reminder_message_template': 'Modello Messaggio',
    'service_fee_reminder': 'Sollecito Oneri di Servizio',
    'enable_service_fee_reminder': 'Abilita Solleciti Oneri di Servizio',
    'service_fee_reminders_desc': 'Notifica agli inquilini e ai proprietari residenti gli oneri di servizio non pagati',
    'service_fee_reminder_sub': 'Notifica agli inquilini i pagamenti imminenti degli oneri di servizio',
    'owner_reminder': 'Sollecito per i Proprietari',
    'enable_owner_reminders': 'Abilita Solleciti per i Proprietari',
    'owner_reminder_sub': 'Avvisa i proprietari quando gli inquilini hanno pagamenti scaduti',
    'owner_message_template': 'Modello Messaggio Proprietario',
    'payment_confirmation': 'Conferma di Pagamento',
    'send_on_payment': 'Invia conferma alla registrazione del pagamento',
    'send_payment_confirmation': 'Invia Conferma di Pagamento',
    'payment_confirmation_sub': 'Notifica automaticamente l\'inquilino via WhatsApp quando un pagamento viene registrato',
    'payment_confirmation_template': 'Modello Messaggio di Conferma',
    'whatsapp_test_send': 'Invia Messaggio di Prova',
    'test_message': 'Messaggio di Prova',
    'send_test_message': 'Invia Messaggio di Prova',
    'whatsapp_test_sent': 'Messaggio di prova inviato!',
    'whatsapp_test_default_message': 'Messaggio di prova dal sistema di gestione immobiliare',
    'send_reminders_now': 'Invia Solleciti Ora',
    'send_reminders_now_description': 'Invia solleciti immediatamente a tutti gli inquilini e proprietari idonei.',
    'whatsapp_must_be_enabled': 'WhatsApp deve essere abilitato prima',
    'phone_number': 'Numero di Telefono',
    'send_test': 'Invia Prova',
    'save_settings': 'Salva Impostazioni',
    'preview_send': 'Anteprima e Invio',
    'sms_twilio': 'SMS (Twilio)',
    'enable_sms_notifications': 'Abilita Notifiche SMS (Twilio)',
    'enable_sms_notifications_desc': 'Attiva o disattiva tutti i messaggi SMS automatizzati',
    'sender': 'Mittente',
    'preview_reminders': 'Anteprima Solleciti Automatici',
    'notification_log_desc': 'Audit trail di tutte le notifiche in uscita',
    'total_sent': 'Totale Inviati',
    'failed_bounced': 'Falliti / Rimbalzati',
    'email_templates_desc': 'Progetta e-mail automatizzate per i tuoi inquilini e proprietari',
    'test_email_address': 'Indirizzo e-mail di test',
    'payment_settings': 'Impostazioni di Pagamento',
    'accept_online_payments': 'Accetta Pagamenti Online',
    'connect_stripe_desc': 'Collega il tuo account Stripe per consentire agli inquilini di pagare l\'affitto direttamente tramite il portale.',
    'start_stripe_onboarding': 'Inizia Onboarding Stripe',
    'active_verified': 'Attivo e Verificato',
    'action_required_onboarding': 'Azione richiesta: Onboarding in sospeso',
    'webhooks_desc': 'Invia eventi ai tuoi sistemi quando accadono cose in APS',
    'recent_deliveries': 'Consegne Recenti',
    'failed_to_load_settings': 'Impossibile caricare le impostazioni',
    'settings_saved': 'Impostazioni salvate con successo',
    'failed_to_save': 'Salvataggio fallito',
    'server_error': 'Errore del server',
    'whatsapp': 'WhatsApp',
    'on': 'ON',
    'off': 'OFF',
    'sms_twilio': 'SMS (Twilio)',
    'via_twilio': 'via Twilio',
    'sender': 'Mittente',
    'no_recipients_match': 'Nessun destinatario corrisponde alle impostazioni attuali e ai dati attivi.',
    'enable_whatsapp_notifications': 'Abilita Notifiche WhatsApp',
    'whatsapp_enable_desc': 'Attiva o disattiva tutti i messaggi WhatsApp automatizzati',
    'enable_sms_notifications': 'Abilita Notifiche SMS (Twilio)',
    'sms_enable_desc': 'Attiva o disattiva tutti i messaggi SMS automatizzati',
    'rent_reminders_desc': 'Invia agli inquilini con pagamenti di affitto scaduti o imminenti',
    'enable_service_fee_reminders': 'Abilita Solleciti Oneri di Servizio',
    'service_fee_reminders_desc': 'Notifica agli inquilini e ai proprietari residenti gli oneri di servizio non pagati',
    'owner_reminders_desc': 'Avvisa i proprietari quando gli inquilini hanno pagamenti in ritardo',
    'send_payment_confirmation': 'Invia Conferma di Pagamento',
    'payment_confirmation_desc': 'Notifica automaticamente l\'inquilino tramite WhatsApp quando viene registrato un pagamento',
    'send_test_sms': 'Invia SMS di Prova',
    'test_sms_desc': 'Verifica la tua integrazione Twilio inviando un messaggio di prova a qualsiasi numero di telefono.',
    'phone_number': 'Numero di Telefono',
    'sms_sent_to': 'SMS inviato a {{to}}',
    'sms_failed': 'SMS fallito',
    'enter_phone_number': 'Inserisci prima un numero di telefono',
    'whatsapp_enable': 'Abilita Notifiche WhatsApp',
    'whatsapp_enable_sub': 'Attiva o disattiva tutti i messaggi WhatsApp automatizzati',
    'default_message_language': 'Lingua Predefinita Messaggi',
    'english': 'Inglese',
    'arabic': 'Arabo',
    'french': 'Francese',
    'german': 'Tedesco',
    'italian': 'Italiano',
    'spanish': 'Spagnolo',
    'kurdish': 'Curdo',
    'preview_send': 'Anteprima e Invia',
    'save_settings': 'Salva Impostazioni',
    'confirm_send_all': 'Conferma e Invia Tutto',
    'no_pending_reminders': 'Nessun sollecito in sospeso al momento.',
    'recipient_pending': 'destinatario(i) in attesa',
    'org_settings_desc': 'Configurazione generale dell\'organizzazione',
    'flat_amount': 'Importo fisso',
    'percent_of_rent': 'Percentuale dell\'affitto',
    'late_fee_configuration': 'Configurazione indennità di mora',
    'enabled': 'Abilitato',
    'disabled': 'Disabilitato',
    'legal_note_late_fees': 'Le leggi variano a seconda dello stato. Consultare le leggi locali su locazioni e inquilini.',
    'grace_period_days': 'Periodo di grazia (giorni)',
    'fee_type': 'Tipo di tariffa',
    'late_fee_summary': 'Indennità di mora',
    'applied_after': 'applicata dopo',
    'past_due': 'Scaduto',
    'days': 'giorni',
    'amount': 'Importo',
    'percentage': 'Percentuale',
    'active': 'Attivo',
    'trial': 'Prova',
    'canceled': 'Annullato',
    'expired': 'Scaduto',
    'unknown': 'Sconosciuto',
    'completed': 'Completato',
    'pending': 'In attesa',
    'failed': 'Fallito',
    'all': 'Tutto',
    'date': 'Data',
    'organization': 'Organizzazione',
    'method': 'Metodo',
    'actions': 'Azioni',
    'starter_plan': 'Starter',
    'pro_plan': 'Pro',
    'enterprise_plan': 'Enterprise',
    'starter_desc': 'Per proprietari indipendenti che gestiscono record interni.',
    'pro_desc': 'Per aziende professionali con flussi di lavoro automatizzati.',
    'enterprise_desc': 'Controllo di livello istituzionale con portali self-service completi.',
    'starter_f1': 'Fino a 100 unità',
    'starter_f2': '2 posti Admin',
    'starter_f3': 'Gestione Edifici e Unità',
    'starter_f4': 'Registro a partita doppia',
    'starter_f5': 'Tracciamento manuale affitto',
    'starter_f6': 'Report finanziari di base',
    'starter_f7': 'Notifiche via email',
    'most_popular': 'Più Popolare',
    'pro_f1': 'Fino a 150 unità',
    'pro_f2': '5 posti Admin',
    'pro_f3': 'Hub globale di manutenzione',
    'pro_f4': 'Conformità depositi cauzionali',
    'pro_f5': 'Estratti conto mensili automatici',
    'pro_f6': 'Solleciti WhatsApp',
    'pro_f7': 'Gestione Proprietari e Ordini di lavoro',
    'pro_f8': 'Analisi occupazione',
    'pro_f9': 'Prenotazioni, Liste d\'attesa e Trasferimenti',
    'pro_f10': 'Supporto prioritario standard',
    'ent_f1': 'Unità e Admin illimitati',
    'ent_f2': 'Portali Inquilini e Proprietari',
    'ent_f3': 'Messaggistica sicura a due vie',
    'ent_f4': 'Pagamenti affitto Stripe E2E',
    'ent_f5': 'Sistema email automatizzato',
    'ent_f6': 'Firma digitale contratti',
    'ent_f7': 'Supporto Multi-Organizzazione',
    'ent_f8': 'Modelli di report personalizzati',
    'ent_f9': 'Log di attività avanzati',
    'ent_f10': 'Accesso API e Webhook',
    'ent_f11': '2FA tramite WhatsApp OTP',
    'choose_a_plan': 'Scegli un Piano',
    'subscribe_now': 'Iscriviti Ora',
    'contact_sales': 'Contatta Vendite',
    'upgrade': 'Upgrade',
    'current': 'Attuale',
    'custom': 'Personalizzato',
    'yr': 'anno',
    'mo': 'mese',
    'expires': 'Scade',
    'renews': 'Rinnova',
    'opening': 'Apertura...',
    'manage_your_subscription_and_billing': 'Gestisci l\'abbonamento e lo storico dei pagamenti',
    'stripe_portal_title': 'Gestione Portale',
    'stripe_portal_desc': 'Gestisci il tuo abbonamento in modo sicuro tramite il portale Stripe.',
    'stripe_secure_notice': '🔒 Pagamenti sicuri gestiti da Stripe',
    'no_payment_history': 'Storico pagamenti non trovato',
    'payment_history': 'Cronologia Pagamenti',
    'monthly': 'Mensile',
    'annual': 'Annuale',
    'subscribe_with_stripe': 'Iscriviti in modo sicuro tramite Stripe',
    'save_20_annual': 'Risparmia il 20% · ${{amount}}/anno fatturato annualmente',

    // Forms
    'personal_information': 'Informazioni Personali',
    'account_information': 'Informazioni Account',
    'security': 'Sicurezza',
    'enter_first_name': 'Inserisci il nome',
    'enter_last_name': 'Inserisci il cognome',
    'enter_email': 'Inserisci l\'indirizzo email',
    'enter_username': 'Inserisci il nome utente',
    'enter_password': 'Inserisci la password',
    'enter_phone_number': 'Inserisci il numero di telefono',
    'confirm_password': 'Conferma Password',
    'leave_blank_to_keep_current': 'Lascia vuoto per mantenere la password attuale',

    // Validation
    'username_too_short': 'El nombre de usuario debe tener al menos 3 caracteres',
    'password_required': 'La contraseña es requerida',
    'password_too_short': 'La contraseña debe tener al menos 6 caracteres',
    'passwords_do_not_match': 'Las contraseñas no coinciden',
    'phone_invalid_format': 'Por favor ingresa un número de teléfono válido',

    // Actions
    'saving': 'Guardando...',
    'deleting': 'Eliminando...',
    'loading_users': 'Cargando usuarios...',
    'loading_user_data': 'Cargando datos del usuario...',
    'update': 'Actualizar',
    'activate': 'Activar',
    'deactivate': 'Desactivar',
    'show_all': 'Mostrar Todo',
    'hide_inactive': 'Ocultar Inactivos',
    'all_roles': 'Todos los Roles',
    'retry': 'Reintentar',

    // Messages
    'no_users_found': 'No se encontraron usuarios',
    'user_created_successfully': 'Usuario creado con éxito',
    'user_updated_successfully': 'Usuario actualizado con éxito',
    'user_deleted_successfully': 'Usuario eliminado con éxito',
    'confirm_deletion': 'Confirmar Eliminación',
    'delete_user_confirmation': '¿Estás seguro de que deseas eliminar a {{name}}? Esta acción no se puede deshacer.',

    // Dashboard
    'welcome_back': 'Bienvenido/a de nuevo',
    'dashboard_subtitle': 'Esto es lo que está pasando hoy con tus propiedades.',
    'total_properties': 'Total de Propiedades',
    'active_tenants': 'Inquilinos Activos',
    'monthly_revenue': 'Ingresos Mensuales',
    'pending_payments': 'Pagos Pendientes',
    'recent_activity': 'Actividad Reciente',
    'recent_transactions': 'Transacciones Recientes',
    'quick_actions': 'Acciones Rápidas',
    'alerts_notifications': 'Alertas y Notificaciones',
    'showing': 'Mostrando',
    'of': 'de',
    'users': 'usuarios',
    'contact': 'Contacto',
    'user': 'Usuario',
    'active_properties': 'Propiedades Activas',
    'occupancy_rate_desc': '{{rate}}% tasa de ocupación',
    'vs_last_month': 'vs mes pasado',
    'overdue_amount': '{{amount}} atrasado',
    'payment_desc': 'Pago de {{type}} - Apt {{number}}',
    'overdue_payments': 'Pagos Atrasados',
    'overdue_payments_msg': '{{count}} inquilinos tienen pagos pendientes por un total de {{amount}}',
    'view_details': 'Ver Detalles',
    'lease_expiring_soon': 'Contrato Próximo a Vencer',
    'lease_expiring_msg': '{{count}} contratos de alquiler vencen en los próximos 30 días',
    'review_leases': 'Revisar Contratos',
    'trial_ending_soon': 'El Período de Prueba Termina Pronto',
    'trial_ending_msg': 'Tu prueba termina en {{days}} días. Suscríbete para evitar la interrupción del servicio.',
    'upgrade_plan': 'Actualizar Plan',
    'last_7_days': 'Últimos 7 días',
    'last_30_days': 'Últimos 30 días',
    'last_3_months': 'Últimos 3 meses',
    'last_year': 'Último año',
    'error_loading_dashboard': 'Error al cargar el panel',
    'reports_dashboard': 'Panel de Informes',
    'overview_of_financial_performance': 'Resumen del rendimiento financiero y estadísticas de propiedades',
    'view_all_reports': 'Ver Todos los Informes',
    'total_revenue': 'Ingresos Totales',
    'total_payments_count': '{{count}} pagos',
    'total_tenants': 'Total de Inquilinos',
    'new_tenants_this_year': '{{count}} nuevos este año',
    'total_buildings_count': '{{count}} edificios',
    'total_owners': 'Total de Propietarios Residentes',
    'ended_contracts_count': '{{count}} contratti terminati',
    'urgent_action': 'Azione Urgente',
    'monthly_revenue_year': 'Ricavi Mensili - {{year}}',
    'occupancy_rate': 'Tasso di Occupazione',
    'quick_reports': 'Report Rapidi',
    'annual_revenue': 'Ricavi Annuali',
    'yearly_breakdown': 'Dettaglio annuale di tutti i ricavi',
    'building_revenue': 'Ricavi per Edificio',
    'revenue_by_building': 'Dettaglio ricavi per edificio',
    'owner_revenue': 'Ricavi Proprietari',
    'revenue_by_owner': 'Dettaglio ricavi per proprietario',
    'detailed_payment_history': 'Storico pagamenti dettagliato e registri',
    'occupied': 'Occupato',
    'vacant': 'Libero',
    'maintenance': 'Manutenzione',
    'excellent': 'Eccellente',
    'good': 'Buono',
    'needs_improvement': 'Richiede Miglioramento',
    'rent': 'Affitto',
    'service': 'Servizio',
    'deposit': 'Deposito',
    'commission': 'Commissione',
    'insurance': 'Assicurazione',
    'total': 'Totale',
    'no_recent_payments': 'Nessun pagamento recente trovato',
    'no_overdue_payments': 'Nessun pagamento scaduto trovato',
    'overdue': 'Scaduto',
    'partial': 'Parziale',
    'expired': 'Scaduto',
    'pending': 'In attesa',
    'paid': 'Pagato',

    'apt': 'Apt',
    'days_overdue': 'días de retraso',
    'more_overdue_tenants': 'más inquilinos atrasados',
    'error_fetching_occupancy': 'Error al obtener datos de ocupación',
    'failed_load_occupancy': 'Error al cargar estadísticas de ocupación',
    'error_fetching_payments': 'Error al obtener pagos recientes',
    'failed_load_payments': 'Error al cargar pagos recientes',
    'error_fetching_tenant_status': 'Error al obtener estado de pago de inquilinos',
    'failed_load_tenant_status': 'Error al cargar estado de pago de inquilinos',
    'failed_to_load_report_data': 'Error al cargar datos del informe',
    'mgmt_fee_collected': 'Commissioni di gestione riscosse (YTD)',
    'mgmt_fee_outstanding': 'Commissioni di gestione in sospeso',
    'active_tenant_arrears': 'Arretrati inquilini attivi',
    'all_accounts_settled': 'Tutti i conti saldati',
    'owner_payments': 'Pagos de Propietarios',
    'all_months': 'Todos los Meses',

    "floor_number": "Piso {{number}}",
    "apartment_number": "Habitación {{number}}",

    // Sidebar specific translations
    'core': 'Principal',
    'user_management': 'Gestión de Usuarios',
    'property_management': 'Gestione Immobiliare',
    'maintenance_operations': 'Manutenzione e Operazioni',
    'financial_management': 'Gestione Finanziaria',
    'reports_analytics': 'Report e Analisi',
    'logs_audit': 'Registri e Audit',
    'all_activities': 'Tutte le Attività',
    'tenant_activities': 'Attività Inquilini',
    'system': 'Sistema',
    'bookings': 'Prenotazioni',
    'booking_list': 'Lista Prenotazioni',
    'new_booking': 'Nuova Prenotazione',
    'booking_calendar': 'Calendario Prenotazioni',
    'waitlist': 'Lista d\'Attesa',
    'analytics': 'Analisi',

    'system_users': 'Utenti del Sistema',
    'user_list': 'Lista Utenti',
    'add_user': 'Aggiungi Utente',

    'buildings': 'Edifici',
    'building_list': 'Lista Edifici',
    'add_building': 'Aggiungi Edificio',

    'apartments': 'Appartamenti',
    'apartment_list': 'Lista Appartamenti',
    'add_apartment': 'Aggiungi Appartamento',

    'owners': 'Proprietari',
    'owner_list': 'Lista Proprietari',
    'add_owner': 'Aggiungi Proprietario',

    'tenants': 'Inquilini',
    'tenant_list': 'Lista Inquilini',
    'add_tenant': 'Aggiungi Inquilino',
    'overdue_rent': 'Affitti Arretrato',

    'payments': 'Pagamenti',
    'all_payments': 'Tutti i Pagamenti',
    'record_payment': 'Registra Pagamento',
    'payment_stats': 'Statistiche Pagamenti',

    'service_payments': 'Pagamenti Servizi',
    'manage_services': 'Gestione Servizi',
    'generate_payments': 'Genera Pagamenti',
    'service_statistics': 'Statistiche Servizi',
    'finance': 'Finanza',
    'transactions': 'Transazioni',
    'service_charges': 'Oneri di servizio',
    'owner_installments': 'Quote proprietario',
    'messages': 'Messaggi',
    'announcements_manager': 'Gestore annunci',
    'all_announcements': 'Tutti gli annunci',
    'sales': 'Vendite',
    'sales_management': 'Gestione vendite',
    'inspections': 'Ispezioni',
    'all_inspections': 'Tutte le ispezioni',
    'renewal_risk': 'Rischio rinnovo',
    'lease_renewals': 'Rinnovi locazione',
    'lease_applications': 'Domande di affitto',
    'application_links': 'Link candidatura',
    'leases': 'Contratti',
    'violations': 'Violazioni',
    'notices': 'Avvisi',
    'screening': 'Screening',
    'documents': 'Documenti',
    'amenities_parking': 'Servizi e Parcheggio',

    // Messages
    'messages_title': 'Messaggi',
    'tenants_tab': 'Inquilini',
    'owners_tab': 'Proprietari',
    'no_conversations': 'Nessuna conversazione ancora',
    'select_conversation_hint': 'Seleziona una conversazione a sinistra per iniziare a messaggiare',
    'type_message_placeholder': 'Scrivi un messaggio...',
    'your_inbox': 'La tua posta in arrivo',
    'you_label': 'Tu: ',
    'mark_as_read': 'Segna come letto',
    'failed_to_load_messages': 'Impossibile caricare i messaggi',
    'failed_to_load_chat_history': 'Impossibile caricare la cronologia chat',
    'failed_to_send_message': 'Impossibile inviare il messaggio',

    // Expenses
    'expenses_title': 'Spese',
    'expenses_subtitle': 'Tracciamento delle spese operative con flusso di approvazione',
    'new_expense': 'Nuova Spesa',
    'new_expense_subtitle': 'Registra una spesa operativa',
    'total_expenses': 'Totale Spese',
    'approved_amount': 'Approvato',
    'how_it_works': 'Come funziona',
    'expense_hint1': 'Registra ogni costo pagato per un edificio: riparazioni, pulizia, spese di gestione, ecc.',
    'expense_hint2': 'Le spese contrassegnate come "In attesa" devono essere approvate prima di influire sul Reddito Operativo Netto (RON)',
    'expense_hint3': '"Addebita al proprietario" registra la spesa direttamente sul libro mastro del proprietario',
    'expense_hint4': 'RON = Affitto riscosso - Spese approvate',
    'search_expenses': 'Cerca per descrizione, fornitore, categoria...',
    'expense_records': 'Registri delle Spese',
    'no_expenses_found': 'Nessuna spesa trovata',

    // Storage / Inventory
    'storage_title': 'Magazzino',
    'storage_subtitle': 'Traccia gli articoli in magazzino e assegnali agli appartamenti — registrato automaticamente nelle Spese',
    'add_stock': 'Aggiungi scorta',
    'stock_value': 'Valore scorte',
    'items_in_storage': 'Articoli in magazzino',
    'total_issued': 'Totale assegnato',
    'stock_on_hand': 'Scorte disponibili',
    'issuance_history': 'Cronologia assegnazioni',
    'quantity_on_hand': 'Disponibile',
    'issue_to_apartment': 'Assegna ad appartamento',
    'issue': 'Assegna',
    'storage_hint1': 'Registra prima gli articoli in magazzino: porte, finestre, sanitari, ecc. — non serve ancora un appartamento',
    'storage_hint2': '"Assegna ad appartamento" sposta le scorte verso un\'unità e registra automaticamente il costo',
    'storage_hint3': 'Il costo assegnato viene registrato come spesa in attesa di approvazione',
    'storage_hint4': 'Il riepilogo per appartamento mostra il costo totale per unità, in base a ciò che è stato effettivamente assegnato',
    'search_materials': 'Cerca per articolo, appartamento, fornitore...',
    'no_materials_found': 'Ancora nulla qui',
    'spend_by_apartment': 'Spesa per appartamento',
    'apartment_label': 'Appartamento',
    'item_name': 'Articolo',
    'item_name_placeholder': 'es. Porta interna, finestra a doppio vetro',
    'items_logged': 'Articoli',
    'quantity': 'Quantità',
    'quantity_required': 'La quantità è obbligatoria',
    'quantity_exceeds_stock': 'Disponibili solo {{available}} in magazzino',
    'available_short': '{{qty}} disponibili',
    'unit_cost': 'Costo unitario',
    'total_cost': 'Costo totale',
    'select_apartment': 'Seleziona appartamento',
    'stock_added': 'Scorta aggiunta al magazzino',
    'material_issued': 'Assegnato all\'appartamento e registrato nelle spese',
    'failed_to_load_materials': 'Impossibile caricare i dati del magazzino',
    'failed_to_load_apartments': 'Impossibile caricare gli appartamenti — controlla la connessione e riprova',

    'approve': 'Approva',
    'void': 'Annulla',
    'confirm_void': 'Annullare questa spesa? L\'azione è irreversibile.',
    'expense_description_placeholder': 'es. Servizio mensile di disinfestazione',
    'select_category': '— Seleziona categoria —',
    'charge_to_owner': 'Addebita al proprietario (verrà registrato nel libro mastro del proprietario)',
    'create_expense': 'Crea Spesa',
    'expense_created': 'Spesa creata',
    'expense_approved': 'Spesa approvata',
    'expense_voided': 'Spesa annullata',
    'invoice_number': 'N. fattura',
    'all_statuses': 'Tutti gli stati',
    'failed_to_load_expenses': 'Impossibile caricare le spese',
    'expense_rejected': 'Spesa rifiutata',
    'confirm_reject': 'Rifiutare questa spesa? Questa azione non può essere annullata.',
    'date_from': 'Data inizio',
    'date_to': 'Data fine',
    'failed_to_load': 'Impossibile caricare i dati',
    'assign_failed': 'Assegnazione fallita',
    'unavailable': 'Non disponibile',
    'filtered_by': 'Filtrato per:',
    'calendar': 'Calendario',
    'notes_placeholder': 'Note aggiuntive…',
    'no_amenities_match_filter': 'Nessun servizio corrisponde al filtro selezionato.',
    'all_amenities': 'Tutti i servizi',
    'no_bookings_on_day': 'Nessuna prenotazione in questo giorno.',
    'parking_assigned': 'Parcheggio assegnato',
    'parking_unassigned': 'Assegnazione parcheggio rimossa',
    'parking_space_deleted': 'Posto auto eliminato',
    'parking_space_created': 'Posto auto creato',
    'parking_space_updated': 'Posto auto aggiornato',
    'parking_spaces_generated': 'Posti auto generati in blocco',
    'booking_deleted': 'Prenotazione eliminata',
    'parking_layout_hint': 'Assegna le righe tramite Modifica spazio per organizzare il layout del parcheggio',
    'delete_amenity_title': 'Elimina servizio',
    'confirm_delete_amenity': 'Sei sicuro di voler eliminare questo servizio? Questa azione non può essere annullata.',
    'delete_parking_space_title': 'Elimina posto auto',
    'confirm_delete_parking': 'Sei sicuro di voler eliminare questo posto auto? Questa azione non può essere annullata.',
    'delete_booking_title': 'Elimina prenotazione',
    'confirm_delete_booking': 'Sei sicuro di voler eliminare questa prenotazione? Questa azione non può essere annullata.',
    'unassign_parking_title': 'Rimuovi assegnazione parcheggio',
    'confirm_unassign_parking': 'Sei sicuro di voler rimuovere l\'assegnazione di questo posto auto?',
    'start_end_required': 'Numeri di inizio e fine obbligatori',
    'space_number_required': 'Il numero dello spazio è obbligatorio',
    'row_zone': 'Fila / Zona',
    'row_zone_hint': 'per il layout della mappa',
    'status_pending_approval': 'In attesa',
    'status_approved': 'Approvato',
    'status_voided': 'Annullato',
    'status_rejected': 'Rifiutato',
    'owner_label': 'Proprietario',
    'select_building': '— Seleziona edificio —',
    'payment_method': 'Metodo di pagamento',
    'method_bank_transfer': 'Bonifico bancario',
    'method_cash': 'Contanti',
    'method_check': 'Assegno',
    'method_credit_card': 'Carta di credito',
    'method_stripe': 'Stripe',
    'method_wire': 'Bonifico telematico',
    'method_other': 'Altro',
    'items_plural': 'elementi',
    'item_singular': 'elemento',
    'all_buildings': 'Tutti gli edifici',

    // Late Fees
    'late_fee_mgmt': 'Gestione indennità di mora',
    'pending_charges': 'Spese in sospeso',
    'history_tab': 'Cronologia',
    'fee_settings': 'Impostazioni tariffe',
    'late_fees_disabled_hint': 'Le indennità di mora sono disabilitate — legale nelle impostazioni',
    'tenants_due_fee': 'Inquilini con indennità di mora dovuta',
    'next_cron_run': 'Prossima esecuzione automatica alle 10:00 (ora dell\'organizzazione)',
    'apply_now': 'Applica ora',
    'applying': 'Applicazione...',
    'waive': 'Scontare',
    'waive_late_fee': 'Sconta indennità di mora',
    'waive_reason_label': 'Motivazione',
    'waive_reason_placeholder': 'es. Accordo di pagamento concordato, cortesia per la prima volta, ecc.',
    'confirm_waiver': 'Conferma sconto',
    'waiving': 'Sconto in corso...',
    'failed_to_load_pending': 'Impossibile caricare le spese in sospeso',
    'failed_to_load_history': 'Impossibile caricare la cronologia',
    'fee_waived': 'Tariffa scontata',
    'failed_to_waive': 'Impossibile scontare',
    'late_fee_assessed': 'Indennità di mora calcolata',
    'failed_to_assess': 'Impossibile calcolare',
    'days_overdue': 'Giorni di ritardo',
    'projected_fee': 'Tariffa prevista',
    'last_fee': 'Ultima tariffa',
    'waive_amount_label': 'Importo sconto ($)',
    'not_found': 'Non trovato',
    'never': 'Mai',
    'balance': 'Saldo',
    'source': 'Fonte',
    'auto_label': 'Auto',
    'manual_label': 'Manuale',
    'late_fees_disabled': 'Indennità di mora disabilitate',
    'of_rent': 'dell\'affitto',
    'day_grace': 'giorni di grazia',
    'no_pending_late_fees': 'Nessun inquilino ha indennità di mora in sospeso al momento.',
    'enable_late_fees_hint': 'Abilita le indennità di mora nelle impostazioni per iniziare il tracciamento.',
    'no_late_fee_records': 'Nessun record di indennità di mora trovato.',
    'all_late_fee_charges': 'Tutte le indennità di mora',
    'failed_to_load_owner_balances': 'Impossibile caricare i saldi dei proprietari',
    'select_at_least_one_owner': 'Seleziona almeno un proprietario',
    'confirm_bulk_payout': 'Pagare {{count}} proprietari per un totale di {{amount}}?',
    'bulk_payout_success': 'Pagati {{count}} proprietari — {{amount}} in totale',
    'bulk_payout_failed': 'Pagamento in blocco fallito',
    'bulk_owner_payout': 'Pagamento in blocco ai proprietari',
    'bulk_payout_subtitle': 'Paga tutti i proprietari con saldi in sospeso in un unico lotto',
    'total_owed_all': 'Totale dovuto (tutti i proprietari)',
    'owners_with_balance': 'Proprietari con saldo',
    'selected_to_pay': 'Selezionato per pagare',
    'balance_owed': 'Saldo dovuto',
    'last_payout': 'Ultimo pagamento',
    'payout_settings': 'Impostazioni di pagamento',
    'period_month': 'Mese del periodo',
    'payout_notes_placeholder': 'es. Distribuzione mensile',
    'pay_owners_btn': 'Paga {{count}} proprietari · {{amount}}',
    'last_batch_results': 'Risultati dell\'ultimo lotto',
    'wire_transfer': 'Bonifico telematico',
    'status_held': 'Trattenuto',
    'status_returned': 'Restituito',
    'status_not_collected': 'Non riscosso',
    'error_loading_deposits': 'Impossibile caricare i depositi cauzionali',
    'deposit_collected': 'Deposito cauzionale riscosso',
    'deposit_returned': 'Deposito cauzionale restituito',
    'security_deposits_subtitle': 'Tracciamento dei depositi a norma — legalmente separato dall\'affitto',
    'total_held': 'Totale trattenuto',
    'active_deposits': 'Depositi attivi',
    'deposits_returned': 'Depositi restituiti',
    'all_tenants_deposit_status': 'Tutti gli inquilini — Stato del deposito',
    'paid_on': 'Pagato il',
    'collect': 'Riscossione',
    'return': 'Restituzione',
    'collect_security_deposit': 'Riscuoti deposito cauzionale',
    'return_security_deposit': 'Restituisci deposito cauzionale',
    'damages_unpaid_rent': 'danni, affitto non pagato, ecc.',
    'optional_notes': 'Note facoltative...',
    'record_collection': 'Registra riscossione',
    'record_return': 'Registra restituzione',
    'deposit_amount_placeholder': 'es. 1500.00',
    'error_loading_utility_data': 'Impossibile caricare i dati delle utenze',
    'utility_account_created': 'Conto utenza creato',
    'reading_recorded_generate_bills': 'Lettura registrata — genera le fatture qui sotto',
    'rubs_complete_msg': 'RUBS completato — {{count}} inquilini fatturati per {{amount_each}} ciascuno (totale {{total}})',
    'no_pending_bills_to_charge': 'Nessuna fattura in sospeso da addebitare',
    'confirm_charge_all_bills': 'Inviare {{count}} fatture in sospeso ai libri mastri degli inquilini?',
    'confirm_charge_all_bills_title': 'Addebita tutte le fatture in sospeso',
    'charge_all_success_msg': '{{count}} fatture inviate ai libri mastri!{{failed_msg}}',
    'generate_bills_btn': 'Genera fatture',
    'generate_from_meters': 'Genera dai contatori',
    'charge_all_btn': 'Addebita tutto ({{count}})',
    'bills_generated_msg': '{{count}} fatture utenze generate',
    'rubs_failed': 'Calcolo RUBS fallito',
    'failed_to_update_account': 'Impossibile aggiornare il conto',
    'utility_management': 'Gestione Utenze',
    'utility_subtitle': 'Monitora contatori, letture e fattura i consumi agli inquilini',
    'add_account': 'Aggiungi conto',
    'utility_accounts': 'Conti Utenze',
    'no_utility_accounts': 'Nessun conto utenza — aggiungine uno per iniziare',
    'provider': 'Fornitore',
    'account_number_label': 'N. conto',
    'meter_number_label': 'N. contatore',
    'utility_bills': 'Fatture Utenze',
    'no_bills_found_msg': 'Nessuna fattura trovata — usa "Genera fatture"',
    'period': 'Periodo',
    'usage': 'Consumo',
    'charge_tenant': 'Addebita inquilino',
    'add_utility_account': 'Aggiungi conto utenza',
    'add_utility_account_subtitle': 'Registra un nuovo contatore o servizio',
    'utility_type': 'Tipo utenza',
    'provider_name': 'Nome fornitore',
    'provider_placeholder': 'es. Enel, Acea',
    'shared_meter': 'Contatore condiviso (copre l\'intero edificio)',
    'add_meter_reading': 'Aggiungi lettura',
    'reading_value': 'Lettura attuale',
    'reading_date': 'Data lettura',
    'record_reading': 'Registra lettura',
    'error_loading_kpi_data': 'Impossibile caricare i dati KPI',
    'snapshot_complete': 'Snapshot completato',
    'snapshot_failed': 'Snapshot fallito',
    'kpi_dashboard': 'Dashboard KPI',
    'kpi_subtitle': 'Performance del portafoglio in tempo reale — occupazione, NOI, cap rate, tasso di riscossione',
    'capturing': 'Acquisizione...',
    'snapshot_now': 'Snapshot ora',
    'occupancy_rate': 'Tasso di occupazione',
    'annual_gross_rent': 'Canone annuo lordo',
    'portfolio_value': 'Valore del portafoglio',
    'total_units': 'Unità totali',
    'units_occupied_msg': '{{occupied}} di {{total}} unità occupate',
    'per_month_suffix': '{{amount}} / mese',
    'equity_label_val': '{{amount}} in capitale',
    'vacant_units_count': '{{count}} vacanti',
    'kpi_step1': 'Cicca su "Snapshot ora" per calcolare le metriche di oggi per tutti gli edifici',
    'kpi_step2': 'Lo snapshot viene eseguito automaticamente ogni notte',
    'kpi_step3': 'Registra le valutazioni immobiliari nella pagina Portafoglio per sbloccare Cap Rate e Rendimento',
    'per_building_metrics': 'Metriche per edificio',
    'no_snapshots_yet': 'Ancora nessuno snapshot — clicca su "Snapshot ora" per generarne uno',
    'collection_rate': 'Riscossione',
    'monthly_noi': 'NOI mensile',
    'cap_rate': 'Cap Rate',
    'gross_yield': 'Rendimento lordo',
    'overdue_tenants': 'In ritardo',
    'investment_summary': 'Riepilogo investimenti',
    'current_value': 'Valore attuale',
    'purchase_cost': 'Costo acquisto',
    'equity': 'Capitale netto',
    'error_loading_portfolio_data': 'Impossibile caricare i dati del portafoglio',
    'valuation_recorded': 'Valutazione registrata',
    'investment_portfolio': 'Portafoglio investimenti',
    'portfolio_subtitle': 'Valutazione portafoglio, capitale, cap rate e rendimento per edificio',
    'record_valuation': 'Registra valutazione',
    'total_portfolio_value': 'Valore del portafoglio',
    'annualized_amount': '{{amount}} annualizzato',
    'avg_cap_rate': 'Cap rate medio',
    'annualized': 'Annualizzato',
    'avg_gross_yield': 'Rendimento lordo medio',
    'gross_rent_on_value': 'Canone lordo / valore',
    'portfolio_step1': 'Clicca su "Registra valutazione" per inserire il valore di mercato attuale di un edificio',
    'portfolio_step2': 'Cap Rate = NOI annuo ÷ Valore immobile × 100',
    'portfolio_step3': 'Rendimento lordo = Canone lordo annuo ÷ Valore immobile × 100',
    'portfolio_step4': 'I dati NOI provengono dalla Dashboard KPI — esegui prima uno snapshot',
    'per_building_breakdown': 'Ripartizione per edificio',
    'no_portfolio_data': 'Nessun dato nel portafoglio — esegui prima uno snapshot KPI, quindi registra le valutazioni',
    'last_valuation': 'Ultima valutazione',
    'occupied_short': 'occ.',
    'no_valuation': 'Nessuna valutazione',
    'update_value': 'Aggiorna valore',
    'record_valuation_subtitle': 'Registra il valore di mercato attuale per un edificio',
    'appraised_value': 'Valore stimato',
    'valuation_date': 'Data',
    'method': 'Metodo',
    'record': 'Registra',
    'error_loading_accounts': 'Impossibile caricare i conti',
    'error_loading_journal_entries': 'Impossibile caricare le scritture di prima nota',
    'error_loading_trial_balance': 'Impossibile caricare il bilancio di verifica',
    'error_loading_pnl': 'Impossibile caricare il conto economico',
    'gl_account_required_fields': 'Codice, nome e tipo sono obbligatori',
    'account_created': 'Conto creato',
    'journal_min_lines_error': 'Sono necessarie almeno 2 righe',
    'entry_out_of_balance_error': 'Scrittura non bilanciata: dare {{debits}} ≠ avere {{credits}}',
    'journal_account_required_error': 'Tutte le righe devono avere un conto selezionato',
    'journal_entry_posted': 'Scrittura registrata',
    'reason_for_reversal_prompt': 'Motivo dello storno:',
    'entry_reversed': 'Scrittura stornata',
    'reversal_failed': 'Storno fallito',
    'chart_of_accounts': 'Piano dei conti',
    'journal_entries': 'Prima nota (Journal Entries)',
    'trial_balance': 'Bilancio di verifica',
    'pnl_statement': 'Conto economico',
    'general_ledger': 'Libro giornale (GL)',
    'gl_subtitle': 'Piano dei conti, prima nota, bilancio di verifica e conto economico',
    'new_gl_account': 'Nuovo conto mastro',
    'normal_balance': 'Saldo normale',
    'no_accounts_found': 'Nessun conto trovato',
    'all_sources': 'Tutte le fonti',
    'new_entry': 'Nuova scrittura',
    'new_journal_entry': 'Nuova scrittura di prima nota',
    'select_account': 'Seleziona conto...',
    'line_description_placeholder': 'Descrizione riga',
    'balanced_msg': '✓ Bilanciato',
    'out_of_balance_amount': 'Sbilancio di {{amount}}',
    'add_line': '+ Aggiungi riga',
    'post_entry': 'Registra scrittura',
    'posting': 'Registrazione in corso...',
    'no_journal_entries_found': 'Nessuna scrittura trovata',
    'reversed': 'Stornato',
    'posted': 'Registrato',
    'draft': 'Bozza',
    'lines_count': '{{count}} righe',
    'as_of_date': 'Alla data del',
    'balanced': 'Bilanciato',
    'out_of_balance': 'Non bilanciato',
    'net': 'Netto',
    'total_revenue': 'Ricavi totali',
    'total_expenses': 'Spese totali',
    'net_income': 'Utile netto',
    'no_revenue_entries': 'Nessuna voce di ricavo',
    'no_expense_entries': 'Nessuna voce di costo',
    'select_date_range_run_msg': 'Seleziona un intervallo di date e clicca su Esegui',
    'asset': 'Attività',
    'liability': 'Passività',
    'revenue': 'Ricavo',
    'expense': 'Costo',
    'market': 'Mercato',
    'income': 'Reddito',
    'cost': 'Costo',
    'broker_opinion': 'Parere del broker',
    'appraisal': 'Perizia',
    'waive_confirm_hint': 'Sconto dell\'indennità di mora per {{name}}. Ciò aggiunge una voce di credito al libro mastro — l\'addebito originale è conservato per l\'audit.',
    'enter_reason_error': 'Inserisci una motivazione',
    'enter_valid_amount_error': 'Inserisci un importo valido',
    'confirm_manual_assess': 'Calcolare manualmente l\'indennità di mora per {{name}}?',
    'search_late_fees': 'Cerca inquilino, unità, edificio...',
    'page_info': 'Pagina {{current}} di {{total}}',

    'reports': 'Report',
    'reports_dashboard': 'Dashboard Report',
    'revenue_report': 'Report Ricavi',
    'payment_logs': 'Registri Pagamenti',
    'occupancy_report': 'Report Occupazione',
    'tenant_payments': 'Pagamenti Inquilini',
    'building_revenue': 'Ricavi Edificio',
    'owner_revenue': 'Ricavi Proprietario',

    'activity_logs': 'Registri Attività',
    'all_activities': 'Tutte le Attività',
    'tenant_activities': 'Attività Inquilini',
    'monthly_revenue': 'Ricavo Mensile',

    'settings': 'Impostazioni',
    'profile_settings': 'Impostazioni Profilo',
    'system_settings': 'Configuración del Sistema',

    'logout': 'Logout',
    'sales': 'Vendite',
    'inspections': 'Ispezioni',
    'maintenance_hub': 'Centro manutenzione',
    'vendors': 'Fornitori',
    'finance': 'Finanza',
    'transactions': 'Transazioni',
    'service_charges': 'Spese di servizio',
    'owner_installments': 'Rate del proprietario',
    'financial_matrix': 'Matrice finanziaria',
    'cash_flow_forecast': 'Previsione a 7 giorni',
    'receivables': 'Crediti',
    'receivables_sub': 'Denaro che ti è dovuto, per anzianità.',
    'no_receivables': 'Nessuno deve nulla.',
    'books_need_attention': 'La contabilità richiede attenzione',
    'books_tie_out': 'I crediti corrispondono alla contabilità generale',
    'ar_gl_drift': 'I crediti non corrispondono alla contabilità generale',
    'unmirrored_charges': 'addebiti',
    'unmirrored_payments': 'pagamenti',
    'not_in_receivables': 'non ancora nei Crediti',
    'closed_periods': 'periodo/i chiuso/i',
    'fix_now': 'Correggi ora',
    'fixing': 'Correzione…',
    'accounting_statement': 'Estratto conto →',
    'statement': 'estratto conto',
    'open_full_record': 'Apri scheda completa →',
    'credit_on_account': 'credito sul conto',
    'opening_balance': 'Saldo iniziale',
    'closing_balance': 'Saldo finale',
    'no_activity': 'Nessuna attività in questo periodo.',
    'charge': 'Addebito',
    'kind_rent': 'Affitto',
    'kind_service': 'Costo servizio',
    'kind_late_fee': 'Mora',
    'kind_utility': 'Utenze',
    'kind_parking': 'Parcheggio',
    'kind_deposit': 'Cauzione',
    'kind_sale_installment': 'Rata di vendita',
    'kind_management_fee': 'Commissione di gestione',
    'kind_maintenance_fee': 'Costo manutenzione',
    'kind_payment': 'Pagamento',
    'ledger_activity_report': 'Attività del libro mastro',
    'management_fee_report': 'Commissioni di gestione',
    'messages': 'Messaggi',
    'announcements_manager': 'Gestore annunci',
    'all_announcements': 'Tutti gli annunci',
    'subscription': 'Abbonamento',
    'contract_templates': 'Modelli di contratto',
    'whatsapp_and_sms': 'WhatsApp & SMS',
    'late_fees_org_config': 'Indennità di mora & Config Org',
    'building_amenities': 'Servizi dell\'edificio',
    'parking_spaces': 'Posti auto',
    'amenity_bookings': 'Prenotazioni servizi',
    'pm_schedules': 'Orari PM',
    'work_orders': 'Ordini di lavoro',
    'security_deposits': 'Depositi cauzionali',
    'expenses': 'Spese',
    'late_fees': 'Indennità di mora',
    'bulk_owner_payout': 'Pagamento collettivo ai proprietari',
    'utilities': 'Utenze',
    'kpi_dashboard': 'Cruscotto KPI',
    'portfolio': 'Portafoglio',
    'general_ledger': 'Libro mastro generale',
    'reports_1099': 'Rapporti 1099',
    'notification_log': 'Registro notifiche',
    'all_messages': 'Tutti i messaggi',
    'notification_log': 'Registro notifiche',

    // AI Intelligence & Sidebar
    'ai_intelligence': 'Intelligenza Artificiale',
    'rent_pricing_ai': 'Prezzi Affitto IA',
    'churn_prediction': 'Predizione Abbandono',
    'showings': 'Visite',
    'tenant_surveys': 'Sondaggi Inquilini',
    'insurance': 'Assicurazione',
    'vendor_1099': 'Fornitore 1099',
    'rent_roll': 'Registro Affitti',
    'ar_aging': 'Scadenzario Crediti',
    'webhooks': 'Webhooks',

    // AI Rent Pricing Page
    'ai_rent_pricing': 'Prezzi Affitto IA',
    'ai_rent_pricing_desc': 'Ottieni suggerimenti sui prezzi di affitto basati sull\'IA in base ai tuoi comparabili di portafoglio, occupazione e tendenze di rinnovo',
    'select_unit_to_analyze': 'Seleziona unità da analizzare',
    'choose_an_apartment': 'Scegli un appartamento...',
    'analyze': 'Analizza',
    'analyzing': 'Analisi in corso...',
    'ai_recommended_rent': 'Affitto Raccomandato dall\'IA',
    'range': 'Intervallo',
    'high_confidence': 'Alta',
    'medium_confidence': 'Media',
    'low_confidence': 'Bassa',
    'confidence_suffix': 'fiducia',
    'comparable_units_found': 'Unità Comparabili ({{count}} trovate)',
    'avg_comparable_rent': 'Media: {{amount}}/mese',
    'vs_suggestion': 'vs suggerimento',
    'select_unit_analyze_desc': 'Seleziona un\'unità e clicca su Analizza',
    'claude_analyze_desc': 'L\'IA analizzerà i comparabili, l\'occupazione e le tendenze per suggerire l\'affitto ottimale',

    // Churn Prediction Page
    'churn_prediction_desc': 'Probabilità di rinnovo tramite IA per tutti gli inquilini attivi',
    'run_ai_scoring': 'Esegui Scoring IA',
    'running': 'In corso...',
    'high_churn_risk': 'Alto Rischio Abbandono',
    'medium_risk': 'Rischio Medio',
    'likely_to_renew': 'Probabile Rinnovo',
    'no_churn_scores': 'Nessun score di abbandono ancora disponibile',
    'run_scoring_desc': 'Clicca su "Esegui Scoring IA" per analizzare tutti gli inquilini attivi',
    'run_scoring_now': 'Esegui Scoring Ora',
    'renewal_score': 'Score Rinnovo',
    'risk_level': 'Livello di Rischio',
    'lease_ends': 'Fine Locazione',
    'key_factors': 'Fattori Chiave',
    'send_offer': 'Invia Offerta',
    'late_payments_6m': '{{count}} pagamenti in ritardo',
    'current_balance_factor': 'Saldo di ${{amount}}',
    'prior_renewals_factor': '{{count}} rinnovi precedenti',

    // Showings Page
    'showings_desc': 'Pianifica e monitora le visite agli immobili per i potenziali inquilini',
    'schedule_showing': 'Pianifica Visita',
    'upcoming': 'In Arrivo',
    'today': 'Oggi',
    'no_shows': 'Assenze',
    'all': 'Tutti',
    'no_showings_found': 'Nessuna visita trovata',
    'schedule_first_showing': 'Pianifica Prima Visita',
    'prospect': 'Potenziale Inquilino',
    'unit': 'Unità',
    'date_and_time': 'Data e Ora',
    'scheduled': 'Pianificato',
    'completed': 'Completato',
    'cancelled': 'Annullato',
    'no_show': 'Assenza',
    'edit_showing': 'Modifica Visita',
    'prospect_name': 'Nome Potenziale Inquilino',
    'prospect_phone': 'Telefono',
    'prospect_email': 'Email',
    'start_time': 'Ora Inizio',
    'end_time': 'Ora Fine',
    'assigned_to': 'Assegnato a',
    'notes': 'Note',

    // Insurance Page
    'insurance_tracking': 'Monitoraggio Assicurazioni',
    'insurance_desc': 'Gestisci le polizze assicurative per inquilini, proprietari e edifici',
    'add_policy': 'Aggiungi Polizza',
    'expiring_30d': 'Scade in 30g',
    'total_coverage': 'Copertura Totale',
    'all_status': 'Tutti gli Stati',
    'all_types': 'Tutti i Tipi',
    'no_policies_found': 'Nessuna polizza trovata',
    'add_first_policy': 'Aggiungi Prima Polizza',
    'entity': 'Entità',
    'insurer': 'Assicuratore',
    'policy_type': 'Tipo di Polizza',
    'coverage': 'Copertura',
    'expiry': 'Scadenza',
    'expired_days_ago': 'Scaduto {{days}}g fa',
    'days_left': '{{days}}g rimasti',
    'edit_policy': 'Modifica Polizza',
    'entity_type': 'Tipo Entità',
    'policy_number': 'Numero Polizza',
    'coverage_amount': 'Importo Copertura',
    'annual_premium': 'Premio Annuale',
    'start_date': 'Data Inizio',
    'expiry_date': 'Data Scadenza',
    'document_url': 'URL Documento (Link COI)',

    // Survey Results Page
    'tenant_surveys_desc': 'Valutazioni CSAT e feedback degli inquilini',
    'overall_rating': 'Valutazione Globale',
    'distribution': 'Distribuzione',
    'by_category': 'Per Categoria',
    'no_surveys_yet': 'Nessun sondaggio ancora disponibile',
    'tenants_submit_feedback_desc': 'Gli inquilini possono inviare feedback tramite il loro portale',

    // Financial Matrix
    'financial_matrix_subtitle': 'Vista unificata di tutta l\'attività finanziaria in ogni unità',
    'total_charged': 'Totale addebitato',
    'total_collected': 'Totale riscosso',
    'overdue_balance': 'Saldo scaduto',
    'partial_balance': 'Saldo parziale',
    'all_floors': 'Tutti i piani',
    'floor_label': 'Piano',
    'legend_paid': 'Pagato',
    'legend_partial': 'Parziale',
    'legend_overdue': 'Scaduto',
    'legend_upcoming': 'In arrivo',
    'legend_no_charges': 'Nessun addebito',
    'table_unit': 'Unità',
    'table_now': 'ora',
    'no_apartments_found_building': 'Nessun appartamento trovato per questo edificio.',
    'view_all': 'Tutti',
    'view_rent': 'Affitto',
    'view_service': 'Servizio',
    'view_sales': 'Vendite',

    // Cash Flow Forecast
    'cash_flow_subtitle': 'Prossimi pagamenti previsti da inquilini e proprietari',
    'expected_this_period': 'Previsto in questo periodo',
    'total_overdue_balance': 'Saldo totale scaduto',
    'collected_today': 'Riscosso oggi',
    'no_upcoming_payments': 'Nessun pagamento in arrivo in questo periodo.',
    'today': 'Oggi',
    'overdue_label': 'SCADUTO',
    'expected_label': 'previsto',

    // Quick Pay
    'quick_pay': 'Pagamento rapido',
    'recording': 'Registrazione...',
    'record_payment_btn': 'Registra pagamento di {{amount}}',
    'no_active_tenant_error': 'Nessun inquilino attivo — il pagamento non può essere registrato qui.',
    'view_full_ledger': 'Visualizza il libro mastro completo per {{name}}',
    'full_payment_form': 'Modulo di pagamento completo',
    'enter_valid_amount': 'Inserisci un importo valido',
    'no_active_tenant_found': 'Nessun inquilino attivo trovato per questa unità',
    'payment_recorded_success': 'Pagamento registrato con successo',
    'treasury_quick_pay': 'Pagamento Rapido Tesoreria',
    'payment_amount': 'Importo del pagamento',
    'memo': 'Memo / Riferimento',
    'add_a_note_about_this_treasury_event': 'Aggiungi una nota su questo evento...',
    'view_owner_file_and_distribution': 'Visualizza file proprietario',
    'view_resident_ledger': 'Visualizza registro residente',
    'processing': 'In elaborazione...',
    'confirm_and_record': 'Conferma e registra',
    'no_entity_found': 'Nessun inquilino o proprietario trovato per questa unità',
    'owner_view': 'Proprietario',
    'tenant_view': 'Inquilino',
    'search_owner_unit_building': 'Cerca proprietario, unità, edificio...',
    'showing_all_installments': 'Mostrando tutte le {{count}} rate',
    'showing_overdue_within_days': 'Mostrando in ritardo + in scadenza entro {{days}} giorni · {{hidden}} rate future nascoste',
    'hide_future_count': 'Nascondi futuri ({{count}})',
    'show_all_future_count': 'Mostra tutti i futuri ({{count}})',
    'no_overdue_upcoming_all_clear': 'Nessun pagamento in ritardo o in arrivo — tutto in ordine!',
    'no_records_match_search': 'Nessun record corrisponde alla tua ricerca.',

    // Months Short
    'jan_short': 'Gen', 'feb_short': 'Feb', 'mar_short': 'Mar', 'apr_short': 'Apr', 'may_short': 'Mag', 'jun_short': 'Giu',
    'jul_short': 'Lug', 'aug_short': 'Ago', 'sep_short': 'Set', 'oct_short': 'Ott', 'nov_short': 'Nov', 'dec_short': 'Dic',

    // Months Full
    'january': 'Gennaio', 'february': 'Febbraio', 'march': 'Marzo', 'april': 'Aprile', 'may': 'Maggio', 'june': 'Giugno',
    'july': 'Luglio', 'august': 'Agosto', 'september': 'Settembre', 'october': 'Ottobre', 'november': 'Novembre', 'december': 'Dicembre',

    // AI Assistant
    'ai_assistant': 'Assistente IA',
    'ask_ai': 'Chiedi all\'IA',
    'ai_greeting': "Ciao! Sono il tuo analista finanziario IA. Come posso aiutarti oggi?",
    'ai_error': "Scusa, non ho potuto elaborarlo. Riprova.",
    'analyzing_data': 'Analisi dei dati...',
    'ai_placeholder': 'Cosa vorresti sapere?',
    'overdue_tenants_q': 'Quali inquilini sono in ritardo?',
    'revenue_30d_q': 'Entrate degli ultimi 30 giorni?',
    'expenses_month_q': 'Spese di questo mese?',
    'utility_pending_q': 'Bollette in sospeso?',
    'kpi_noi_summary_q': 'Riepilogo KPI & NOI?',
    'security_deposits_q': 'Depositi cauzionali detenuti?',
    'late_fees_q': 'Indennità di mora addebitate?',
    'owner_payouts_q': 'Pagamenti ai proprietari questo mese?',


    // Apartment Detail View
    'loading_apartment_details': 'Cargando detalles del apartamento...',
    'error_loading_apartment': 'Error al cargar detalles del apartamento',
    'try_again': 'Intentar de Nuevo',
    'back_to_apartments': 'Volver a Apartamentos',
    'apartment_not_found': 'Apartamento No Encontrado',
    'apartment_not_found_message': 'El apartamento que buscas no existe o ha sido eliminado.',

    'building_and_location': 'Edificio y Ubicación',
    'building': 'Edificio',
    'floor': 'Piso',
    'address': 'Dirección',

    'apartment_details': 'Detalles del Apartamento',
    'apartment_type': 'Tipo',
    'size': 'Tamaño',
    'furnished': 'Amueblado',

    'owner_information': 'Información del Propietario',
    'owner_name': 'Nombre',
    'owner_contact': 'Contacto',

    'additional_information': 'Información Adicional',
    'created_at': 'Creado El',
    'updated_at': 'Última Actualización',

    'status_management': 'Gestión de Estado',
    'status_vacant': 'Vacante',
    'status_occupied': 'Ocupado',
    'status_maintenance': 'En Mantenimiento',
    'status_vacant_description': 'Disponible para alquilar o arrendar',
    'status_occupied_description': 'Actualmente alquilado a un inquilino',
    'status_maintenance_description': 'En mantenimiento o renovación',
    'change_status': 'Cambiar Estado A',

    'quick_actions': 'Acciones Rápidas',
    'create_lease': 'Crear Contrato',
    'view_tenant_info': 'Ver Info del Inquilino',
    'mark_maintenance_complete': 'Marcar Mantenimiento Completado',
    'view_building': 'Ver Edificio',
    'edit_apartment': 'Editar Apartamento',

    'same_building_apartments': 'Mismo Edificio',
    'view_all_apartments_in_building': 'Ver Todos los Apartamentos en el Edificio',
    'view_vacant_apartments': 'Ver Apartamentos Vacantes',

    // Delete confirmation
    'delete_apartment_confirmation': '¿Estás seguro de que deseas eliminar el apartamento "{{name}}"? Esta acción no se puede deshacer.',

    // Apartment Form
    'loading_apartment_data': 'Cargando datos del apartamento...',
    'edit_apartment': 'Editar Apartamento',
    'add_new_apartment': 'Añadir Nuevo Apartamento',

    'basic_information': 'Información Básica',
    'apartment_number': 'Número de Apartamento',
    'enter_apartment_number': 'Ingresa el número de apartamento',
    'floor_number': 'Número de Piso',
    'enter_floor_number': 'Ingresa el número de piso',
    'size_sqm': 'Tamaño (m²)',
    'enter_size': 'Ingresa el tamaño en metros cuadrados',
    'apartment_type': 'Tipo de Apartamento',
    'select_apartment_type': 'Selecciona el tipo de apartamento',
    'select_building': 'Selecciona edificio',
    'furnished': 'Amueblado',

    // Validation messages
    'floor_required': 'El piso es requerido',
    'apartment_number_required': 'El número de apartamento es requerido',
    'size_required': 'El tamaño es requerido',
    'type_required': 'El tipo es requerido',
    'building_required': 'El edificio es requerido',
    'invalid_size': 'El tamaño debe ser mayor que 0',

    // Form actions
    'update': 'Actualizar',
    'save': 'Guardar',
    'saving': 'Guardando...',


    // Apartment List
    'apartments': 'Apartamentos',
    'search_apartments': 'Buscar apartamentos...',
    'filter': 'Filtrar',
    'grid_view': 'Cuadrícula',
    'list_view': 'Lista',
    'add_apartment': 'Añadir Apartamento',
    'all_buildings': 'Todos los Edificios',
    'all_types': 'Todos los Tipos',
    'all_statuses': 'Todos los Estados',
    'all': 'Todo',
    'vacant_apartments': 'Apartamentos Vacantes',
    'occupied_apartments': 'Apartamentos Ocupados',
    'maintenance_apartments': 'En Mantenimiento',
    'loading_apartments': 'Cargando apartamentos...',
    'error_loading_apartments': 'Error al cargar apartamentos',
    'no_apartments_found': 'No se encontraron apartamentos',
    'no_apartments_message': 'Aún no hay apartamentos en el sistema.',
    'create_first_apartment': 'Crear el Primer Apartamento',
    'showing_filtered_results': 'Mostrando {{showing}} de {{total}} apartamentos',

    // Statuses
    'vacant': 'Vacante',
    'occupied': 'Ocupado',
    'maintenance': 'En Mantenimiento',

    // Apartment card
    'furnished': 'Amueblado',

    // Delete confirmation
    'delete_apartment_confirmation': '¿Estás seguro de que deseas eliminar el apartamento "{{name}}"? Esta acción no se puede deshacer.',
    'deleting': 'Eliminando...',


    // Bulk Apartment Creator
    'bulk_apartment_creation': 'Creación Masiva de Apartamentos',
    'preview': 'Previsualizar',
    'apartment_number_format': 'Formato del Número de Apartamento',
    'format_pattern': 'Patrón de Formato',
    'format_pattern_help': 'Usa {floor} para número de piso y {unit} para número de unidad. Ejemplo: {floor}{unit} = 0201',
    'preview_example': 'Ejemplo de Previsualización',
    'floor_plans': 'Planos de Planta',
    'add_floor_plan': 'Añadir Plano de Planta',
    'floor_plan_number': 'Plano de Planta {number}',
    'floors_comma_separated': 'Pisos (separados por coma)',
    'unit_types': 'Tipos de Unidad',
    'add_unit_type': 'Añadir Tipo de Unidad',
    'unit_type_number': 'Tipo de Unidad {number}',
    'name': 'Nombre',
    'quantity': 'Cantidad',
    'type': 'Tipo',
    'area_sqm': 'Área (m²)',
    'furnished': 'Amueblado',
    'apartment_preview_count': 'Previsualización de Apartamentos ({count} unidades)',
    'floor_unit_type': 'Piso {floor} • {type}',
    'close': 'Cerrar',
    'create_apartments': 'Crear Apartamentos',
    'create_apartments_count': 'Crear {count} Apartamentos',
    'creating_apartments': 'Creando Apartamentos...',
    'add_at_least_one_floor_plan': 'Por favor añade al menos un plano de planta',
    'no_apartments_to_create': 'No hay apartamentos para crear',


    'building_name_required': 'El nombre del edificio es requerido',
    'building_address_required': 'La dirección del edificio es requerida',
    'invalid_floors': 'El total de pisos debe ser al menos 1',
    'invalid_apartments': 'El total de apartamentos debe ser al menos 0',
    'loading_building_data': 'Cargando datos del edificio...',
    'edit_building': 'Editar Edificio',
    'add_new_building': 'Añadir Nuevo Edificio',
    'basic_information': 'Información Básica',
    'building_name': 'Nombre del Edificio',
    'enter_building_name': 'Ingresa el nombre del edificio',
    'total_floors': 'Total de Pisos',
    'number_of_floors': 'Número de pisos',
    'total_apartments': 'Total de Apartamentos',
    'number_of_apartments': 'Número de apartamentos',
    'address': 'Dirección',
    'enter_complete_building_address': 'Ingresa la dirección completa del edificio',
    'cancel': 'Cancelar',
    'saving': 'Guardando...',
    'update': 'Actualizar',
    'save': 'Guardar',


    'buildings': 'Edificios',
    'search_buildings': 'Buscar edificios...',
    'bulk_add_apartments': 'Añadir Apartamentos Masivamente',
    'add_building': 'Añadir Edificio',
    'loading_buildings': 'Cargando edificios...',
    'error_loading_buildings': 'Error al Cargar Edificios',
    'try_again': 'Intentar de Nuevo',
    'no_buildings_found': 'No se encontraron edificios',
    'no_buildings_yet': 'Sin Edificios Todavía',
    'no_buildings_match_search': 'Ningún edificio coincide con "{{search}}"',
    'no_buildings_message': 'Aún no hay edificios en el sistema. Añade tu primer edificio para empezar.',
    'create_first_building': 'Crear el Primer Edificio',
    'showing_filtered_results': 'Mostrando {{showing}} de {{total}} edificios',
    'floors': 'Pisos',
    'apartments': 'Apartamentos',
    'occupancy': 'Ocupación',
    'vacant': 'Vacante',
    'occupied': 'Ocupado',
    'no_apartments_yet': 'Aún no hay apartamentos',
    'add_apartments': '+ Añadir Apartamentos',
    'confirm_deletion': 'Confirmar Eliminación',
    'delete_building_confirmation': '¿Estás seguro de que deseas eliminar el edificio "{{name}}"? Esta acción no se puede deshacer.',
    'cancel': 'Cancelar',
    'deleting': 'Eliminando...',
    'delete': 'Eliminar',
    'create_building_first': 'Por favor crea un edificio primero',
    'create': 'Crear Apartamentos',
    'unnamed_building': 'Edificio sin Nombre',
    'no_address_provided': 'No se proporcionó dirección',

    'select_building_for_bulk_creation': 'Selecciona Edificio para Creación Masiva de Apartamentos',

    'loading_building_details': 'Cargando detalles del edificio...',
    'error_loading_building': 'Error al cargar edificio',
    'try_again': 'Intentar de Nuevo',
    'back_to_buildings': 'Volver a Edificios',
    'building_not_found': 'Edificio No Encontrado',
    'building_not_found_message': 'El edificio que buscas no existe o ha sido eliminado.',
    'add_apartment': 'Añadir Apartamento',
    'edit_building': 'Editar Edificio',
    'generate_reports': 'Generar Informes',
    'total_apartments': 'Total de Apartamentos',
    'units': 'unidades',
    'across_floors': 'En {{floors}} pisos',
    'vacant_apartments': 'Vacante',
    'available_for_rent': 'Disponible para alquilar',
    'no_vacancies': 'Sin vacantes',
    'occupancy_rate': 'Tasa de Ocupación',
    'occupied_units': 'unidades ocupadas',
    'maintenance_apartments': 'Mantenimiento',
    'needs_attention': 'Necesita atención',
    'average_apartment_size': 'Tamaño Promedio',
    'furnished_apartments': 'Amueblado',
    'utility_status': 'Estado de Servicios Públicos',
    'water': 'Agua',
    'electricity': 'Electricidad',
    'internet': 'Internet',
    'hide_details': 'Ocultar Detalles',
    'show_details': 'Mostrar Detalles',
    'search_apartments': 'Buscar apartamentos, propietarios, inquilinos...',
    'all_statuses': 'Todos los Estados',
    'vacant': 'Vacante',
    'occupied': 'Ocupado',
    'maintenance': 'Mantenimiento',
    'top_floor_first': 'Piso Superior Primero',
    'ground_floor_first': 'Planta Baja Primera',
    'showing_results': 'Mostrando {{count}} de {{total}} apartamentos',
    'matching': 'coincidentes',
    'with_status': 'con estado',
    'no_apartments_found': 'No se encontraron apartamentos',
    'no_apartments_match_filters': 'No hay apartamentos que coincidan con tus filtros actuales.',
    'clear_filters': 'Limpiar Filtros',
    'floor_number': 'Piso {{number}}',
    'apartments': 'apartamentos',
    'owner': 'Propietario',
    'status': 'Estado',
    'vacant_status': 'Disponible',
    'maintenance_status': 'En Mantenimiento',
    'furnished': 'Amueblado',
    'unfurnished': 'Sin amueblar',
    'no_matching_apartments_on_floor': 'No hay apartamentos en el piso {{floor}} que coincidan con tus filtros actuales.',
    'construction_year': 'Año de Construcción: {{year}}',

    'activity_logs': 'Registros de Actividad',
    'track_all_system_activities': 'Rastrea todas las actividades y cambios del sistema',
    'filter': 'Filtrar',
    'export_to_excel': 'Exportar a Excel',
    'exporting': 'Exportando...',
    'filter_logs': 'Filtrar Registros',
    'action_type': 'Tipo de Acción',
    'all_actions': 'Todas las Acciones',
    'entity_type': 'Tipo de Entidad',
    'all_entities': 'Todas las Entidades',
    'entries_per_page': 'Entradas por Página',
    'start_date': 'Fecha de Inicio',
    'end_date': 'Fecha de Fin',
    'reset': 'Restablecer',
    'apply_filter': 'Aplicar Filtro',
    'previous': 'Anterior',
    'next': 'Siguiente',
    'tenant_activity_logs': 'Registros de Actividad de Inquilinos',
    'payment_activity_logs': 'Registros de Actividad de Pagos',
    'building_activity_logs': 'Registros de Actividad de Edificios',
    'apartment_activity_logs': 'Registros de Actividad de Apartamentos',
    'owner_activity_logs': 'Registros de Actividad de Propietarios',
    'user_activity_logs': 'Registros de Actividad de Usuarios',
    'system_activity_logs': 'Registros de Actividad del Sistema',

    'monthly_revenue_by_user': 'Ingresos Mensuales por Usuario',
    'export_to_excel': 'Exportar a Excel',
    'exporting': 'Exportando...',
    'total_revenue': 'Ingresos Totales',
    'total_payments': 'Total de Pagos',
    'recorded_by': 'Registrado por',
    'average_payment': 'Pago Promedio',
    'per_transaction': 'Por transacción',
    'revenue_by_user': 'Ingresos por Usuario',
    'no_revenue_data': 'Sin Datos de Ingresos',
    'no_revenue_data_message': 'No se encontraron registros de pago para {{month}} {{year}}. Intenta seleccionar un mes o año diferente.',


    'loading_owner_data': 'Cargando datos del propietario...',
    'error_loading_owner': 'Error al cargar propietario',
    'back_to_owners': 'Volver a Propietarios',
    'send_reminder': 'Enviar Recordatorio',
    'edit': 'Editar',
    'overview': 'Resumen',
    'properties': 'Apartamentos',
    'payments': 'Pagos',
    'contracts': 'Contratos',
    'outstanding': 'Pendiente',
    'financial_overview': 'Resumen Financiero',
    'portfolio_summary': 'Resumen de Cartera',
    'financial_ledger': 'Libro Mayor Financiero',
    'no_installments': 'No se encontraron pagos a plazos en tu libro mayor.',
    'total_outstanding': 'Total Pendiente',
    'management_agreement': 'Acuerdo de Gestión',
    'my_agreements': 'Mis Acuerdos',
    'active_agreements': 'Acuerdos Activos',
    'no_active_agreements': 'Sin Acuerdos Activos',
    'remaining': 'Restante',
    'total_value': 'Valor Total',
    'contact_information': 'Información de Contacto',
    'property_overview': 'Resumen de Propiedad',
    'add_apartment': 'Añadir Apartamento',
    'no_properties': 'Sin Apartamentos',
    'no_properties_message': 'Este propietario no tiene apartamentos aún.',
    'add_first_property': 'Añadir el Primer Apartamento',
    'view_details': 'Ver Detalles',
    'payment_history': 'Historial de Pagos',
    'no_payments': 'Sin Pagos',
    'no_payments_message': 'No se han registrado pagos aún.',
    'outstanding_fees': 'Cuotas Pendientes',
    'no_outstanding_fees': 'Sin Cuotas Pendientes',
    'all_fees_paid': 'Todas las cuotas están al día.',
    'total_outstanding': 'Total Pendiente',
    'add_payment': 'Añadir Pago',
    'property': 'Apartamento',
    'select_property': 'Seleccionar Apartamento',
    'amount': 'Monto',
    'payment_date': 'Fecha de Pago',
    'payment_method': 'Método de Pago',
    'cash': 'Efectivo',
    'bank_transfer': 'Transferencia Bancaria',
    'check': 'Cheque',
    'credit_card': 'Tarjeta de Crédito',
    'online_payment': 'Pago en Línea',
    'reference_number': 'Número de Referencia',
    'notes': 'Notas',
    'cancel': 'Cancelar',

    'owner_information': 'Información del Propietario',
    'name': 'Nombre',
    'phone': 'Teléfono',
    'owner_lives_property': 'El propietario vive en la propiedad',
    'select_apartments': 'Seleccionar Apartamentos',
    'available_apartments': 'apartamentos disponibles',
    'no_apartments_available': 'No hay apartamentos disponibles. Todos los apartamentos ya tienen propietarios.',
    'apartment_number': 'Apartamento {{number}}',
    'floor': 'Piso',
    'size': 'Tamaño',
    'type': 'Tipo',
    'status': 'Estado',
    'cancel': 'Cancelar',
    'saving': 'Guardando...',
    'update_owner': 'Actualizar Propietario',
    'create_owner': 'Crear Propietario',
    'edit_property_owner': 'Editar Propietario de Propiedad',
    'add_property_owner': 'Añadir Propietario de Propiedad',

    'property_owners': 'Propietarios',
    'add_owner': 'Añadir Propietario',
    'search_owners': 'Buscar propietarios...',
    'filter': 'Filtrar',
    'list_view': 'Lista',
    'grid_view': 'Cuadrícula',
    'export': 'Exportar',
    'exporting': 'Exportando...',

    // Owner Contracts & Installments - NEW
    'owner_contracts': 'Contratos de Propietarios',
    'contracts': 'Contratos',
    'add_contract': 'Añadir Contrato',
    'contract_details': 'Detalles del Contrato',
    'installments': 'Plazos',
    'installment_details': 'Detalles del Plazo',
    'pay_now': 'Pagar Ahora',
    'contract_type': 'Tipo de Contrato',
    'purchase_agreement': 'Acuerdo de Compra',
    'service_agreement': 'Acuerdo de Servicio',
    'next_installment': 'Próximo Plazo',
    'outstanding_balance': 'Saldo Pendiente',
    'total_contract_value': 'Valor Total del Contrato',
    'installment_plan': 'Plan de Pagos a Plazos',
    'payment_successful': '¡Pago exitoso! Tus registros se actualizarán en breve.',
    'payment_canceled': 'El pago fue cancelado.',
    'redirecting_to_payment': 'Redirigiendo a pago seguro...',
    'no_contracts_found': 'No se encontraron contratos.',
    'no_installments_found': 'No se encontraron plazos.',

    'living_status': 'Estado de Residencia',
    'all': 'Todos',
    'living_on_property': 'Viviendo en la Propiedad',
    'not_living_on_property': 'No Viviendo en la Propiedad',
    'country': 'País',
    'all_countries': 'Todos los Países',
    'apartment_status': 'Estado del Apartamento',
    'all_statuses': 'Todos los Estados',
    'with_vacant': 'Con Apartamentos Vacantes',
    'fully_occupied': 'Totalmente Ocupado',
    'with_maintenance': 'Con Mantenimiento',
    'min_apartments': 'Mín. Apartamentos',
    'max_apartments': 'Máx. Apartamentos',
    'min_occupancy_rate': 'Tasa de Ocupación Mín. (%)',
    'clear_filters': 'Limpiar Filtros',
    'apply_filters': 'Aplicar Filtros',
    'total_owners': 'Total de Propietarios',
    'resident_owners': 'Propietarios Residentes',
    'with_apartments': 'Con Apartamentos',
    'without_apartments': 'Sin Apartamentos',
    'loading_owners': 'Cargando propietarios...',
    'error_loading_owners': 'Error al cargar propietarios',
    'try_again': 'Intentar de Nuevo',
    'no_owners_found': 'No Se Encontraron Propietarios',
    'no_owners_message': 'Aún no hay propietarios en el sistema. Haz clic en el botón \'Añadir Propietario\' para crear tu primer propietario.',
    'create_first_owner': 'Crear Primer Propietario',
    'showing_filtered_results': 'Mostrando {showing} de {total} propietarios',
    'confirm_deletion': 'Confirmar Eliminación',
    'delete_owner_confirmation': '¿Estás seguro de que deseas eliminar al propietario "{name}"? Esta acción no se puede deshacer.',
    'cancel': 'Cancelar',
    'delete': 'Eliminar',
    'deleting': 'Eliminando...',

    'resident_owner': 'Propietario Residente',
    'apartments_count': 'Cantidad de Apartamentos',
    'show_apartments': 'Mostrar Apartamentos',
    'hide_apartments': 'Ocultar Apartamentos',
    'size_unit_sqm': 'Tamaño de unidad en metros cuadrados',

    "loading": "Cargando...",
    "edit_property_owner": "Editar Propietario de Propiedad",
    "add_property_owner": "Añadir Propietario de Propiedad",
    "owner_information": "Información del Propietario",
    "name": "Nombre",
    "phone": "Teléfono",
    "owner_lives_on_property": "El propietario vive en la propiedad",
    "select_apartments": "Seleccionar Apartamentos ({{count}})",
    "available_apartments": "{{count}} apartamentos disponibles",
    "no_apartments_available": "No hay apartamentos disponibles. Todos los apartamentos ya tienen propietarios.",
    "floor": "Piso",
    "size": "Tamaño",
    "size_unit_sqm": "m²",
    "type": "Tipo",
    "status": "Estado",
    "cancel": "Cancelar",
    "saving": "Guardando...",
    "update_owner": "Actualizar Propietario",
    "create_owner": "Crear Propietario",
    "failed_to_load_data": "Error al cargar datos",
    "failed_to_save_owner": "Error al guardar el propietario",


    "activity_logs": "Registros de Actividad",
    "tenant_activity_logs": "Registros de Actividad de Inquilinos",
    "payment_activity_logs": "Registros de Actividad de Pagos",
    "building_activity_logs": "Registros de Actividad de Edificios",
    "apartment_activity_logs": "Registros de Actividad de Apartamentos",
    "owner_activity_logs": "Registros de Actividad de Propietarios",
    "user_activity_logs": "Registros de Actividad de Usuarios",
    "system_activity_logs": "Registros de Actividad del Sistema",
    "track_all_system_activities": "Rastrea todas las actividades y cambios del sistema",
    "filter": "Filtrar",
    "export_to_excel": "Exportar a Excel",
    "exporting": "Exportando...",
    "search_logs_placeholder": "Buscar registros por nombre, usuario o detalles...",
    "showing_entries": "Mostrando {{showing}} de {{total}} entradas",
    "filter_logs": "Filtrar Registros",
    "action_type": "Tipo de Acción",
    "all_actions": "Todas las Acciones",
    "entity_type": "Tipo de Entidad",
    "all_entities": "Todas las Entidades",
    "entries_per_page": "Entradas Por Página",
    "start_date": "Fecha de Inicio",
    "end_date": "Fecha de Fin",
    "reset": "Restablecer",
    "apply_filter": "Aplicar Filtro",
    "time": "Hora",
    "user": "Usuario",
    "action": "Acción",
    "entity": "Entidad",
    "details": "Detalles",
    "view": "Ver",
    "system": "Sistema",
    "view_entity_details": "Ver detalles de {{type}}",
    "no_logs_matching_search": "No hay registros de actividad que coincidan con tu búsqueda",
    "no_logs_for_filters": "No se encontraron registros de actividad para los filtros seleccionados",
    "showing_range": "Mostrando {{start}} a {{end}} de {{total}} entradas",
    "previous": "Anterior",
    "next": "Siguiente",
    "failed_to_load_logs": "Error al cargar registros de actividad",
    "failed_to_export_logs": "Error al exportar registros a Excel",

    "tenant": "Inquilino",
    "payment": "Pago",
    "building": "Edificio",
    "apartment": "Apartamento",
    "owner": "Propietario",
    "user": "Usuario",
    "system": "Sistema",

    "created": "Creado",
    "updated": "Actualizado",
    "deleted": "Eliminado",
    "viewed": "Visto",
    "login": "Inicio de Sesión",
    "logout": "Cierre de Sesión",
    "payment_made": "Pago Realizado",
    "payment_received": "Pago Recibido",
    "status_changed": "Estado Cambiado",
    "approved": "Aprobado",
    "rejected": "Rechazado",
    "maintenance_request": "Solicitud de Mantenimiento",
    "maintenance_completed": "Mantenimiento Completado",

    "loading_payment_data": "Cargando datos de pago...",
    "error_loading_payment": "Error al Cargar Pago",
    "payment_not_found": "Pago no encontrado",
    "back_to_payments": "Volver a Pagos",
    "confirm_deletion": "Confirmar Eliminación",
    "delete_payment_confirmation": "¿Estás seguro de que deseas eliminar este pago de {{amount}}? Esta acción no se puede deshacer.",
    "cancel": "Cancelar",
    "deleting": "Eliminando...",
    "delete": "Eliminar",
    "print_receipt": "Imprimir Recibo",
    "edit": "Editar",
    "tenant": "Inquilino",
    "unknown_tenant": "Inquilino Desconocido",
    "apartment": "Apartamento",
    "apt": "Apt",
    "none": "Ninguno",
    "payment_period": "Período de Pago",
    "payment_details": "Detalles del Pago",
    "tenant_information": "Información del Inquilino",
    "payment_information": "Información del Pago",
    "amount": "Monto",
    "payment_date": "Fecha de Pago",
    "payment_type": "Tipo de Pago",
    "created": "Creado",
    "last_updated": "Última Actualización",
    "notes": "Notas",
    "view_tenant": "Ver Inquilino",
    "unknown_period": "Período desconocido",
    "to": "a",
    "invalid_period_data": "Datos de período no válidos",
    "unknown_type": "Tipo Desconocido",
    "unknown": "Desconocido",
    "failed_to_load_payment_data": "Error al cargar los datos de pago",
    "failed_to_delete_payment": "Error al eliminar el pago",

    "rent": "Alquiler",
    "service": "Cuota de Servicio",
    "deposit": "Depósito",
    "maintenance": "Mantenimiento",
    "other": "Otro",


    "generate": "Generar",
    "generated": "Generado",
    "generate_payment_for": "Generar Pago para",
    "payment_amount": "Monto del Pago",
    "enter_amount": "Ingresa el monto",
    "mark_as_paid_immediately": "Marcar como pagado de inmediato",
    "notes": "Notas",
    "payment_notes": "Notas del pago",
    "required_fields": "Campos requeridos",
    "cancel": "Cancelar",
    "generate_payment": "Generar Pago",

    "loading": "Cargando...",
    "edit_payment": "Editar Pago",
    "record_payment": "Registrar Pago",
    "payment_information": "Información de Pago",
    "tenant": "Inquilino",
    "select_tenant": "Seleccionar Inquilino",
    "apt": "Apt",
    "no_apartment": "Sin Apartamento",
    "amount": "Monto",
    "payment_date": "Fecha de Pago",
    "payment_type": "Tipo de Pago",
    "payment_period": "Período de Pago",
    "period_start": "Inicio de Período",
    "period_end": "Fin de Período",
    "additional_information": "Información Adicional",
    "notes": "Notas",
    "notes_placeholder": "Cualquier nota adicional sobre este pago...",
    "cancel": "Cancelar",
    "saving": "Guardando...",
    "update_payment": "Actualizar Pago",
    "failed_to_load_tenants_format": "Error al cargar inquilinos: formato de datos inesperado",
    "failed_to_load_tenants": "Error al cargar inquilinos. Por favor inténtalo de nuevo.",
    "failed_to_load_payment_data": "Error al cargar datos del pago",
    "failed_to_save_payment": "Error al guardar el pago",

    "rent": "Alquiler",
    "service": "Cuota de Servicio",
    "deposit": "Depósito",
    "maintenance": "Mantenimiento",
    "other": "Otro",

    "payments": "Pagos",
    "refresh": "Actualizar",
    "refresh_payments": "Actualizar pagos",
    "stats": "Estadísticas",
    "toggle_statistics": "Alternar vista de estadísticas",
    "search_payments": "Buscar pagos...",
    "filter": "Filtrar",
    "record_payment": "Registrar Pago",
    "confirm_deletion": "Confirmar Eliminación",
    "confirm_delete_payment": "¿Estás seguro de que deseas eliminar el pago de {amount} para {tenantName}? Esta acción no se puede deshacer.",
    "cancel": "Cancelar",
    "deleting": "Eliminando...",
    "delete": "Eliminar",
    "filter_payments": "Filtrar Pagos",
    "reset_all": "Restablecer Todo",
    "payment_type": "Tipo de Pago",
    "all_types": "Todos los Tipos",
    "payment_type_rent": "Alquiler",
    "payment_type_service": "Servicio",
    "payment_type_deposit": "Depósito",
    "payment_type_other": "Otro",

    "payment_type_commission": "Commissione",
    "payment_type_security_deposit": "Deposito cauzionale",    "building": "Edificio",
    "all_buildings": "Todos los Edificios",
    "from_date": "Desde Fecha",
    "to_date": "Hasta Fecha",
    "total_payments": "Pagos Totales",
    "payment": "pago",
    "payments": "pagos",
    "recorded": "registrados",
    "rent_payments": "Pagos de Alquiler",
    "service_payments": "Pagos de Servicios",
    "payment_statistics": "Estadísticas de Pagos",
    "payments_by_month": "Pagos por Mes",
    "payment_types_distribution": "Distribución de Tipos de Pago",
    "recent_activity": "Actividad Reciente",
    "close_statistics": "Cerrar Estadísticas",
    "loading_payments": "Cargando pagos...",
    "this_may_take_moment": "Esto puede tardar un momento",
    "error_loading_payments": "Error al Cargar Pagos",
    "try_again": "Intentar de Nuevo",
    "no_payments_found": "No se encontraron pagos",
    "no_payments_match_filters": "No hay pagos que coincidan con tus filtros actuales. Intenta ajustar tus criterios de filtro para ver más resultados.",
    "no_payments_in_system": "Aún no hay pagos en el sistema. Empieza registrando tu primer pago.",
    "reset_filters": "Restablecer Filtros",
    "record_first_payment": "Registrar Primer Pago",
    "unknown_period": "Período desconocido",
    "to": "a",
    "invalid_period_data": "Datos de período no válidos",
    "unknown_type": "Tipo Desconocido",
    "apt": "Apt",
    "print_receipt": "Imprimir recibo",
    "view_details": "Ver detalles",
    "edit_payment": "Editar pago",
    "delete_payment": "Eliminar pago",
    "showing_payments": "Visualizzazione {{start}}-{{end}} di {{total}} pagamenti",
    "showing_filtered_payments": "Visualizzazione {{filtered}} di {{total}} pagamenti in base alla tua ricerca",
    "authentication_required": "Autenticación requerida",
    "failed_load_payments": "Error al cargar datos de pagos",
    "auth_failed_login_again": "Error de autenticación. Por favor inicia sesión de nuevo.",
    "access_denied_admin_required": "Acceso denegado. Se requiere el rol de Administrador.",
    "server_error_check_backend": "Error del servidor. Por favor comprueba si el backend se está ejecutando.",
    "cannot_connect_server": "No se puede conectar al servidor. Por favor comprueba si el backend se está ejecutando.",
    "error_fetching_payments": "Error al obtener pagos",
    "error_deleting_payment": "Error al eliminar pago",
    "failed_delete_payment": "Error al eliminar el pago",

    "occupancy_report": "Informe de Ocupación",
    "loading": "Cargando...",
    "refresh": "Actualizar",
    "back": "Atrás",
    "error_fetching_occupancy": "Error al obtener datos de ocupación",
    "failed_load_occupancy": "Error al cargar datos de ocupación",
    "occupied": "Ocupado",
    "vacant": "Vacante",
    "maintenance": "Mantenimiento",
    "apartments": "apartamentos",
    "occupancy_rate": "Tasa de Ocupación",
    "of": "de",
    "vacant_apartments": "Apartamentos Vacantes",
    "of_total": "del total",
    "maintenance_apartments": "En Mantenimiento",
    "potential_income": "Ingreso Mensual Potencial",
    "buildings": "edificios",
    "occupancy_distribution": "Distribución de Ocupación",
    "occupancy_by_building": "Ocupación por Edificio",
    "building": "Edificio",
    "total_apartments": "Total de Apartamentos",
    "print_report": "Imprimir Informe",
    "export_report": "Exportar Informe",

    "rent": "Alquiler",
    "service": "Servicio",
    "commission": "Comisión",
    "insurance": "Seguro",
    "total": "Total",
    "occupied": "Ocupado",
    "vacant": "Vacante",
    "maintenance": "Mantenimiento",
    "apartments": "apartamentos",
    "of": "de",
    "excellent": "Excelente",
    "good": "Bueno",
    "needs_improvement": "Necesita Mejorar",
    "error_fetching_occupancy": "Error al obtener datos de ocupación",
    "failed_load_occupancy": "Error al cargar datos de ocupación",

    "overdue": "Atrasado",
    "pending": "Pendiente",
    "paid": "Pagado",
    "no_overdue_payments": "No se encontraron pagos atrasados",
    "apt": "Apt",
    "days_overdue": "días de retraso",
    "more_overdue_tenants": "más inquilinos con retraso...",
    "error_fetching_tenant_status": "Error al obtener el estado de pago del inquilino",
    "failed_load_tenant_status": "Error al cargar el estado de pago del inquilino",

    "rent": "Alquiler",
    "service": "Servicio",
    "deposit": "Depósito",
    "no_recent_payments": "No se encontraron pagos recientes",
    "error_fetching_payments": "Error al obtener pagos recientes",
    "failed_load_payments": "Error al cargar pagos recientes",

    "payment_logs": "Registros de Pagos",
    "filter": "Filtrar",
    "back": "Atrás",
    "search_payment_logs_placeholder": "Buscar en registros de pagos...",
    "showing_entries": "Mostrando {{showing}} de {{total}} entradas",
    "filter_payments": "Filtrar Pagos",
    "time_period": "Período de Tiempo",
    "start_date": "Fecha de Inicio",
    "end_date": "Fecha de Fin",
    "payment_type": "Tipo de Pago",
    "all_types": "Todos los Tipos",
    "entries_per_page": "Entradas Por Página",
    "reset": "Restablecer",
    "apply_filter": "Aplicar Filtro",
    "payment_id": "ID de Pago",
    "date": "Fecha",
    "tenant": "Inquilino",
    "building": "Edificio",
    "type": "Tipo",
    "amount": "Monto",
    "actions": "Acciones",
    "print_receipt": "Imprimir Recibo",
    "view_details": "Ver Detalles",
    "no_logs_matching_search": "No hay registros de pago que coincidan con tus criterios de búsqueda",
    "no_logs_for_period": "No hay registros de pago disponibles para el período de tiempo seleccionado",
    "showing_range": "Mostrando {{start}} a {{end}} de {{total}} entradas",
    "previous": "Anterior",
    "next": "Siguiente",
    "print_report": "Imprimir Informe",
    "export_to_excel": "Exportar a Excel",
    "failed_to_load_payment_logs": "Error al cargar registros de pagos",

    "current_month": "Mes Actual",
    "last_month": "Mes Pasado",
    "current_quarter": "Trimestre Actual",
    "current_year": "Año Actual",
    "custom": "Rango Personalizado",

    "rent": "Alquiler",
    "service": "Servicio",
    "commission": "Comisión",
    "insurance": "Seguro",
    "other": "Otro",

    "reports_dashboard": "Panel de Informes",
    "overview_of_financial_performance": "Resumen del rendimiento financiero y estadísticas de propiedades",
    "view_all_reports": "Ver Todos los Informes",
    "failed_to_load_report_data": "Error al cargar datos del informe",
    "total_revenue": "Ingresos Totales",
    "total_payments_count": "{{count}} pagos",
    "total_tenants": "Total de Inquilinos",
    "new_tenants_this_year": "{{count}} nuevos este año",
    "total_properties": "Total de Propiedades",
    "total_buildings_count": "{{count}} edificios",
    "total_owners": "Total de Propietarios",
    "ended_contracts_count": "{{count}} contratos terminados",
    "monthly_revenue_year": "Ingresos Mensuales - {{year}}",
    "view_details": "Ver Detalles",
    "occupancy_rate": "Tasa de Ocupación",
    "recent_payments": "Pagos Recientes",
    "view_all": "Ver Todo",
    "overdue_payments": "Pagos Atrasados",
    "quick_reports": "Informes Rápidos",
    "annual_revenue": "Ingresos Anuales",
    "yearly_breakdown": "Desglose anual de todos los ingresos",
    "building_revenue": "Ingresos por Edificio",
    "revenue_by_building": "Desglose de ingresos por edificio",
    "owner_revenue": "Ingresos de Propietarios",
    "revenue_by_owner": "Desglose de ingresos por propietario",
    "payment_logs": "Registros de Pagos",
    "detailed_payment_history": "Historial detallado de pagos y registros",

    "revenue_report": "Informe de Ingresos",
    "filter": "Filtrar",
    "loading": "Cargando...",
    "refresh": "Actualizar",
    "back": "Atrás",
    "filter_report": "Filtrar Informe",
    "time_period": "Período de Tiempo",
    "start_date": "Fecha de Inicio",
    "end_date": "Fecha de Fin",
    "cancel": "Cancelar",
    "apply_filter": "Aplicar Filtro",
    "failed_to_load_revenue_data": "Error al cargar datos de ingresos",
    "total_revenue": "Ingresos Totales",
    "total_payments_count": "{{count}} pagos",
    "rent_revenue": "Ingresos por Alquiler",
    "percent_of_total": "{{percent}}% del total",
    "service_revenue": "Ingresos por Servicio",
    "unique_tenants": "Inquilinos Únicos",
    "avg_per_tenant": "Promedio de {{amount}} por inquilino",
    "revenue_by_building": "Ingresos por Edificio",
    "view_details": "Ver Detalles",
    "building": "Edificio",
    "tenants": "Inquilinos",
    "no_building_revenue_data": "No hay datos de ingresos por edificio disponibles",
    "revenue_by_owner": "Ingresos por Propietario",
    "owner": "Propietario",
    "apartments": "Apartamentos",
    "no_owner_revenue_data": "No hay datos de ingresos por propietario disponibles",
    "print_report": "Imprimir Informe",
    "export_report": "Exportar Informe",

    "current_month": "Mes Actual",
    "last_month": "Mes Pasado",
    "current_quarter": "Trimestre Actual",
    "current_year": "Año Actual",
    "custom": "Rango Personalizado",

    "service_payments_management": "Gestión de Pagos de Servicios",
    "refresh": "Actualizar",
    "back_to_dashboard": "Volver al Panel",
    "building": "Edificio",
    "select_building": "Seleccionar Edificio",
    "year": "Año",
    "search": "Buscar",
    "search_apartments_tenants": "Buscar apartamentos, inquilinos...",
    "generate_payments": "Generar Pagos",
    "view_statistics": "Ver Estadísticas",
    "filter_by_status": "Filtrar por estado",
    "all": "Todo",
    "paid": "Pagado",
    "unpaid": "No Pagado",
    "clear_filters": "Limpiar Filtros",
    "loading_service_data": "Cargando datos de pagos de servicios...",
    "no_building_selected": "No se Seleccionó Edificio",
    "please_select_building": "Por favor selecciona un edificio para ver los pagos de servicios.",
    "no_search_results": "Sin Resultados de Búsqueda",
    "no_matching_apartments": "No hay apartamentos o inquilinos que coincidan con tu búsqueda.",
    "service_payments_for_building_year": "Pagos de Servicios para {{building}} - {{year}}",
    "floor_number": "Piso {{number}}",
    "apartments": "Apartamentos",
    "rate": "Tasa",
    "tenant_owner": "Inquilino/Propietario",
    "vacant": "Vacante",
    "mark_as_paid": "Marcar como Pagado",
    "mark_as_unpaid": "Marcar como No Pagado",
    "view_details": "Ver Detalles",
    "summary": "Resumen",
    "floor_apartment_count": "{{floors}} pisos, {{apartments}} apartamentos",
    "no_floors_available": "No Hay Pisos Disponibles",
    "no_floors_message": "No hay pisos con apartamentos en este edificio, o aún no se han generado pagos de servicios.",
    "failed_to_load_buildings": "Error al cargar edificios. Por favor inténtalo de nuevo.",
    "failed_to_load_floors": "Error al cargar pisos",
    "failed_to_load_building_floors": "Error al cargar pisos del edificio",
    "failed_to_load_floor_data": "Error al cargar datos del piso",
    "data_refreshed_successfully": "Datos actualizados exitosamente.",
    "failed_to_refresh_data": "Error al actualizar los datos",
    "marked_as_paid_via_service_management": "Marcado como pagado a través de la gestión de servicios",
    "marked_as_unpaid_via_service_management": "Marcado como no pagado a través de la gestión de servicios",
    "payment_marked_as_paid": "Pago marcado como pagado exitosamente.",
    "payment_marked_as_unpaid": "Pago marcado como no pagado exitosamente.",
    "failed_to_update_payment": "Error al actualizar el pago",
    "payment_details": "Detalles del Pago",
    "payment_due": "Pago Vencido",
    "amount": "Monto",
    "status": "Estado",
    "paid_on": "Pagado el",
    "no_apartments_on_floor": "No se encontraron apartamentos en este piso.",

    "month_1": "Enero",
    "month_2": "Febrero",
    "month_3": "Marzo",
    "month_4": "Abril",
    "month_5": "Mayo",
    "month_6": "Junio",
    "month_7": "Julio",
    "month_8": "Agosto",
    "month_9": "Septiembre",
    "month_10": "Octubre",
    "month_11": "Noviembre",
    "month_12": "Diciembre",


    "service_payment_details": "Detalles del Pago de Servicio",
    "print_receipt": "Imprimir Recibo",
    "loading": "Cargando...",
    "failed_to_load_payment_details": "Error al cargar detalles del pago",
    "api_endpoint_missing_message": "Este error indica que falta un punto de conexión API en tu servidor backend. Para solucionarlo, añade una ruta para GET /api/services/:id en tu archivo serviceRoutes.js.",
    "payment_information": "Información del Pago",
    "apartment": "Apartamento",
    "period": "Período",
    "amount": "Monto",
    "status": "Estado",
    "tenant": "Inquilino",
    "owner": "Propietario",
    "payment_date": "Fecha de Pago",
    "paid_by": "Pagado Por",
    "notes": "Notas",
    "update_payment": "Actualizar Pago",
    "mark_as_paid": "Marcar como Pagado",
    "currency": "Moneda",
    "select_payer": "Seleccionar Pagador",
    "management": "Gestión",
    "other": "Otro",
    "payment_notes_placeholder": "Ingresa cualquier nota adicional sobre este pago...",
    "cancel": "Cancelar",
    "saving": "Guardando...",
    "payment_history": "Historial de Pagos",
    "date": "Fecha",
    "action": "Acción",
    "by": "Por",
    "paid": "Pagado",
    "unpaid": "No Pagado",
    "payment_marked_as_paid": "Pago marcado exitosamente como pagado.",
    "payment_marked_as_unpaid": "Pago marcado exitosamente como no pagado.",
    "failed_to_update_payment": "Error al actualizar el pago",
    "service_payment_receipt": "Recibo de Pago de Servicio",
    "property_management": "Gestión de Propiedades",
    "receipt_generated": "Este recibo fue generado el {{date}} a las {{time}}",
    "automated_receipt_notice": "Este es un recibo generado automáticamente y no requiere firma.",
    "us_dollar": "Dólar Estadounidense",
    "iraqi_dinar": "Dinar Iraquí",
    "euro": "Euro",

    "month_1": "Enero",
    "month_2": "Febrero",
    "month_3": "Marzo",
    "month_4": "Abril",
    "month_5": "Mayo",
    "month_6": "Junio",
    "month_7": "Julio",
    "month_8": "Agosto",
    "month_9": "Septiembre",
    "month_10": "Octubre",
    "month_11": "Noviembre",
    "month_12": "Diciembre",

    "tenant": "inquilino",
    "owner": "propietario",
    "management": "gestión",
    "other": "otro",

    "generate_service_payments": "Generar Pagos de Servicios",
    "recipients": "Destinatarios",
    "entire_building": "Edificio Entero",
    "generate_for_all_apartments": "Generar para todos los apartamentos en un edificio",
    "specific_tenants": "Inquilinos Específicos",
    "generate_for_selected_tenants": "Generar solo para inquilinos seleccionados",
    "specific_owners": "Propietarios Específicos",
    "generate_for_selected_owners": "Generar solo para propietarios seleccionados",
    "select_building": "Seleccionar Edificio",
    "include_vacant_apartments": "Incluir apartamentos vacantes",
    "selected_tenants": "Inquilinos Seleccionados",
    "selected_owners": "Propietarios Seleccionados",
    "select_tenants": "Seleccionar Inquilinos",
    "select_owners": "Seleccionar Propietarios",
    "no_tenants_selected": "No se seleccionaron inquilinos",
    "no_owners_selected": "No se seleccionaron propietarios",
    "payment_details": "Detalles del Pago",
    "amount": "Monto",
    "currency": "Moneda",
    "us_dollar": "Dólar Estadounidense",
    "iraqi_dinar": "Dinar Iraquí",
    "euro": "Euro",
    "initial_status": "Estado Inicial",
    "unpaid": "No Pagado",
    "paid": "Pagado",
    "notes": "Notas",
    "payment_notes_placeholder": "Ingresa cualquier nota adicional sobre estos pagos...",
    "time_period": "Período de Tiempo",
    "generation_type": "Tipo de Generación",
    "single_month": "Mes Único",
    "multiple_months": "Múltiples Meses",
    "month_range": "Rango de Meses",
    "year": "Año",
    "month": "Mes",
    "select_months": "Seleccionar Meses",
    "from": "De",
    "to": "A",
    "selected_months": "Meses Seleccionados",
    "payment_generation_summary": "Resumen de Generación de Pagos",
    "all_apartments_in": "Todos los apartamentos en",
    "selected_building": "edificio seleccionado",
    "tenants": "inquilinos",
    "owners": "propietarios",
    "cancel": "Cancelar",
    "generating": "Generando...",
    "generate_payments": "Generar Pagos",
    "search": "Buscar",
    "search_by_tenant_name_or_phone": "Buscar por nombre del inquilino, teléfono o número de apto...",
    "search_by_owner_name_or_phone": "Buscar por nombre de propietario o teléfono...",
    "no_results_found": "No se encontraron resultados",
    "selected": "seleccionado/s",
    "done": "Hecho",
    "no_tenants_available": "No hay inquilinos disponibles. Por favor añade inquilinos primero.",
    "no_owners_available": "No hay propietarios disponibles. Por favor añade propietarios primero.",
    "apt": "Apt",
    "january": "Enero",
    "february": "Febrero",
    "march": "Marzo",
    "april": "Abril",
    "may": "Mayo",
    "june": "Junio",
    "july": "Julio",
    "august": "Agosto",
    "september": "Septiembre",
    "october": "Octubre",
    "november": "Noviembre",
    "december": "Diciembre",
    "failed_to_load_buildings": "Error al cargar edificios. Por favor inténtalo de nuevo.",
    "failed_to_load_tenants": "Error al cargar inquilinos. Por favor inténtalo de nuevo.",
    "failed_to_load_owners": "Error al cargar propietarios. Por favor inténtalo de nuevo.",
    "please_select_building": "Por favor selecciona un edificio",
    "please_select_at_least_one_recipient": "Por favor selecciona al menos un {{recipient}}",
    "please_enter_valid_amount": "Por favor ingresa un monto válido",
    "please_select_month": "Por favor selecciona un mes",
    "please_select_at_least_one_month": "Por favor selecciona al menos un mes",
    "end_month_must_be_after_start_month": "El mes de fin debe ser posterior al mes de inicio",
    "successfully_generated_payments": "Se generaron con éxito {{count}} pagos de servicios durante {{months}} mes(es). {{skipped}} pagos ya estaban generados.",
    "failed_to_generate_service_payments": "Error al generar pagos de servicios",
    "tenant": "inquilino",
    "owner": "propietario",

    "service_payment_statistics": "Estadísticas de Pagos de Servicios",
    "back_to_services": "Volver a Servicios",
    "building": "Edificio",
    "year": "Año",
    "loading_statistics": "Cargando estadísticas...",
    "no_building_selected": "No se Seleccionó Edificio",
    "please_select_building_statistics": "Por favor selecciona un edificio para ver las estadísticas de pagos de servicios.",
    "overall_statistics": "Estadísticas Generales",
    "total_collection": "Recaudación Total",
    "of": "de",
    "payment_rate": "Tasa de Pago",
    "payments": "pagos",
    "outstanding_amount": "Monto Pendiente",
    "unpaid_payments": "pagos no pagados",
    "monthly_statistics": "Estadísticas Mensuales",
    "no_monthly_data": "No hay datos mensuales disponibles para el año seleccionado.",
    "month": "Mes",
    "total_amount": "Monto Total",
    "collected": "Recaudado",
    "outstanding": "Pendiente",
    "progress": "Progreso",
    "failed_to_load_service_statistics": "Error al cargar las estadísticas de servicios",

    "loading_tenant_data": "Cargando datos del inquilino...",
    "error_loading_tenant": "Error al Cargar Inquilino",
    "tenant_not_found": "Inquilino no encontrado",
    "back_to_tenants": "Volver a Inquilinos",
    "record_payment": "Registrar Pago",
    "edit": "Editar",
    "status_unknown": "Estado Desconocido",
    "apartment": "Apartamento",
    "apt": "Apt",
    "none": "Ninguno",
    "monthly_rent": "Alquiler Mensual",
    "payment_date": "Fecha de Pago",
    "overview": "Resumen",
    "leases": "Contratos",
    "payments": "Pagos",
    "contact_information": "Información de Contacto",
    "lease_information": "Información del Contrato",
    "contract_period": "Período del Contrato",
    "rent": "Alquiler",
    "discount": "Descuento",
    "rent_after_discount": "Alquiler Después de Descuento",
    "additional_fees": "Cuotas Adicionales",
    "service_fee": "Cuota de Servicio",
    "office_commission": "Comisión de Oficina",
    "insurance": "Seguro",
    "notes": "Notas",
    "no_leases": "Sin Contratos",
    "no_leases_message": "Este inquilino aún no tiene asignado un apartamento.",
    "active_leases": "Contratos Activos",
    "inactive_leases": "Contratos Inactivos",
    "active": "Activo",
    "ended": "Finalizado",
    "expiring_soon": "Vence pronto",
    "end_lease": "Finalizar contrato",
    "start_date": "Fecha de Inicio",
    "end_date": "Fecha de Fin",
    "duration": "Duración",
    "remaining": "Restante",
    "months": "meses",
    "security_deposit": "Depósito de Seguridad",
    "total_value": "Valor Total",
    "no_payments": "Sin Pagos",
    "no_payments_message": "Este inquilino aún no tiene pagos registrados.",
    "record_first_payment": "Registrar Primer Pago",
    "payment_period": "Período de Pago",
    "reference": "Referencia",
    "payment_type": "Tipo de Pago",
    "rent_payment": "Pago de Alquiler",
    "additional_fee": "Cuota Adicional",
    "utility_payment": "Pago de Servicios Públicos",
    "other_payment": "Otro Pago",
    "start": "Inicio",
    "end": "Fin",
    "reference_number": "Número de Referencia",
    "cancel": "Cancelar",
    "unknown_period": "Período desconocido",
    "invalid_period_format": "Formato de período no válido",
    "to": "a",
    "invalid_period_data": "Datos de período no válidos",
    "please_enter_valid_payment_amount": "Por favor ingresa un monto de pago válido",
    "end_date_must_be_after_start_date": "La fecha de fin debe ser posterior a la fecha de inicio",
    "failed_to_add_payment": "Error al añadir el pago",
    "maintenance_requests_not_supported": "Las solicitudes de mantenimiento no son compatibles en la estructura de base de datos actual",
    "failed_to_create_maintenance_request": "Error al crear la solicitud de mantenimiento",
    "confirm_end_lease": "¿Estás seguro de que deseas finalizar este contrato? Esta acción no se puede deshacer.",
    "lease_ended_by_administrator": "Contrato finalizado por el administrador",
    "failed_to_end_lease": "Error al finalizar el contrato",
    "failed_to_load_tenant_data": "Error al cargar los datos del inquilino",
    "actual_end_date": "Fecha de Fin Real",

    "edit_tenant": "Editar Inquilino",
    "add_tenant": "Añadir Inquilino",
    "basic_information": "Información Básica",
    "first_name": "Nombre",
    "last_name": "Apellido",
    "email": "Correo Electrónico",
    "phone": "Teléfono",
    "apartment": "Apartamento",
    "select_apartment": "Seleccionar Apartamento",
    "floor": "Piso",
    "rent_amount": "Monto de Alquiler",
    "discount": "Descuento",
    "service_fee": "Cuota de Servicio",
    "office_commission": "Comisión de Oficina",
    "insurance": "Seguro",
    "contract_start_date": "Fecha de Inicio del Contrato",
    "contract_end_date": "Fecha de Fin del Contrato",
    "payment_date": "Fecha de Pago",
    "payment_end_date": "Fecha de Fin de Pago",
    "rent_status": "Estado de Alquiler",
    "additional_information": "Información Adicional",
    "notes": "Notas",
    "tenant_notes_placeholder": "Cualquier nota adicional sobre este inquilino...",
    "cancel": "Cancelar",
    "saving": "Guardando...",
    "update_tenant": "Actualizar Inquilino",
    "create_tenant": "Crear Inquilino",
    "loading": "Cargando...",
    "failed_to_load_tenant_data": "Error al cargar los datos del inquilino",
    "failed_to_save_tenant": "Error al guardar el inquilino",
    "pending": "Pendiente",
    "paid": "Pagado",
    "late": "Tarde",
    "overdue": "Atrasado",
    "unpaid": "No Pagado",

    "tenants": "Inquilinos",
    "refresh_tenants": "Actualizar inquilinos",
    "selected": "seleccionado",
    "delete_selected_tenants": "Eliminar inquilinos seleccionados",
    "search_tenants": "Buscar inquilinos...",
    "filter": "Filtrar",
    "switch_to_list_view": "Cambiar a Vista de Lista",
    "switch_to_grid_view": "Cambiar a Vista de Cuadrícula",
    "list_view": "Lista",
    "grid_view": "Cuadrícula",
    "hide_inactive_tenants": "Ocultar inquilinos inactivos",
    "show_inactive_tenants": "Mostrar inquilinos inactivos",
    "hide_inactive": "Ocultar Inactivos",
    "show_inactive": "Mostrar Inactivos",
    "add_tenant": "Añadir Inquilino",
    "rent_status": "Estado del Alquiler",
    "all_statuses": "Todos los Estados",
    "all_buildings": "Todos los Edificios",
    "all_apartments": "Todos los Apartamentos",
    "min_rent": "Alquiler Mín.",
    "max_rent": "Alquiler Máx.",
    "unlimited": "Ilimitado",
    "contracts_ending_before": "Contratos Terminando Antes",
    "clear_filters": "Limpiar Filtros",
    "apply_filters": "Aplicar Filtros",
    "active_tenants": "Inquilinos Activos",
    "inactive_tenants": "Inquilinos Inactivos",
    "with_apartments": "Con Apartamentos",
    "without_apartments": "Sin Apartamentos",
    "loading_tenants": "Cargando inquilinos...",
    "error_loading_tenants": "Error al Cargar Inquilinos",
    "try_again": "Intentar de Nuevo",
    "no_tenants_found": "No Se Encontraron Inquilinos",
    "no_tenants_message": "Aún no hay inquilinos en el sistema. Haz clic en el botón 'Añadir Inquilino' para crear tu primer inquilino.",
    "create_first_tenant": "Crear Primer Inquilino",
    "page": "página",
    "showing_items": "Mostrando {start}-{end} de {total}",
    "first_page": "Primera Página",
    "previous_page": "Página Anterior",
    "next_page": "Página Siguiente",
    "last_page": "Última Página",
    "showing_filtered_results": "Mostrando {showing} de {total} inquilinos",
    "confirm_deletion": "Confirmar Eliminación",
    "delete_tenant_confirmation": "¿Estás seguro de que deseas eliminar al inquilino \"{name}\"? Esta acción no se puede deshacer.",
    "cancel": "Cancelar",
    "deleting": "Eliminando...",
    "delete": "Eliminar",
    "tenant": "Inquilino",
    "apartment": "Apartamento",
    "rent": "Alquiler",
    "contract": "Contrato",
    "status": "Estado",
    "actions": "Acciones",
    "apt": "Apt",
    "unknown_building": "Edificio Desconocido",
    "no_apartment_assigned": "No hay apartamento asignado",
    "status_unknown": "Estado Desconocido",
    "monthly_rent": "Alquiler Mensual",
    "after_discount": "Después del Descuento",
    "payment_date": "Fecha de Pago",
    "not_set": "No establecido",
    "contract_start": "Inicio de Contrato",
    "contract_end": "Fin de Contrato",
    "service": "Servicio",
    "commission": "Comisión",
    "insurance": "Seguro",
    "hide_owner_details": "Ocultar Detalles del Propietario",
    "show_owner_details": "Mostrar Detalles del Propietario",
    "apartment_owner": "Propietario del Apartamento",
    "loading_owner_details": "Cargando detalles del propietario...",
    "no_owner_information": "No hay información del propietario disponible",
    "lives_on_property": "Vive en la Propiedad",
    "yes": "Sí",
    "no": "No",
    "total_apartments": "Total de Apartamentos",
    "apartment_details": "Detalles del Apartamento",
    "apartment_number": "Apt #",
    "unknown": "Desconocido",
    "floor": "Piso",
    "apartment_type": "Tipo de Apartamento",
    "standard": "Estándar",
    "furnished": "Amueblado",
    "view_owner_profile": "Ver Perfil del Propietario",
    "mark_as_inactive": "Marcar como inactivo",
    "mark_as_active": "Marcar como activo",
    "record_payment": "Registrar pago",
    "view_details": "Ver detalles",
    "edit_tenant": "Editar inquilino",
    "delete_tenant": "Eliminar inquilino",
    "to": "A",
    "payment": "Pago",
    "apartment_financial_details": "Detalles del Apartamento y Financieros",
    "not_authenticated": "No autenticado. Por favor inicia sesión.",
    "authentication_required": "Autenticación requerida",
    "authentication_failed": "Fallo de autenticación. Por favor inicia sesión de nuevo.",
    "access_denied": "Acceso denegado. Se requiere el rol de Administrador.",
    "server_error": "Error del servidor. Por favor verifica si el backend se está ejecutando.",
    "cannot_connect_to_server": "No se puede conectar al servidor. Verifica si el backend se está ejecutando en el puerto 3000.",
    "failed_to_load_tenants_data": "Error al cargar los datos de los inquilinos",
    "unknown_error": "Error desconocido",
    "failed_to_delete_tenant": "Error al eliminar el inquilino",
    "confirm_bulk_delete": "¿Estás seguro de que deseas eliminar {count} inquilinos? Esta acción no se puede deshacer.",
    "failed_to_delete_tenants": "Error al eliminar los inquilinos",
    "failed_to_update_tenant_status": "Error al actualizar el estado del inquilino",
    "pending": "Pendiente",
    "paid": "Pagado",
    "late": "Tarde",
    "overdue": "Atrasado",

    'add_new_user': 'Añadir Nuevo Usuario',
    'search_users': 'Buscar Usuarios',
    'total_users': 'Total de Usuarios',
    'active_users': 'Usuarios Activos',
    'inactive_users': 'Usuarios Inactivos',
    'financial_summary': 'Resumen Financiero',
    'filters': 'Filtros',
    'search_tenants_by_name_phone_or_apartment': 'Buscar Inquilino por Nombre, Teléfono o Apartamento',
    'view_profile': 'Ver Perfil',

    // WhatsApp Settings
    'whatsapp_settings': 'Configuración de WhatsApp',
    'whatsapp_settings_description': 'Notificaciones automatizadas de WhatsApp para inquilinos y propietarios',
    'whatsapp_enable': 'Habilitar Notificaciones de WhatsApp',
    'whatsapp_enable_sub': 'Activa o desactiva todos los mensajes automatizados de WhatsApp',
    'general_settings': 'Configuración General',
    'default_country_code': 'Código de País por Defecto',
    'tenant_rent_reminder': 'Recordatorio de Alquiler del Inquilino',
    'tenant_rent_reminder_sub': 'Enviar recordatorio a los inquilinos antes o después de la fecha de vencimiento del pago',
    'days_before_due': 'Días Antes del Vencimiento',
    'reminder_message_template': 'Plantilla de Mensaje',
    'service_fee_reminder': 'Recordatorio de Cuota de Servicio',
    'enable_service_fee_reminder': 'Habilitar Recordatorio de Cuota de Servicio',
    'service_fee_reminder_sub': 'Notificar a los inquilinos sobre próximos pagos de cuotas de servicio',
    'owner_reminder': 'Recordatorio para Propietarios',
    'enable_owner_reminders': 'Habilitar Recordatorios para Propietarios',
    'owner_reminder_sub': 'Notificar a los propietarios cuando sus inquilinos tengan pagos atrasados',
    'owner_message_template': 'Plantilla de Mensaje para Propietario',
    'payment_confirmation': 'Confirmación de Pago',
    'send_on_payment': 'Enviar confirmación cuando se registre el pago',
    'payment_confirmation_sub': 'Se envía automáticamente al inquilino cuando se registra un pago',
    'payment_confirmation_template': 'Plantilla de Mensaje de Confirmación',
    'whatsapp_test_send': 'Enviar Mensaje de Prueba',
    'test_message': 'Mensaje',
    'send_test_message': 'Enviar Mensaje de Prueba',
    'whatsapp_test_sent': '¡Mensaje de prueba enviado!',
    'whatsapp_test_default_message': 'Mensaje de prueba del sistema de gestión de propiedades',
    'send_reminders_now': 'Enviar Recordatorios Ahora',
    'send_reminders_now_description': 'Envía recordatorios de inmediato a todos los inquilinos y propietarios que necesiten uno ahora mismo.',
    'whatsapp_must_be_enabled': 'WhatsApp debe estar habilitado primero',
    'failed_to_load_settings': 'Error al cargar la configuración',
    'settings_saved': 'Configuración guardada exitosamente',
    'failed_to_save': 'Error al guardar',
    'failed_to_send': 'Error al enviar',
    'server_error': 'Error de conexión al servidor',
    'sent': 'Enviado',
    'errors': 'Errores',
    'skipped': 'Omitido',

    // Bookings
    'bookings': 'Reservas',
    'booking_management': 'Gestión de Reservas',
    'new_booking': 'Nueva Reserva',
    'create_booking': 'Crear Reserva',
    'edit_booking': 'Editar Reserva',
    'booking_details': 'Detalles de la Reserva',
    'prospect': 'Prospecto',
    'prospect_name': 'Nombre del Prospecto',
    'prospect_phone': 'Número de Teléfono',
    'prospect_email': 'Dirección de Correo',
    'move_in_date': 'Fecha de Mudanza',
    'move_out_date': 'Fecha de Salida',
    'hold_duration': 'Duración de Reserva (Retención)',
    'hold_hours': 'Horas de Retención',
    'hold_expiration': 'Vencimiento de Retención',
    'internal_notes': 'Notas Internas',
    'check_availability': 'Comprobar Disponibilidad',
    'checking_availability': 'Comprobando disponibilidad...',
    'no_bookings_found': 'No se encontraron reservas',
    'calendar_view': 'Vista de Calendario',
    'waitlist': 'Lista de Espera',
    'new_booking_hold': 'Nueva Retención de Reserva',
    'property_information': 'Información de la Propiedad',
    'prospect_details': 'Detalles del Prospecto',
    'requested_dates': 'Fechas Solicitadas',
    'conflict_detected': 'Conflicto Detectado',
    'booking_timeline': 'Cronología de la Reserva',
    'monthly_view_holds': 'Vista mensual de reservas de apartamentos activas',
    'confirmed_hold': 'Retención Confirmada',
    'pending_payment': 'Pago Pendiente',
    'move_in': 'Mudanza',
    'move_out': 'Salida',
    'convert_to_tenant': 'Convertir en Inquilino',
    'confirm_booking': 'Confirmar Reserva',
    'cancel_booking': 'Cancelar Reserva',
    'booking_confirmed': 'Reserva confirmada',
    'booking_cancelled': 'Reserva cancelada',
    'booking_converted': '¡Reserva convertida en inquilino con éxito!',
    'process_to_booking': 'Procesar a Reserva',
    'waitlist_management': 'Gestión de Lista de Espera',
    'waitlist_empty': 'La lista de espera está vacía',
    'search_waitlist': 'Buscar en lista de espera...',
    'priority': 'Prioridad',
    'desired_unit': 'Unidad Deseada',
    'move_in_preference': 'Preferencia de Mudanza',
    'added': 'Añadido',
    'rank': 'Rango',
    'process_waitlist_success': '¡Convertido a reserva pendiente con éxito!',
    'remove_from_waitlist': '¿Estás seguro de que deseas eliminar esta entrada de la lista de espera?',
    'entry_removed': 'Entrada eliminada',
    'hold_expires': 'La Retención Vence',
    'hours': 'Horas',
    'optional': 'Opcional',
    'apartment_element': 'Elemento Apartamento',
    'select_unit': 'Seleccionar Unidad',
    'error_loading_data': 'Error al cargar los datos',
    'error_saving_booking': 'Error al guardar la reserva',
    'save_changes': 'Guardar Cambios',
    'select_apartment_move_in_date_error': 'Por favor selecciona un apartamento y la fecha de mudanza para comprobar la disponibilidad',
    'apartment_available': '¡El apartamento está disponible para estas fechas!',
    'error_checking_availability': 'Error al comprobar disponibilidad',
    'confirm_conflict_booking': 'Hay conflictos de fechas. ¿Estás seguro de que deseas continuar?',
    'booking_updated': 'Reserva actualizada con éxito',
    'booking_number': 'Reserva #{{id}}',
    'created_at': 'Creado el {{date}}',
    'created_by': 'por {{name}}',
    'system': 'Sistema',
    'confirm': 'Confirmar',
    'target_property': 'Propiedad de Destino',
    'furnished': 'Amueblado',
    'unfurnished': 'Sin amueblar',
    'booking_window': 'Ventana de Reserva',
    'indefinite': 'Indefinido',
    'created_source': 'Creado ({{source}})',
    'view_tenant_profile': 'Ver Perfil del Inquilino',
    'convert_to_active_tenant': 'Convertir a Inquilino Activo',
    'lease_details_move_in_instruction': 'Completa los siguientes detalles del contrato para mudar a {{name}} a la Unidad {{unit}}.',
    'monthly_rent': 'Alquiler Mensual',
    'first_payment_date': 'Fecha del Primer Pago',
    'contract_start': 'Inicio del Contrato',
    'contract_end': 'Fin del Contrato',
    'confirm_convert': 'Confirmar y Convertir',
    'confirm_booking_question': 'Finalizar Reserva: ¿Estás seguro de que deseas confirmar esta reserva y bloquear la unidad para este prospecto?',
    'confirm_booking_question_ar': 'تأكيد الحجز: هل أنت متأكد من رغبتك في تثبيت هذا الحجز وحجز الوحدة لهذا العميل؟',
    'confirm_booking_question_ku': 'پشتڕاستکردنەوەی حجز: ئایا دڵنیایت کە دەتەوێت ئەم حجزە پشتڕاست بکەیتەوە و یەکەکە بۆ ئەم کڕیارە دابنێیت؟',
    'reason_optional': 'Por favor proporciona una razón (opcional):',
    'amount': 'Monto',
    'today': 'Hoy',
    'sun': 'Dom',
    'mon': 'Lun',
    'tue': 'Mar',
    'wed': 'Mié',
    'thu': 'Jue',
    'fri': 'Vie',
    'sat': 'Sáb',
    'more': 'Más',
    'close': 'Cerrar',
    'hold_expiration': 'Vencimiento de Retención',
    'view_details': 'Ver Detalles',
    'waitlist_management': 'Gestión de Lista de Espera',
    'search_waitlist': 'Buscar en lista de espera...',
    'waitlist_empty': 'La lista de espera está vacía',
    'no_prospective_tenants_waiting': 'Ningún posible inquilino está esperando por disponibilidad de apartamentos en este momento.',
    'priority': 'Prioridad',
    'rank': 'Rango: {{priority}}',
    'desired_unit': 'Unidad Deseada',
    'move_in_preference': 'Preferencia de Mudanza',
    'process_to_booking': 'Procesar a Reserva',
    'remove': 'Eliminar',
    'remove_waitlist_confirm': '¿Estás seguro de que deseas eliminar esta entrada de la lista de espera?',
    'waitlist_processed': '¡Convertido a reserva pendiente con éxito!',
    'entry_removed': 'Entrada eliminada',
    'failed_process_waitlist': 'Error al procesar la entrada de la lista de espera',
    'failed_remove_entry': 'Error al eliminar entrada',
    'booking_analytics': 'Análisis de Reservas',
    'track_conversion_and_holds': 'Rastrea las tasas de conversión y las duraciones de las retenciones',
    'last_7_days': 'Últimos 7 Días',
    'last_30_days': 'Últimos 30 Días',
    'last_90_days': 'Últimos 90 Días',
    'last_year': 'Último Año',
    'total_bookings': 'Total de Reservas',
    'in_selected_period': 'En el período seleccionado',
    'conversion_rate': 'Tasa de Conversión',
    'converted_to_tenants': '{{count}} convertidos en inquilinos',
    'cancellation_rate': 'Tasa de Cancelación',
    'cancelled_holds': '{{count}} retenciones canceladas',
    'avg_hold_time': 'Tiempo de Retención Prom.',
    'before_conversion_cancel': 'Antes de la conversión/cancelación',
    'volume_trends': 'Tendencias de Volumen',
    'no_trend_data': 'No hay datos de tendencias disponibles',
    'total_holds': 'Total de Retenciones',
    'status_breakdown': 'Desglose por Estado',
    'no_status_data': 'No hay datos de estado disponibles',
    'active_holds': 'Retenciones Activas',
    'overdue_rent': 'Alquiler Atrasado',
    'subscription': 'Suscripción',
    'whatsapp': 'WhatsApp',
    'apartment_unit_display': 'Apartamento {{number}} - Piso {{floor}}',
    'building_view': 'Vista del Edificio',
    'showing_all_apartments': 'Mostrando todos los apartamentos',
    'expand_all_floors': 'Desplegar todos los pisos',
    'collapse_all_floors': 'Contraer todos los pisos',
    'pending_move_in': 'Mudanza Pendiente',
    'tenant_name': 'Nombre',
    'tenant_phone': 'Teléfono',
    'tenant_email': 'Correo Electrónico',
    'lease_details': 'Detalles del Contrato',
    'start_date': 'Fecha de Inicio',
    'end_date': 'Fecha de Fin',
    'monthly_pay_date': 'Día de Pago Mensual',
    'day_number': 'Día {{number}}',
    'duration': 'Duración',
    'months': 'Meses',
    'remaining_time': 'Tiempo Restante',
    'financial_summary': 'Resumen Financiero',
    'monthly_rent': 'Alquiler Mensual',
    'effective_rent': 'Alquiler Efectivo',
    'rent_status': 'Estado de Alquiler',
    'future_tenant_upcoming_move_in': 'Futuro Inquilino (Próxima Mudanza)',
    'move_in_date': 'Fecha de Mudanza',
    'contract_end': 'Fin del Contrato',
    'recent_bookings': 'Reservas y Retenciones Recientes',
    'new_hold': 'Nueva Retención',
    'available_now': 'Disponible Ahora',
    'lease_ending_soon': 'El contrato termina pronto',
    'no_apartments_found': 'No se encontraron apartamentos adecuados',
    'ready': 'Listo',
    'ends_in_days': 'Termina en {{count}}d',
    'search_unit': 'Buscar apartamento...',
    'currently_occupied': 'Actualmente Ocupado',
    'occupied': 'Ocupado',
    'all_service_payments': 'Todos los Pagos de Servicios',
    'manage_all_service_payments_across_buildings': 'Gestiona todos los pagos de servicios en todos los edificios',
    'tenants_management': 'Gestión de Inquilinos',
    'manage_tenants_and_leases': 'Gestiona inquilinos y contratos',
    'past_tenants': 'Inquilinos Anteriores',
    'lease_ended': 'Contrato Terminado',
    'end_lease_confirm_title': 'Confirmar Fin de Contrato',
    'end_lease_confirm_body': '¿Estás seguro de que deseas finalizar este contrato?',
    'no_past_tenants': 'No hay inquilinos anteriores',
    'sign_up_to_get_started': 'Regístrate para empezar',
    'company_name': 'Nombre de la Empresa',
    'already_have_account': '¿Ya tienes una cuenta?',
    'status_expired_description': 'Este contrato ha caducado. No se pueden aplicar más pagos.',
    'lease_expired_warning': 'Este contrato ha caducado.',
    'tenant_lease_expired_message': 'No se pueden aplicar más pagos.',
    'expired_on': 'Caducó el',
    'manage_tenant': 'Gestionar Inquilino',
    'move_in_pending': 'Mudanza Pendiente',
    'lease_expired': 'Contrato Caducado',
    'create_hold': 'Crear Retención',
    'billing_subscription': 'Facturación y Suscripción',
    'current_plan': 'Plan Actual',
    'subscribe_now': 'Suscribirse Ahora',
    'manage_your_subscription_and_billing': 'Gestiona tu suscripción y facturación',
    'view_payment_logs': 'Ver Registros de Pagos',
    'view_activity_logs': 'Ver Registros de Actividad',
    'view_revenue_report': 'Ver Informe de Ingresos',
    'view_occupancy_report': 'Ver Informe de Ocupación',
    'view_tenant_logs': 'Ver Registros de Inquilinos',
    'login_success': 'Inicio de Sesión Exitoso',
    'logout_success': 'Cierre de Sesión Exitoso',
    'record_payment': 'Registrar Pago',
    'occupied_status': 'Ocupado',
    'financial_status': 'Estado Financiero',
    'occupancy_physical': 'Ocupación Física',
    'unit_indicators': 'Indicadores de Unidad',
    'furnished_unit': 'Unidad Amueblada',
    'lease_expired_short': 'Contrato Caducado',
    'lease_ended_short': 'Contrato Terminado',
    'expired_label': 'Caducado',
    'scheduled_tenants': 'Inquilinos Programados',
    'multiple_leases': 'Múltiples Contratos',

    // Portal Common
    'owner_portal': 'Portal del Propietario',
    'tenant_portal': 'Portal del Inquilino',
    'sign_out': 'Cerrar Sesión',
    'indefinite': 'Indefinido',
    'total_value': 'Valor Total',
    'remaining_balance': 'Saldo Restante',

    // Portal Navigation
    'lease_details': 'Detalles del Contrato',
    'installments': 'Plazos',
    'documents': 'Documentos',
    'announcements': 'Anuncios',

    // Owner Portal / Admin
    'management_fees': 'Comisiones de Gestión',
    'management_fees_subtitle': 'Resumen de todos los ingresos de gestión del arrendador y calendarios.',
    'ledger_subtitle': 'Desglose detallado de tus cuotas de gestión y saldos pendientes.',
    'agreements_subtitle': 'Mira todos tus contratos de gestión y registros de propiedad.',

    // Tenant Portal
    'welcome_back_user': '¡Bienvenido/a de nuevo, {{name}}!',
    'tenancy_overview': "Esto es lo que está pasando hoy con tu arrendamiento.",
    'current_balance': 'Saldo Actual',
    'action_required': 'Acción requerida',
    'account_good_standing': 'Cuenta al día',
    'view_lease_short': 'Ver detalles del contrato',
    'need_repairs': '¿Necesitas Reparaciones?',
    'repairs_subtitle': 'Envía un ticket de mantenimiento en línea rápidamente.',
    'create_request': 'Crear Solicitud',
    'building_news': 'Noticias y Avisos del Edificio',
    'payments_billing': 'Pagos y Facturación',
    'payments_subtitle': 'Gestiona los pagos de tu alquiler y mira tu historial de transacciones.',
    'download_statement': 'Descargar Estado de Cuenta PDF',
    'amount_due': 'Monto Actual a Pagar',
    'due_on': 'Vence el {{date}}',
    'pay_now': 'Pagar Ahora',
    'transaction_history': 'Historial de Transacciones',
    'no_transactions': 'Aún no hay transacciones',
    'first_payment_message': 'Tu historial de pagos aparecerá aquí cuando realices tu primer pago.',
    'unit_display': 'Unidad {{number}}',

    // Tenant Lease
    'lease_details_subtitle': 'Revisa tu contrato de alquiler activo y la información de la propiedad.',
    'lease_signed': 'Contrato Firmado',
    'sign_lease_now': 'Firmar Contrato Ahora',
    'contract_term': 'Duración del Contrato',
    'property_info': 'Información de la Propiedad',
    'landlord_owner': 'Propietario / Arrendador',
    'electronic_signature_recorded': 'Firma Electrónica Registrada',
    'signed_on': 'Firmado el: {{date}}',
    'digital_trace': 'Rastro Digital',
    'legal_disclosure': 'Divulgación Legal',
    'legal_disclosure_text': 'Al firmar este documento de manera electrónica, aceptas que tu firma electrónica tiene la misma validez legal que tu firma manual en este Acuerdo.',
    'electronic_lease_signing': 'Firma Electrónica de Contrato',
    'confirmation_statement': '"Yo, {{name}}, confirmo por la presente que he leído y acepto todos los términos del contrato de alquiler para {{building}}, Unidad {{unit}}."',
    'type_full_name': 'Escribe el Nombre Completo para Firmar',
    'digital_verification_required': 'Se Requiere Verificación de Firma Digital',
    'complete_signing': 'Completar Firma',
    'lease_not_found': 'Contrato No Encontrado',
    'lease_not_found_subtitle': 'Contacta con la administración si crees que esto es un error.',

    // Lease Management
    'renew_lease': 'Renovar Contrato',
    'extend_lease': 'Extender Contrato',
    'current_end_date': 'Fecha de Fin Actual',
    'new_end_date': 'Nueva Fecha de Fin',
    'extend': 'Extender',
    'transfer': 'Transferir',
    'transfer_apartment': 'Transferir Apartamento',
    'current_apartment': 'Apartamento Actual',
    'select_new_apartment': 'Seleccionar Nuevo Apartamento',
    'new_monthly_rent': 'Nuevo Alquiler Mensual',
    'transferring': 'Transfiriendo...',
    'failed_to_transfer_tenant': 'Error al transferir al inquilino',
    'tenant_transferred_success': 'Inquilino transferido con éxito',
    'expired': 'Caducado',
    'select_option': 'Seleccionar Opción',
    'invite_portal': 'Invitar al Portal',
    'tenant_documents': 'Documentos del Inquilino',
    'maintenance_requests': 'Solicitudes de Mantenimiento',
    'add_request': 'Añadir Solicitud',
    'reported_on': 'Reportado el',
    'send_portal_invitation': 'Enviar Invitación al Portal',
    'fully_signed': 'Totalmente Firmado',
    'voided': 'Anulado',
    'upgrade_for_analytics': 'Per le analisi',
    'upgrade_analytics_message': 'Per le analisi',
    'view_plans': 'Vedi i piani',
    'choose_a_plan': 'Scegli un piano',
    'subscribe_with_stripe': 'Abbonati con Stripe',
    'manage_subscription': 'Gestisci l\'abbonamento',
    'subscribe_with_stripe': 'Abbonati con Stripe',
    'upgrade': 'Aggiorna',
    'contact_sales': 'Contatta Vendite',
    'no_payment_history': 'Nessun storico di pagamento',
    'no_subscription_history': 'Nessun storico di abbonamento',

    // ID Documents (Tenant & Owner)
    'id_documents': 'Documentos de Identidad',
    'id_document_front': 'Anverso',
    'id_document_back': 'Reverso',
    'id_document_type': 'Tipo de Documento',
    'id_document_number': 'Número de Documento',
    'id_document_uploaded_at': 'Subido El',
    'select_document_type': 'Seleccionar tipo de documento',
    'national_id': 'DNI / Cédula',
    'passport': 'Pasaporte',
    'driving_license': 'Licencia de Conducir',
    'residence_permit': 'Permiso de Residencia',
    'other_document': 'Otro',
    'document_number_placeholder': 'Ingresa el número de documento (opcional)',
    'front_side': 'Anverso',
    'back_side': 'Reverso',
    'drag_drop_or_click': 'Arrastra y suelta o haz clic para subir',
    'supported_formats': 'Compatible: JPG, PNG, WEBP (máx 5MB)',
    'upload_id_documents': 'Subir Documentos de Identidad',
    'uploading': 'Subiendo...',
    'id_documents_uploaded': 'Documentos de identidad subidos con éxito',
    'id_documents_upload_failed': 'Error al subir los documentos de identidad',
    'delete_document_side': 'Eliminar documento {{side}}',
    'confirm_delete_document': '¿Estás seguro de que deseas eliminar este documento?',
    'document_deleted': 'Documento eliminado con éxito',
    'document_delete_failed': 'Error al eliminar el documento',
    'no_id_documents': 'Aún no se han subido documentos de identidad',
    'view_document': 'Ver Documento',
    'close_preview': 'Cerrar Vista Previa',
    'save_changes': 'Guardar Cambios',
    'pending_upload': 'Subida Pendiente',
    'id_documents_tab': 'Documentos de Identidad',
    'tenant_id_documents': 'Documentos de Identidad del Inquilino',
    'owner_id_documents': 'Documentos de Identidad del Propietario',
    'id_documents_description': 'Subir y gestionar imágenes de documentos de identidad',

    'waitlist': 'Lista d\'attesa',
    'waitlist_management': 'Gestione della lista d\'attente',
    'search_waitlist': 'Cerca per nome, telefono o unità...',
    'waitlist_empty': 'La lista d\'attesa è vuota',
    'no_prospective_tenants_waiting': 'Nessun futuro inquilino sta attualmente aspettando un\'unità.',

    // Waitlist table columns
    'priority': 'Priorità',
    'prospect': 'Potenziale Cliente',
    'desired_unit': 'Unità Desiderata',
    'move_in_preference': 'Data di Trasferimento Preferita',
    'added': 'Aggiunto',
    'rank': '#{{priority}}',
    'process_to_booking': 'Converti in Prenotazione',
    'remove': 'Rimuovi',
    'remove_from_waitlist': 'Rimuovi dalla Lista d\'Attesa',
    'remove_waitlist_confirm': 'Sei sicuro di voler rimuovere questo potenziale cliente dalla lista d\'attesa? Questa azione non può essere annullata.',

    // Waitlist status messages
    'waitlist_processed': 'Potenziale cliente convertito con successo in una prenotazione in sospeso',
    'failed_process_waitlist': 'Errore durante la conversione di questa voce della lista d\'attesa in una prenotazione',
    'entry_removed': 'Voce rimossa dalla lista d\'attesa',
    'failed_remove_entry': 'Errore durante la rimozione della voce dalla lista d\'attesa',

    // Add to Waitlist Modal
    'add_to_waitlist': 'Aggiungi alla Lista d\'Attesa',
    'waitlist_form_subtitle': 'Il potenziale cliente verrà promosso automaticamente quando l\'unità diventerà disponibile',
    'desired_unit': 'Unità Desiderata',
    'prospect_details': 'Dettagli del Potenziale Cliente',
    'prospect_name': 'Nome del Potenziale Cliente',
    'prospect_phone': 'Telefono del Potenziale Cliente',
    'prospect_email': 'Email del Potenziale Cliente',
    'scheduling_priority': 'Pianificazione e Priorità',
    'preferred_move_in_date': 'Data di Trasferimento Preferita',
    'higher_is_first': 'Più alto = primo in coda',
    'priority_hint': 'I potenziali clienti con priorità più alta avanzano nella coda. Il valore predefinito è 0 (FIFO).',
    'priority_range_error': 'La priorità deve essere compresa tra 0 e 10',
    'loading_apartments': 'Caricamento appartamenti...',
    'field_required': 'Questo campo è obbligatorio',
    'adding': 'Aggiunta...',
    'added_to_waitlist': 'Potenziale cliente aggiunto con successo alla lista d\'attesa',
    'failed_add_waitlist': 'Errore durante l\'aggiunta del potenziale cliente alla lista d\'attesa',
    'waitlist_auto_promote_info': 'Quando l\'unità selezionata diventa disponibile, questo potenziale cliente verrà automaticamente convertito in una prenotazione in sospeso in base alla sua priorità e posizione nella coda.',
    'waitlist_notes_placeholder': 'Requisiti speciali, fonte del lead, note dell\'agente...',

    // ── Maintenance Hub ───────────────────────────────────────────
    'maintenance_hub': 'Centro di Manutenzione',
    'track_and_assign_maintenance': 'Traccia le richieste dei locatari e assegna ordini di lavoro ai fornitori',
    'search_requests': 'Cerca per problema, locatario o appartamento...',
    'loading_requests': 'Caricamento richieste...',
    'no_maintenance_found': 'Nessuna richiesta di manutenzione trovata',
    'issue': 'Problema',
    'location': 'Posizione',
    'tenant': 'Locatario',
    'assign_vendor': 'Assegna Fornitore',
    'update_status': 'Aggiorna Stato',
    'status_updated': 'Stato aggiornato con successo',
    'error_updating_status': 'Errore durante l\'aggiornamento dello stato',
    'error_fetching_data': 'Errore durante il recupero dei dati',

    // Work Orders
    'create_work_order': 'Crea Ordine di Lavoro',
    'work_order_created': 'Ordine di lavoro creato e assegnato',
    'error_creating_work_order': 'Errore durante la creazione dell\'ordine di lavoro',
    'select_vendor': 'Seleziona Fornitore',
    'select_a_vendor': 'Seleziona un fornitore',
    'estimated_cost': 'Costo Stimato',
    'scheduled_date': 'Data Prevista',
    'work_description': 'Descrizione del Lavoro',

    // Maintenance statuses
    'open': 'Aperto',
    'in_progress': 'In Corso',
    'completed': 'Completato',
    'cancelled': 'Annullato',

    // ── Vendor Management ─────────────────────────────────────────
    'vendor_management': 'Gestione Fornitori',
    'manage_maintenance_vendors': 'Gestisci fornitori di manutenzione esterni e fornitori di servizi',
    'add_vendor': 'Aggiungi Fornitore',
    'add_new_vendor': 'Aggiungi Nuovo Fornitore',
    'edit_vendor': 'Modifica Fornitore',
    'search_vendors': 'Cerca per nome o categoria...',
    'no_vendors_found': 'Nessun fornitore trovato',
    'vendor_name': 'Nome Fornitore',
    'category': 'Categoria',
    'contact_person': 'Persona di Contatto',
    'vendor_created': 'Fornitore creato con successo',
    'vendor_updated': 'Fornitore aggiornato con successo',
    'vendor_deleted': 'Fornitore eliminato con successo',
    'update_vendor': 'Aggiorna Fornitore',
    'save_vendor': 'Salva Fornitore',
    'confirm_delete_vendor': 'Sei sicuro di voler eliminare questo fornitore? Questa azione non può essere annullata.',
    'error_fetching_vendors': 'Errore durante il recupero dei fornitori',
    'error_saving_vendor': 'Errore durante il salvataggio del fornitore',
    'error_deleting_vendor': 'Errore durante l\'eliminazione del fornitore',
    'confirm_delete_vendor_title': 'Elimina fornitore',
    'vendor_no_email': 'Il fornitore non ha un indirizzo email',
    'vendor_invite_saved': 'Invito salvato!',
    'vendor_invite_link_copied': 'Link di configurazione copiato negli appunti',
    'vendor_invite_failed': "Impossibile inviare l'invito",
    'vendor_invite_portal': 'Invita al portale fornitori',
    'vendor_category_placeholder': 'es. Idraulica, IT, Elettricità',
    'vendor_1099_nec': 'Fornitore 1099-NEC',
    'vendor_1099_desc': 'Rendiconto annuale IRS — fornitori pagati ≥ $600 in compenso a non dipendenti',
    'vendor_1099_disclaimer': "I moduli 1099-NEC sono obbligatori per qualsiasi fornitore (non dipendente) che ha ricevuto ≥ $600 nell'anno solare. La scadenza per la presentazione IRS è generalmente il 31 gennaio. Verificare sempre con un professionista fiscale prima di presentare.",
    '1099_required': '1099 Richiesto',
    'no_vendor_payments_recorded': 'Nessun pagamento fornitore registrato per',

    // ── Contract Templates ────────────────────────────────────────
    'contract_templates': 'Modelli di Contratto',
    'manage_legal_templates_desc': 'Gestisci i quadri legali e le regole automatizzate per i contratti.',
    'create_template': 'Crea Modello',
    'search_templates': 'Cerca tra i modelli...',
    'no_templates_found': 'Nessun modello trovato',
    'create_first_template_desc': 'Inizia creando il tuo primo modello legale di contratto.',
    'no_description_provided': 'Nessuna descrizione fornita.',
    'default_rules': 'Regole Predefinite',
    'failed_to_load_templates': 'Errore durante il caricamento dei modelli',
    'template_deleted_successfully': 'Modello eliminato con successo',
    'failed_to_delete_template': 'Errore durante l\'eliminazione del modello',
    'confirm_delete_template': 'Sei sicuro di voler eliminare questo modello? Questa azione non può essere annullata.',

    // Contract Template Form
    'edit_template': 'Modifica Modello',
    'create_new_template': 'Crea Nuovo Modello',
    'template_details': 'Dettagli del Modello',
    'template_name': 'Nome del Modello',
    'is_active': 'Modello Attivo',
    'legal_text': 'Contenuto del Testo Legale',
    'default_variable_rules': 'Regole Variabili Predefinite',
    'default_rules_desc': 'Definisci le variabili predefinite (come commission_rate) che il creatore utilizzerà.',
    'add_rule': 'Aggiungi Regola',
    'no_default_rules': 'Nessuna regola predefinita definita.',
    'variable_name_placeholder': 'Nome Variabile (es: commission_rate)',
    'default_value_placeholder': 'Valore Predefinito (es: 8)',
    'archive_template': 'Archivia Modello',
    'archive_template_confirm': 'Sei sicuro di voler archiviare questo modello? Non sarà più disponibile per i nuovi contratti.',
    'archive': 'Archivia',
    'template_archived_successfully': 'Modello archiviato con successo',
    'failed_to_archive_template': 'Errore durante l\'archiviazione del modello',
    'template_updated_successfully': 'Modello aggiornato con successo',
    'template_created_successfully': 'Modello creato con successo',
    'failed_to_save_template': 'Errore durante il salvataggio del modello',
    'failed_to_load_template': 'Errore durante il caricamento del modello',

    // Contract types
    'management': 'Gestione',
    'lease': 'Locazione',
    'sale': 'Vendita',
    'lease_progress': 'Avanzamento del contratto',
    'status_open': 'Aperto',
    'status_in_progress': 'In corso',
    'status_completed': 'Completato',
    'status_cancelled': 'Annullato',
    'priority_low': 'Bassa',
    'priority_medium': 'Media',
    'priority_high': 'Alta',
    'priority_urgent': 'Urgente',
    'priority_emergency': 'Emergenza',
    'estimated_cost': 'Costo est.',
    'tenant_portal_submissions': 'Invii del portale inquilini',
    'portal_submission_note': 'File inviati dall\'inquilino tramite il portale self-service',
    'tenant_proof_document': 'Documento d\'identità / Prova',
    'tenant_insurance_document': 'Assicurazione / Certificato',
    'not_submitted': 'Non inviato',
    'saved': 'Salvato',
    'payment_method': 'Metodo',
    'tenant_ledger': 'Libro mastro inquilino',
    'ledger_description': 'Registro immutabile di tutti gli addebiti e i pagamenti. Aggiungere crediti per correggere errori.',
    'ledger_generate_monthly': 'Genera mensile',
    'ledger_add_charge': 'Aggiungi addebito',
    'ledger_add_credit': 'Aggiungi credito',
    'ledger_apply_late_fee': 'Applica penale mora',
    'ledger_late_fee': 'Penale mora',
    'ledger_charge': 'Addebito',
    'ledger_deposit': 'Deposito',
    'ledger_payment': 'Pagamento',
    'ledger_credit': 'Credito',
    'ledger_charge_rent_fee': 'Addebito (Affitto / Spese)',
    'ledger_description_placeholder': 'es. Spese di manutenzione',
    'outstanding_balance': 'Saldo in sospeso',
    'ledger_balance_note': 'Derivato da tutte le voci del libro mastro',
    'ledger_total_entries': 'Totale voci',
    'ledger_no_entries': 'Nessuna voce nel libro mastro',
    'ledger_no_entries_hint': 'Genera il primo addebito mensile o registra un addebito manuale sopra.',
    'ledger_balance_after': 'Saldo dopo',
    'ledger_charge_added': 'Addebito aggiunto al libro mastro',
    'ledger_charge_failed': 'Impossibile aggiungere l\'addebito',
    'ledger_credit_added': 'Credito aggiunto al libro mastro',
    'ledger_credit_failed': 'Impossibile aggiungere il credito',
    'ledger_late_fee_applied': 'Penale mora applicata al libro mastro',
    'ledger_late_fee_failed': 'Impossibile applicare la penale',
    'ledger_monthly_generated': 'Addebito mensile generato',
    'ledger_monthly_failed': 'Impossibile generare l\'addebito',
    'ledger_load_failed': 'Impossibile caricare il libro mastro',
    'created_by': 'Creato da',
    'expired': 'Scaduto',
    'expiring_soon': 'In scadenza',
    'email': 'Email',

    // ── Portale Inquilino ───────────────────────────────────────────────────
    'welcome_back_user': 'Bentornato, {{name}}',
    'tenancy_overview': 'Riepilogo della tua locazione',
    'unit_display': 'Unità {{number}}',
    'current_balance': 'Saldo attuale',
    'action_required': 'Azione richiesta',
    'account_good_standing': 'Conto in regola',
    'lease_ends': 'Fine contratto',
    'view_lease_short': 'Visualizza contratto',
    'need_repairs': 'Richiedi riparazioni',
    'repairs_subtitle': 'Invia una richiesta di manutenzione',
    'create_request': 'Crea richiesta',
    'quick_actions': 'Azioni rapide',
    'pay_now': 'Paga ora',
    'recent_account_activity': 'Attività recente dell\'account',
    'view_ledger': 'Visualizza estratto conto',
    'no_ledger_entries_yet': 'Nessuna voce ancora',
    'active_maintenance': 'Manutenzione attiva',
    'view_all': 'Visualizza tutto',
    'all_clear_maintenance': 'Nessuna richiesta aperta',
    'maintenance_request_default': 'Richiesta di manutenzione',
    'building_news': 'Notizie dell\'edificio',
    'lease_progress': 'Avanzamento del contratto',
    'days_left': '{{days}} giorni rimasti',
    'expires_today': 'Scade oggi!',
    'pct_elapsed': '{{pct}}% trascorso',
    'balance_after': 'saldo:',


    // Pagos
    'failed_to_load_payment_data': 'Error al cargar los datos de pago',
    'failed_to_initiate_payment': 'Error al iniciar el pago',
    'payments_billing': 'Pagos y facturación',
    'payments_billing_subtitle': 'Historial de alquiler, cargos de servicios y libro mayor completo',
    'download_statement': 'Descargar estado de cuenta',
    'current_amount_due': 'Monto actual adeudado',
    'due_on': 'Vence el',
    'view_ledger_hint': '¿Quieres ver cómo se calculó?',
    'view_your_ledger': 'Ver tu libro mayor',
    'in_n_days': 'En {{count}} día',
    'in_n_days_plural': 'En {{count}} días',
    'due_today': '⚡ Vence hoy',
    'all_paid_up': '¡Todo pagado!',
    'tab_rent_payments': 'Pagos de alquiler',
    'tab_service_charges': 'Cargos de servicios',
    'tab_service_charges_due': 'Cargos de servicios ({{count}} pendientes)',
    'tab_account_ledger': 'Libro de cuenta',
    'transaction_history': 'Historial de transacciones',
    'no_transactions': 'Sin transacciones aún',
    'no_transactions_subtitle': 'Tu historial de pagos aparecerá aquí una vez que se registren.',
    'rejected': 'Rechazado',
    'outstanding_service_charges': 'Cargos de servicios pendientes',
    'paid_service_history': 'Historial de servicios pagados',
    'service_charge_default': 'Cargo de servicio',
    'pay': 'Pagar',
    'paid_badge': 'Pagado',
    'no_service_charges': 'Sin cargos de servicio',
    'no_service_charges_subtitle': 'No tienes cargos de servicio en este momento.',
    'account_balance': 'Saldo de la cuenta',
    'ledger_calculated_from': 'Calculado de {{count}} entradas',
    'full_account_statement': 'Estado de cuenta completo',
    'full_account_statement_subtitle': 'Cada cargo y pago de tu cuenta, con saldo corriente.',
    'balance_after_col': 'Saldo después',
    'no_ledger_entries': 'Sin entradas en el libro mayor',
    'no_ledger_entries_subtitle': 'Tu historial financiero aparecerá aquí una vez que se publiquen los cargos.',
    'ledger_type_charge': 'Cargo',
    'ledger_type_late_fee': 'Recargo por mora',
    'ledger_type_deposit': 'Depósito',
    'ledger_type_payment': 'Pago',
    'ledger_type_credit': 'Crédito',
    'payment_success_stripe': '¡Pago exitoso! Tu cuenta se actualizará en breve.',
    'payment_cancelled_stripe': 'Pago cancelado. No se realizó ningún cargo.',
    'online_payments_not_enabled': 'Los pagos en línea aún no están habilitados.',

    // Contrato
    'failed_to_load_lease_details': 'Error al cargar los detalles del contrato',
    'lease_signed_success': '¡Contrato firmado con éxito!',
    'failed_to_sign_lease': 'Error al firmar el contrato',
    'lease_pdf_download_success': 'Contrato PDF descargado con éxito',
    'lease_pdf_download_failed': 'Error al descargar el contrato. Inténtalo de nuevo.',
    'generating': 'Generando…',
    'download_pdf': 'Descargar PDF',
    'download_your_lease': 'Descargar tu contrato firmado en PDF',
    'unit_prefix': 'Unidad',
    'ip_trace': 'Rastreo IP:',
    'integrity_hash': 'Hash de integridad:',
    'signature_graphic': 'Gráfico de firma:',
    'lease_details': 'Detalles del contrato',
    'lease_details_subtitle': 'Tu contrato de arrendamiento activo e información de pago',
    'lease_signed': 'Firmado',
    'sign_lease_now': 'Firmar contrato ahora',
    'contract_term': 'Duración del contrato',
    'start_date': 'Fecha de inicio',
    'end_date': 'Fecha de fin',
    'property_information': 'Información de la propiedad',
    'landlord_owner': 'Propietario / Arrendador',
    'payment_status': 'Estado de pago',
    'payment_required': 'Pago requerido',
    'e_signature_recorded': 'Firma electrónica registrada',
    'signed_on': 'Firmado el',
    'legal_disclosure': 'Divulgación legal',
    'legal_disclosure_text': 'Este contrato de arrendamiento es legalmente vinculante. Al firmar electrónicamente, aceptas todos los términos y condiciones. Asegúrate de haber leído el documento completo antes de firmar.',
    'lease_not_found': 'No se encontró contrato',
    'contact_management_error': 'Por favor, contacta a la administración si crees que esto es un error.',

    // Perfil
    'my_profile': 'Mi perfil',
    'my_profile_subtitle': 'Actualiza tu información de contacto y contraseña',
    'personal_information': 'Información personal',
    'full_name': 'Nombre completo',
    'your_full_name_placeholder': 'Tu nombre completo',
    'phone_placeholder': '+1 234 567 8900',
    'email_placeholder': 'tu@email.com',
    'save_changes': 'Guardar cambios',
    'change_password': 'Cambiar contraseña',
    'current_password': 'Contraseña actual',
    'new_password': 'Nueva contraseña',
    'confirm_new_password': 'Confirmar nueva contraseña',
    'min_8_chars': 'Mín. 8 caracteres',
    'repeat_new_password': 'Repetir nueva contraseña',
    'update_password': 'Actualizar contraseña',
    'updating': 'Actualizando...',
    'passwords_do_not_match': 'Las contraseñas no coinciden',
    'password_min_8': 'La contraseña debe tener al menos 8 caracteres',
    'failed_to_load_profile': 'Error al cargar el perfil',
    'profile_updated': '¡Perfil actualizado con éxito!',
    'password_changed': '¡Contraseña cambiada con éxito!',
    'failed_to_update_profile': 'Error al actualizar el perfil',
    'failed_to_change_password': 'Error al cambiar la contraseña',
    'account_id': 'ID de cuenta',
    'tenant_since': 'Inquilino desde',

    // Inspecciones
    'my_inspections': 'Mis inspecciones',
    'my_inspections_subtitle': 'Informes de inspección de tu unidad',
    'no_inspections_yet': 'Sin inspecciones aún',
    'no_inspections_subtitle': 'Los informes de inspección completados aparecerán aquí.',
    'items_checked': '{{done}}/{{total}} elementos revisados',
    'inspection_items': 'Elementos de inspección',
    'general_notes': 'Notas generales',
    'failed_to_load_inspections': 'Error al cargar las inspecciones',
    'inspection_type_move_in': 'Entrada',
    'inspection_type_move_out': 'Salida',
    'inspection_type_periodic': 'Periódica',
    'inspection_type_maintenance': 'Mantenimiento',
    'inspection_status_completed': 'Completada',
    'inspection_status_signed': 'Firmada',
    'inspection_status_draft': 'Borrador',

    // Servicios
    'service_charges_title': 'Cargos de servicios',
    'service_charges_subtitle': 'Cuotas mensuales de servicios del edificio para tu unidad',
    'total_charges': 'Total de cargos',
    'outstanding_balance_label': 'Saldo pendiente',
    'service_charges_year': 'Cargos de servicios — {{year}}',
    'no_service_charges_year': 'Sin cargos de servicio para {{year}}',
    'no_service_charges_year_hint': 'Los cargos aparecerán aquí cuando sean generados por tu administrador.',
    'paid_on': 'Pagado el {{date}}',
    'unpaid': 'No pagado',
    'pay_online': 'Pagar en línea',
    'service_paid_success': '¡Cargo de servicio pagado con éxito!',
    'payment_canceled': 'Pago cancelado.',
    'failed_to_load_service_charges': 'Error al cargar los cargos de servicios',

    // Mensajes
    'management_team': 'Equipo de administración',
    'management_team_subtitle': 'Mensaje directo con la administración de la propiedad',
    'message_empty_state': 'Envía un mensaje para contactar a la administración.',
    'message_placeholder': 'Escribe un mensaje a la administración...',
    'failed_to_load_messages': 'Error al cargar los mensajes',
    'failed_to_send_message': 'Error al enviar el mensaje',

    'portfolio_summary': 'Riepilogo del portafoglio',
    'portfolio_subtitle': 'Metriche di performance in tempo reale per {{name}}.',
    'portfolio_statement': 'Estratto conto portafoglio',
    'total_units': 'Unità totali',
    'occupancy_rate': 'Tasso di occupazione',
    'active_leases': '{{count}} contratti attivi',
    'monthly_revenue': 'Entrate mensili',
    'vacant_units': 'Unità libere',
    'installment_summary': 'Riepilogo rate',
    'view_detailed_ledger': 'Visualizza libro mastro dettagliato',
    'outstanding': 'In sospeso',
    'across_installments': 'Su {{count}} rate',
    'actions_required': '{{count}} azioni immediate richieste',
    'proceed_to_payments': 'Vai ai pagamenti',
    'revenue_performance': 'Performance delle entrate (ultimi 6 mesi)',
    'no_revenue_data': 'Nessun dato sulle entrate',
    'portfolio_distribution': 'Distribuzione del portafoglio',
    'no_building_data': 'Nessun dato edificio trovato',
    'occupied_label': 'OCCUPATO',
    'ready_to_scale': 'Pronto a crescere?',
    'ready_to_scale_subtitle': 'Gestisci le tue proprietà con la massima visibilità.',
    'financials': 'Finanze',
    'approvals': 'Approvazioni',
    'failed_to_download_statement': 'Impossibile scaricare l\'estratto conto',
    'my_properties': 'Le mie proprietà',
    'my_properties_subtitle': 'Panoramica di tutte le unità nel tuo portafoglio gestionale.',
    'portfolio_empty': 'Portafoglio vuoto',
    'portfolio_empty_subtitle': 'Nessuna unità è attualmente assegnata al tuo account.',
    'floor_prefix': 'Piano',
    'current_rent': 'Affitto corrente',
    'per_month_short': '/mese',
    'sqm': 'mq',
    'maintenance_approvals': 'Approvazioni manutenzione',
    'maintenance_approvals_subtitle': 'Esamina e approva le richieste di riparazione degli inquilini.',
    'no_maintenance_requests': 'Nessuna richiesta di manutenzione',
    'no_maintenance_subtitle': 'Tutte le tue proprietà sono attualmente ben mantenute.',
    'pending_approval': 'In attesa di approvazione',
    'approved_in_progress': 'Approvato / In corso',
    'rejected_cancelled': 'Rifiutato/Annullato',
    'above_threshold': 'Sopra la soglia di ${{amount}}',
    'high_priority': 'Alta priorità',
    'medium_priority': 'Priorità media',
    'low_priority': 'Bassa priorità',
    'est_cost': 'Costo stimato',
    'approve': 'Approva',
    'reject': 'Rifiuta',
    'request_status_updated': 'Stato della richiesta aggiornato',
    'failed_to_update_request': 'Impossibile aggiornare lo stato della richiesta',
    'failed_to_load_maintenance': 'Impossibile caricare le richieste di manutenzione',
    'failed_to_load_properties': 'Impossibile caricare le tue proprietà',
    'financial_overview': 'Panoramica finanziaria',
    'financial_subtitle': 'Monitora le entrate generate dai tuoi inquilini in tutte le proprietà.',
    'no_financial_data': 'Nessun dato finanziario',
    'no_payments_message': 'Attualmente non ci sono pagamenti registrati per il tuo portafoglio.',
    'recent_payments': 'Pagamenti recenti',
    'overdue_payments': 'Pagamenti scaduti',
    'property_tenant': 'Proprietà / Inquilino',
    'gross_amount': 'Importo lordo',
    'commission': 'Commissione',
    'net_amount': 'Importo netto',
    'since': 'Dal',
    'amount_owed': 'Importo dovuto',
    'management_commission': 'Commissione di gestione',
    'failed_to_load_financials': 'Impossibile caricare i dati finanziari',
    'statement_downloaded': 'Estratto conto per {{month}} {{year}} scaricato!',
    'member_since': 'Membro dal',
    'saving': 'Salvataggio...',
    'owner_messages_title': 'Amministrazione immobiliare',
    'owner_messages_subtitle': 'Messaggio diretto con il team di gestione',

    'owner_service_charges': 'Oneri di servizio',
    'owner_service_charges_subtitle': 'Spese mensili di servizio per le tue unità libere',
    'owner_service_info': 'Gli oneri di servizio si applicano solo alle tue unità <strong>libere</strong>. Le unità occupate vengono fatturate direttamente all\'inquilino.',
    'total_charges': 'Totale oneri',
    'outstanding_balance': 'Saldo in sospeso',
    'no_service_charges_year': 'Nessun onere di servizio per il {{year}}',
    'no_service_charges_subtitle': 'Gli oneri per le unità libere appariranno qui una volta generati.',
    'paid_on': 'Pagato il {{date}}',
    'pay_online': 'Paga online',
    'service_charge_paid': 'Onere di servizio pagato con successo!',
    'unpaid': 'Non pagato',
    'my_agreements': 'I miei accordi',
    'agreements_subtitle': 'Visualizza tutti i tuoi contratti di gestione e i documenti di proprietà.',
    'no_active_agreements': 'Nessun accordo attivo',
    'no_contracts_message': 'Non hai ancora contratti di gestione registrati nel nostro sistema.',
    'total_value': 'Valore totale',
    'remaining': 'Rimanente',
    'indefinite': 'Indefinito',
    'sign_now': 'Firma ora',
    'failed_to_load_agreements': 'Impossibile caricare gli accordi',
    'financial_ledger': 'Libro mastro finanziario',
    'ledger_subtitle': 'Dettaglio delle rate delle commissioni di gestione e dei saldi in sospeso.',
    'total_outstanding': 'Totale in sospeso',
    'no_installments': 'Nessuna rata trovata nel tuo libro mastro.',
    'settled': 'Saldato',
    'pay_amount': 'Paga {{amount}}',
    'failed_to_load_installments': 'Impossibile caricare il piano delle rate',
    'failed_to_initiate_payment': 'Impossibile avviare il pagamento',
    'error_connecting_payment': 'Errore di connessione al provider di pagamento',
    'payment_success_msg': 'Pagamento completato con successo!',
    'payment_canceled_msg': 'Pagamento annullato.',
    'welcome_user': 'Benvenuto, {{name}}!',
    'owner_portal': 'Portale Proprietario',
    'tenant_portal': 'Portale Inquilino',
    'owner': 'Proprietario',
    'tenant': 'Inquilino',
    'core': 'Principale',
    'properties_&_contracts': 'Proprietà & Contratti',
    'financial': 'Finanziario',
    'financial_&_lease': 'Finanziario & Affitto',
    'Dashboard': 'Dashboard',
    'Properties': 'Proprietà',
    'Contracts': 'Contratti',
    'Installments': 'Rate',
    'Service Charges': 'Oneri di servizio',
    'Financials': 'Finanze',
    'Maintenance': 'Manutenzione',
    'Payments': 'Pagamenti',
    'Lease Details': 'Dettagli affitto',
    'Inspections': 'Ispezioni',
    'Profile': 'Profilo',
    'documents': 'Documenti',
    'announcements': 'Annunci',
    'messages': 'Messaggi',
    'Messages': 'Messaggi',
    'maintenance_subtitle': 'Invia e tieni traccia di tutte le tue richieste di manutenzione in un unico posto.',
    'new_request': 'Nuova richiesta',
    'report_an_issue': 'Segnala un problema',
    'issue_summary': 'Riepilogo del problema',
    'issue_summary_placeholder': 'Es.: Perdita d’acqua nel bagno',
    'urgency_level': 'Livello di urgenza',
    'low_urgency': 'Basso – Non urgente',
    'normal_urgency': 'Normale – Richiede attenzione',
    'high_urgency': 'Alto – Influisce sulla vita quotidiana',
    'emergency_urgency': 'Emergenza – Azione immediata necessaria',
    'describe_the_problem': 'Descrivi il problema',
    'describe_problem_placeholder': 'Descrivi il problema nel modo più dettagliato possibile...',
    'upload_photo_optional': 'Carica una foto (facoltativo)',
    'add_photo': 'Aggiungi foto',
    'photo_upload_tip': 'Una foto ci aiuta a risolvere il tuo problema più velocemente.',
    'photo_upload_specs': 'JPG, PNG o WEBP. Max 5 MB.',
    'emergency_contact_warning': 'Per emergenze che mettono a rischio la vita, chiama subito i servizi di emergenza. Tratteremo questa richiesta con la massima priorità.',
    'processing': 'Elaborazione…',
    'submit_request': 'Invia richiesta',
    'ongoing_past_requests': 'Richieste in corso e passate',
    'submitted': 'Inviato',
    'in_progress': 'In corso',
    'completed': 'Completato',
    'request_cancelled': 'Richiesta annullata',
    'all_clear': 'Tutto a posto!',
    'no_maintenance_on_record': 'Nessuna richiesta di manutenzione registrata. Tutto sembra ottimo!',
    'resolved_on': 'Risolto il {{date}}',
    'failed_to_load_maintenance_requests': 'Impossibile caricare le richieste di manutenzione',
    'failed_to_submit_request': 'Impossibile inviare la richiesta',
    'photo_size_limit_error': 'La foto deve essere inferiore a 5 MB',
    'request_submitted_success': 'Richiesta inviata con successo',
    'low': 'Basso',
    'normal': 'Normale',
    'high': 'Alto',
    'emergency': 'Emergenza',
    'id': 'ID',
    'announcements_subtitle': 'Rimani aggiornato sulle ultime notizie della tua gestione immobiliare.',
    'no_announcements_title': 'Nessun annuncio',
    'no_announcements_subtitle': 'Controlla più tardi per gli aggiornamenti della gestione.',
    'posted_by': 'Pubblicato da {{name}}',
    'failed_to_load_announcements': 'Impossibile caricare gli annunci',
    'documents_verification': 'Documenti & Verifica',
    'documents_verification_subtitle': 'Carica e gestisci i documenti richiesti per un\'esperienza di affitto serena.',
    'supported_formats_specs': 'Formati accettati: PDF, JPG, JPEG, PNG. Max 5 MB per documento.',
    'identification_proof': 'Documento d\'identità',
    'identification_proof_desc': 'Documento rilasciato da un\'autorità: passaporto, carta d\'identità o patente.',
    'renters_insurance': 'Assicurazione affittuario',
    'renters_insurance_desc': 'Certificato assicurativo valido che copre il tuo appartamento.',
    'verified': 'Verificato',
    'missing': 'Mancante',
    'pdf_document': 'Documento PDF',
    'view_full_size': 'Visualizza a schermo intero',
    'replace': 'Sostituisci',
    'upload_file': 'Carica file',
    'need_help_verification': 'Hai bisogno di aiuto con la verifica?',
    'need_help_verification_subtitle': 'Se hai difficoltà a caricare i documenti, contatta il nostro team di supporto.',
    'contact_support': 'Contatta il supporto',
    'failed_to_load_document_status': 'Impossibile caricare lo stato dei documenti',
    'file_size_large_error': 'File troppo grande. Max 5 MB.',
    'document_uploaded_success': 'Documento caricato con successo',
    'failed_to_upload_document': 'Impossibile caricare il documento',
    'my_inspections': 'Le mie ispezioni',
    'my_inspections_subtitle': 'Visualizza tutte le ispezioni relative alla tua locazione.',
    'no_inspections_yet': 'Nessuna ispezione',
    'no_inspections_subtitle': 'I rapporti di ispezione appariranno qui una volta completati.',
    'failed_to_load_inspections': 'Impossibile caricare le ispezioni',
    'inspection_type_move_in': 'Ingresso',
    'inspection_type_move_out': 'Uscita',
    'inspection_type_periodic': 'Periodica',
    'inspection_type_maintenance': 'Manutenzione',
    'inspection_status_completed': 'Completato',
    'inspection_status_signed': 'Firmato',
    'inspection_status_draft': 'Bozza',
    'unit_prefix': 'Unità',
    'items_checked': '{{done}} / {{total}} elementi verificati',
    'inspection_items': 'Elementi ispezionati',
    'general_notes': 'Note generali',
    'management_team': 'Team di gestione',
    'management_team_subtitle': 'Linea diretta con la gestione del tuo edificio',
    'message_empty_state': 'Nessun messaggio ancora. Inizia la conversazione!',
    'failed_to_load_messages': 'Impossibile caricare i messaggi',
    'failed_to_send_message': 'Impossibile inviare il messaggio',
    'message_placeholder': 'Scrivi un messaggio...',
    'lease_details_subtitle': 'Rivedi il tuo contratto di affitto, lo stato dei pagamenti e la firma digitale.',
    'lease_not_found': 'Nessun contratto trovato',
    'contact_management_error': 'Contatta la gestione del tuo edificio per assistenza.',
    'lease_signed': 'Firmato',
    'download_your_lease': 'Scarica il contratto in PDF',
    'generating': 'Generazione...',
    'download_pdf': 'Scarica PDF',
    'sign_lease_now': 'Firma ora',
    'contract_term': 'Durata contratto',
    'property_information': 'Proprietà & Proprietario',
    'landlord_owner': 'Proprietario',
    'payment_status': 'Stato pagamento',
    'current_balance': 'Saldo attuale',
    'payment_required': 'Pagamento richiesto',
    'account_good_standing': 'Conto in regola',
    'lease_signed_success': 'Contratto firmato con successo!',
    'failed_to_sign_lease': 'Impossibile firmare il contratto',
    'lease_pdf_download_success': 'PDF scaricato con successo',
    'lease_pdf_download_failed': 'Impossibile scaricare il PDF',
    'e_signature_recorded': 'Firma elettronica registrata',
    'signed_on': 'Firmato il',
    'ip_trace': 'IP',
    'integrity_hash': 'Hash',
    'signature_graphic': 'La tua firma',
    'legal_disclosure': 'Informativa legale',
    'legal_disclosure_text': 'Questo contratto di affitto è un documento legalmente vincolante. Firmando elettronicamente, accetti tutti i termini e le condizioni del contratto.',
    'payments_billing': 'Pagamenti & Fatturazione',
    'payments_billing_subtitle': 'Tieni traccia dei tuoi pagamenti, spese e estratto conto.',
    'download_statement': 'Scarica estratto conto',
    'current_amount_due': 'Importo attualmente dovuto',
    'due_on': 'Scadenza',
    'view_ledger_hint': 'Visualizza la cronologia completa nel',
    'view_your_ledger': 'Estratto conto',
    'all_paid_up': 'Tutto pagato!',
    'tab_rent_payments': 'Pagamenti affitto',
    'tab_service_charges': 'Spese condominiali',
    'tab_service_charges_due': 'Spese ({{count}} da pagare)',
    'tab_account_ledger': 'Estratto conto',
    'transaction_history': 'Storico transazioni',
    'no_transactions': 'Nessuna transazione',
    'no_transactions_subtitle': 'La cronologia dei pagamenti apparirà qui.',
    'outstanding_service_charges': 'Spese in sospeso',
    'service_charge_default': 'Spesa condominiale',
    'paid_service_history': 'Storico spese pagate',
    'paid_badge': 'Pagato',
    'no_service_charges': 'Nessuna spesa condominiale',
    'no_service_charges_subtitle': 'Nessuna spesa è stata addebitata al tuo conto.',
    'account_balance': 'Saldo conto',
    'ledger_calculated_from': 'Calcolato su {{count}} transazioni',
    'full_account_statement': 'Estratto conto completo',
    'full_account_statement_subtitle': 'Tutti gli addebiti e pagamenti del tuo conto',
    'no_ledger_entries': 'Nessuna voce',
    'no_ledger_entries_subtitle': 'L\'attività del tuo conto apparirà qui.',
    'balance_after_col': 'Saldo dopo',
    'ledger_type_charge': 'Addebito',
    'ledger_type_late_fee': 'Mora',
    'ledger_type_deposit': 'Deposito',
    'ledger_type_payment': 'Pagamento',
    'ledger_type_credit': 'Credito',
    'payment_success_stripe': 'Pagamento riuscito! Il tuo conto è stato aggiornato.',
    'payment_cancelled_stripe': 'Pagamento annullato. Nessun addebito.',
    'online_payments_not_enabled': 'I pagamenti online non sono abilitati per il tuo account.',
    'failed_to_initiate_payment': 'Impossibile avviare il pagamento',
    'failed_to_load_payment_data': 'Impossibile caricare i dati di pagamento',
    'my_profile': 'Il mio profilo',
    'my_profile_subtitle': 'Gestisci le tue informazioni personali e la sicurezza dell\'account.',
    'personal_information': 'Informazioni personali',
    'full_name': 'Nome completo',
    'your_full_name_placeholder': 'Il tuo nome completo',
    'phone_placeholder': '+39 XXX XXX XXXX',
    'email_placeholder': 'tu@esempio.it',
    'saving': 'Salvataggio...',
    'save_changes': 'Salva modifiche',
    'change_password': 'Cambia password',
    'current_password': 'Password attuale',
    'new_password': 'Nuova password',
    'confirm_new_password': 'Conferma nuova password',
    'min_8_chars': 'Min. 8 caratteri',
    'repeat_new_password': 'Ripeti nuova password',
    'passwords_do_not_match': 'Le password non coincidono',
    'updating': 'Aggiornamento...',
    'update_password': 'Aggiorna password',
    'account_id': 'ID account',
    'tenant_since': 'Inquilino dal',
    'failed_to_load_profile': 'Impossibile caricare il profilo',
    'profile_updated': 'Profilo aggiornato con successo',
    'failed_to_update_profile': 'Impossibile aggiornare il profilo',
    'password_changed': 'Password cambiata con successo',
    'failed_to_change_password': 'Impossibile cambiare la password',
    'password_min_8': 'La password deve contenere almeno 8 caratteri',
    'service_charges_title': 'Spese condominiali',
    'service_charges_subtitle': 'Visualizza e paga le tue spese condominiali.',
    'total_charges': 'Totale spese',
    'outstanding_balance_label': 'In sospeso',
    'service_charges_year': 'Spese — {{year}}',
    'no_service_charges_year': 'Nessuna spesa per {{year}}',
    'no_service_charges_year_hint': 'Prova a selezionare un anno diverso.',
    'paid_on_date': 'Pagato il {{date}}',
    'unpaid_label': 'Non pagato',
    'pay_online': 'Paga online',
    'service_paid_success': 'Spesa pagata con successo!',
    'payment_canceled': 'Pagamento annullato.',
    'failed_to_load_service_charges': 'Impossibile caricare le spese condominiali',
    'portfolio_summary': 'Riepilogo portafoglio',
    'portfolio_subtitle': 'Bentornato, {{name}}. Ecco il riepilogo del tuo portafoglio immobiliare.',
    'portfolio_statement': 'Estratto portafoglio',
    'total_units': 'Unità totali',
    'occupancy_rate': 'Tasso di occupazione',
    'active_leases': '{{count}} contratti attivi',
    'monthly_revenue': 'Entrate mensili',
    'vacant_units': 'Unità vuote',
    'installment_summary': 'Riepilogo rate',
    'view_detailed_ledger': 'Visualizza registro dettagliato',
    'outstanding': 'In sospeso',
    'across_installments': 'Su {{count}} rate',
    'overdue': 'Scaduto',
    'actions_required': '{{count}} azioni richieste',
    'proceed_to_payments': 'Vai ai pagamenti',
    'revenue_performance': 'Andamento entrate',
    'no_revenue_data': 'Nessun dato sulle entrate disponibile',
    'portfolio_distribution': 'Distribuzione portafoglio',
    'no_building_data': 'Nessun dato edificio disponibile',
    'occupied_label': 'occupato',
    'ready_to_scale': 'Pronto a gestire il tuo portafoglio?',
    'ready_to_scale_subtitle': 'Accedi agli strumenti essenziali per le tue proprietà',
    'failed_to_load_dashboard_data': 'Impossibile caricare i dati della dashboard',
    'failed_to_download_statement': 'Impossibile scaricare l\'estratto',
    'owner_messages_title': 'Messaggi',
    'owner_messages_subtitle': 'Comunicazioni dirette con la gestione dell\'edificio',
    'my_properties': 'Le mie proprietà',
    'my_properties_subtitle': 'Visualizza tutti gli appartamenti e le unità del tuo portafoglio.',
    'portfolio_empty': 'Nessuna proprietà trovata',
    'portfolio_empty_subtitle': 'Nessun appartamento è ancora stato assegnato al tuo portafoglio. Contatta il tuo gestore.',
    'floor_prefix': 'Piano',
    'sqm': 'mq',
    'current_rent': 'Affitto attuale',
    'per_month_short': '/mese',
    'failed_to_load_properties': 'Impossibile caricare le proprietà',
    'maintenance_approvals': 'Approvazioni manutenzione',
    'maintenance_approvals_subtitle': 'Esamina e approva o rifiuta le richieste di manutenzione degli inquilini.',
    'failed_to_load_maintenance': 'Impossibile caricare le richieste di manutenzione',
    'request_status_updated': 'Stato della richiesta aggiornato con successo',
    'failed_to_update_request': 'Impossibile aggiornare la richiesta di manutenzione',
    'pending_approval': 'In attesa di approvazione',
    'approved_in_progress': 'Approvato / In corso',
    'rejected_cancelled': 'Rifiutato / Annullato',
    'above_threshold': 'Sopra la soglia (${{amount}})',
    'no_maintenance_requests': 'Nessuna richiesta di manutenzione',
    'no_maintenance_subtitle': 'Le richieste di manutenzione degli inquilini che richiedono la tua approvazione appariranno qui.',
    'financial_overview': 'Panoramica finanziaria',
    'financial_subtitle': 'Monitora le entrate generate dai tuoi inquilini su tutte le proprietà.',
    'no_financial_data': 'Nessun dato finanziario',
    'no_payments_message': 'Non ci sono attualmente pagamenti registrati per il tuo portafoglio.',
    'recent_payments': 'Pagamenti recenti',
    'property_tenant': 'Proprietà / Inquilino',
    'gross_amount': 'Importo lordo',
    'commission': 'Commissione',
    'net_amount': 'Importo netto',
    'overdue_payments': 'Pagamenti scaduti',
    'failed_to_load_financials': 'Impossibile caricare i dati finanziari',
    'statement_downloaded': 'Estratto di {{month}} {{year}} scaricato',
    'management_commission': 'Commissione di gestione',
    'unit_display': 'Unità {{number}}',
    'since': 'Dal',
    'amount_owed': 'Importo dovuto',
    'financial_ledger': 'Registro finanziario',
    'ledger_subtitle': 'Tutti i pagamenti rateali sui tuoi contratti immobiliari.',
    'total_outstanding': 'Totale in sospeso',
    'installment': 'Rata',
    'due_date': 'Scadenza',
    'action': 'Azione',
    'partial': 'Parziale',
    'owner_contract': 'Contratto proprietario',
    'pay_amount': 'Paga {{amount}}',
    'settled': 'Saldato',
    'no_installments': 'Nessuna rata trovata.',
    'failed_to_load_installments': 'Impossibile caricare le rate',
    'payment_success_msg': 'Pagamento riuscito! Grazie.',
    'payment_canceled_msg': 'Pagamento annullato.',
    'error_connecting_payment': 'Errore di connessione al sistema di pagamento',
    'owner_service_charges': 'Spese condominiali',
    'owner_service_charges_subtitle': 'Visualizza e paga le spese fatturate per le tue proprietà.',
    'owner_service_info': 'Le spese condominiali sono fatturate dalla gestione dell\'edificio. Salda gli importi in sospeso tempestivamente per evitare interruzioni del servizio.',
    'outstanding_balance': 'Saldo in sospeso',
    'service_charge_paid': 'Spesa pagata con successo!',
    'paid_on': 'Pagato il {{date}}',
    'unpaid': 'Non pagato',
    'my_agreements': 'I miei accordi',
    'agreements_subtitle': 'Rivedi e firma i tuoi contratti di gestione immobiliare.',
    'no_active_agreements': 'Nessun accordo trovato',
    'no_contracts_message': 'Al momento non hai contratti registrati. Contatta il tuo gestore dell\'edificio.',
    'management_agreement': 'Contratto di gestione',
    'total_value': 'Valore totale',
    'remaining': 'Rimanente',
    'failed_to_load_agreements': 'Impossibile caricare gli accordi',
    'rent': 'Affitto',
    'download_pdf': 'Scarica PDF',
    'generating': 'Generazione…',
    'announcements_manager': 'Annunci',
    'announcements_manager_subtitle': 'Pubblica e gestisci annunci per inquilini, proprietari o edifici specifici.',
    'new_announcement': 'Nuovo annuncio',
    'publish_announcement': 'Pubblica',
    'publishing': 'Pubblicazione…',
    'all_announcements': 'Tutti gli annunci',
    'announcement_created': 'Annuncio pubblicato con successo!',
    'announcement_create_failed': 'Pubblicazione non riuscita.',
    'announcement_deleted': 'Annuncio eliminato.',
    'announcement_delete_failed': 'Eliminazione non riuscita.',
    'announcement_delete_confirm': 'Eliminare questo annuncio? L\'azione è irreversibile.',
    'announcement_fields_required': 'Titolo e contenuto sono obbligatori.',
    'announcement_building_required': 'Seleziona un edificio.',
    'announcement_title_placeholder': 'es. Manutenzione idrica programmata lunedì',
    'announcement_content_placeholder': 'Scrivi qui il tuo messaggio…',
    'target_audience': 'Pubblico destinatario',
    'audience_all': 'Tutti',
    'audience_tenants': 'Solo inquilini',
    'audience_owners': 'Solo proprietari',
    'audience_building': 'Edificio specifico',
    'select_building': 'Seleziona edificio',
    'select_building_placeholder': '— scegli un edificio —',
    'no_announcements_yet': 'Nessun annuncio ancora',
    'no_announcements_yet_subtitle': 'Clicca "Nuovo annuncio" per inviare il tuo primo messaggio.',
    'announcements_owner_subtitle': 'Leggi le ultime notizie e aggiornamenti dal tuo gestore immobiliare.',
    'announcements_check_back': 'Torna più tardi per le notizie e gli aggiornamenti del tuo gestore.',
    'posted_by': 'Pubblicato da {{name}}',

    // ── Rapporto commissioni di gestione ──────────────────────────────────────
    'management_fee_report': 'Rapporto commissioni di gestione',
    'management_fee_report_subtitle': 'Monitoraggio degli incassi delle rate dei proprietari e analisi dei ritardi',
    'ledger_activity_report': 'Report attività libro mastro',
    'ledger_activity_report_subtitle': 'Tutte le voci del libro mastro — addebiti, pagamenti, more, crediti e depositi',
    'ledger_type_charge':   'Addebito',
    'ledger_type_late_fee': 'Mora',
    'ledger_type_deposit':  'Deposito',
    'ledger_type_payment':  'Pagamento',
    'ledger_type_credit':   'Credito',
    'ledger_net_balance':   'Saldo Dovuto',
    'feature_locked': 'Funzione bloccata',
    'mgmt_fee_analytics_required': 'I report sulle commissioni di gestione richiedono il piano Analytics.',
    'upgrade': 'Aggiorna',
    'year': 'Anno',
    'month': 'Mese',
    'all_months': 'Tutti i mesi',
    'all_owners': 'Tutti i proprietari',
    'all_statuses': 'Tutti gli stati',
    'status_paid': 'Pagato',
    'status_pending_upcoming': 'In sospeso (in arrivo)',
    'status_overdue': 'Scaduto',
    'status_partial': 'Parziale',
    'status_cancelled_label': 'Annullato',
    'clear_filters': 'Cancella filtri',
    'print_pdf': 'Stampa / PDF',
    'export_csv': 'Esporta CSV',
    'exporting': 'Esportazione…',
    'total_expected': 'Totale previsto',
    'total_collected': 'Totale incassato',
    'overdue_balance': 'Saldo scaduto',
    'collection_rate': 'Tasso di incasso',
    'n_installments': '{{count}} rate',
    'n_paid': '{{count}} pagato',
    'n_overdue_installments': '{{count}} rate scadute',
    'n_upcoming': '{{count}} in arrivo',
    'monthly_breakdown': 'Dettaglio mensile — {{year}}',
    'monthly_breakdown_filtered': 'Dettaglio mensile — {{year}} (filtrato a {{month}})',
    'chart_expected': 'Previsto',
    'chart_collected': 'Incassato',
    'chart_overdue': 'Scaduto',
    'no_installment_data_year': 'Nessun dato sulle rate per {{year}}',
    'tooltip_expected': 'Previsto:',
    'tooltip_collected': 'Incassato:',
    'tooltip_overdue': 'Scaduto:',
    'all_installments': 'Tutte le rate',
    'n_records': '{{count}} record',
    'n_records_plural': '{{count}} record',
    'page_of': 'pagina {{page}}/{{total}}',
    'no_installments_found': 'Nessuna rata trovata',
    'try_adjusting_filters': 'Prova ad aggiustare i filtri.',
    'col_owner': 'Proprietario',
    'col_apt': 'App.',
    'col_building': 'Edificio',
    'col_due_date': 'Data di scadenza',
    'col_amount': 'Importo',
    'col_paid': 'Pagato',
    'col_balance': 'Saldo',
    'col_status': 'Stato',
    'col_days_late': 'Giorni di ritardo',
    'totals_all_pages': 'Totali (tutte le pagine):',
    'previous': '← Precedente',
    'next': 'Successivo →',
    'page_x_of_y': 'Pagina {{page}} di {{total}} ({{count}} totali)',
    'overdue_aging_title': 'Rate scadute — Analisi dei ritardi',
    'col_aging': 'Anzianità',
    'all_installments_up_to_date': 'Tutte le rate sono aggiornate!',
    'no_overdue_found': 'Nessuna rata di commissione di gestione scaduta trovata.',
    'total_overdue': 'Totale scaduto:',
    'n_days': '{{count}} giorni',
    'aging_1_30': '1–30 giorni',
    'aging_31_60': '31–60 giorni',
    'aging_61_90': '61–90 giorni',
    'aging_90_plus': '90+ giorni',
    'badge_paid': 'Pagato',
    'badge_partial': 'Parziale',
    'badge_pending': 'In sospeso',
    'badge_overdue': 'Scaduto',
    'badge_cancelled': 'Annullato',
    'failed_to_load_mgmt_fee_report': 'Impossibile caricare il rapporto sulle commissioni di gestione',
    'export_failed': 'Esportazione non riuscita',
    'export_downloaded_label': 'Scaricato: {{label}}',

    // Report Templates
    'report_templates': 'Modelli di Rapporto',
    'report_templates_subtitle': 'Crea e gestisci configurazioni di report riutilizzabili',
    'create_template': 'Nuovo Modello',
    'create_first_template': 'Crea Primo Modello',
    'template_name': 'Nome Modello',
    'template_description': 'Descrizione',
    'template_config': 'Configurazione (JSON)',
    'no_templates': 'Nessun Modello di Rapporto',
    'no_templates_message': 'Salva le configurazioni di report usate frequentemente come modelli riutilizzabili.',
    'template_created': 'Modello creato con successo',
    'template_updated': 'Modello aggiornato con successo',
    'template_deleted': 'Modello eliminato',
    'delete_template_title': 'Elimina Modello',
    'delete_template_message': 'Sei sicuro di voler eliminare "{{name}}"? Questa azione non può essere annullata.',



    // Email Template Form
    'et_new_title': 'Nuovo modello e-mail',
    'et_edit_title': 'Modifica modello e-mail',
    'et_basic_info': 'Informazioni di base',
    'et_template_name': 'Nome modello *',
    'et_template_name_placeholder': 'es. Promemoria affitto mensile',
    'et_trigger_event': 'Evento di attivazione',
    'et_description': 'Descrizione',
    'et_description_placeholder': 'Nota interna opzionale',
    'et_subject_line': 'Riga dell\'oggetto *',
    'et_subject_placeholder': 'es. Il tuo affitto di ${{rent_amount}} scade il {{due_date}}',
    'et_html_body': 'Corpo HTML',
    'et_editor': 'Editor',
    'et_preview': 'Anteprima',
    'et_quick_insert': 'Inserimento rapido variabili',
    'et_update_btn': 'Aggiorna modello',
    'et_create_btn': 'Crea modello',
    'et_created': 'Modello creato',
    'et_updated': 'Modello aggiornato',
    'et_failed_load': 'Impossibile caricare il modello',
    'et_save_failed': 'Salvataggio non riuscito',
    'et_fields_required': 'Nome, oggetto e corpo sono obbligatori',
    'issue_utility_bill': 'Emetti Fattura Utenze',
    'tenant_billing_assignment': 'Assegnazione Inquilino e Fatturazione',
    'select_tenant': 'Seleziona Inquilino',
    'search_tenant_placeholder': 'Cerca per nome o numero appartamento...',
    'utility_details': 'Dettagli Utenza',
    'period_month': 'Mese',
    'period_year': 'Anno',
    'due_date': 'Data di Scadenza',
    'posting_options': 'Opzioni di Registrazione',
    'charge_immediately': 'Addebita Immediatamente sul Registro',
    'charge_immediately_desc_on': 'L\'importo verrà registrato sul saldo dell\'inquilino non appena salvato.',
    'charge_immediately_desc_off': 'La fattura verrà salvata come "In attesa" e dovrai addebitarla manualmente in seguito.',
    'processing': 'Elaborazione...',
    'issue_and_charge': 'Emetti e Addebita',
    'issue_bill': 'Emetti Fattura',
    'meter_identity_provider': 'Identità Contatore e Fornitore',
    'account_number': 'Numero di Conto',
    'meter_number': 'Numero Contatore',
    'shared_meter_rubs': 'Contatore condiviso (ripartizione RUBS)',
    'pricing_unit_measurement': 'Prezzi e Unità di Misura',
    'rate_per_unit': 'Tariffa per Unità ($)',
    'unit_of_measure': 'Unità di Misura',
    'billing_day_monthly': 'Giorno di Fatturazione (Mensile)',
    'internal_notes': 'Note Interne',

    // Utility — edit / void / mark-paid
    'edit_utility_account': 'Modifica conto servizi',
    'void_bill': 'Annulla fattura',
    'void_reason': 'Motivo (opzionale)',
    'void_reason_placeholder': 'es. Errore di fatturazione, duplicato...',
    'confirm_void_bill': 'Questa fattura verrà annullata e non potrà essere addebitata.',
    'confirm_void_bill_sent': 'Questa fattura è già stata addebitata. Verrà emessa una nota di credito per stornare l\'addebito.',
    'bill_voided': 'Fattura annullata',
    'bill_marked_paid': 'Fattura contrassegnata come pagata',
    'confirm_mark_paid': 'Contrassegnare questa fattura come pagata (pagamento esterno)?',
    'deactivate_utility_account': 'Disattiva account',
    'confirm_deactivate_utility_account': 'Sei sicuro di voler disattivare questo conto servizi?',
    'post_utility_charge': 'Registra addebito servizi',
    'account_updated': 'Account aggiornato con successo',
    'utility_bill': 'Fattura servizi',
    'tenant_info': 'Inquilino',
    'tenant_name_5': 'Nome',
    'email_15': 'Email',
    'reading_history': 'Storico letture',
    'usage_breakdown': 'Dettaglio consumi',
    'previous_reading': 'Lettura precedente',
    'current_reading': 'Lettura attuale',
    'view_account': 'Visualizza conto servizi',

    // Currency
    'currency_selector_label': 'Valuta dell\'organizzazione',
    'currency_stripe_warning': 'I pagamenti online tramite Stripe non sono disponibili per questa valuta. I locatari pagheranno solo di persona.',
    'online_payment_unavailable': 'Il pagamento online non è disponibile per la tua valuta. Si prega di pagare di persona.',

    // --- HIGH-QUALITY MANUAL TRANSLATIONS ---
    'total_properties': 'Proprietà totali',
    'active_properties': 'Proprietà attive',
    'active_tenants': 'Inquilini attivi',
    'monthly_revenue': 'Entrate mensili',
    'pending_payments': 'Pagamenti in sospeso',
    'lease_expiring_soon': 'Contratto in scadenza a breve',
    'payment_risk': 'Rischio di pagamento',
    'ai_scored_late_payment': 'Probabilità di pagamento in ritardo (IA)',
    'high_risk': 'Alto rischio',
    'medium_risk': 'Medio rischio',
    'low_risk': 'Basso rischio',
    'no_scores_yet': 'Nessun punteggio ancora. Clicca per aggiornare.',
    'renewal_risk': 'Rischio di rinnovo',
    'leases_expiring_in_90_days': 'Contratti in scadenza in 90 giorni',
    'exp_in_30d': 'Scade in 30g',
    'exp_in_90d': 'Scade in 90g',
    'no_leases_expiring_90d': 'Nessun contratto in scadenza nei prossimi 90 giorni.',
    'leasing_office': 'Ufficio affitti',
    'marketing_links': 'Link di marketing',
    'bulk_import': 'Importazione di massa',
    'evictions': 'Sfratti',
    'accounting': 'Contabilità',
    'payments': 'Pagamenti',
    'portfolio_kpis': 'Portafoglio e KPI',
    'bulk_comms': 'Messaggio di massa',
    'email_templates': 'Modelli email',
    'building_view': 'Vista edificio',
    'failed_to_load_logs': 'Caricamento log fallito',
    'export_failed': 'Esportazione log fallita',
    'all_user_activities_desc': 'Tieni traccia di tutte le azioni di sistema',
    'search_logs': 'Cerca nei log...',
    'entries': 'voci',
    'filter_activities': 'Filtra attività',
    'action_type': 'Tipo di azione',
    'all_actions': 'Tutte le azioni',
    'entity_type': 'Tipo di entità',
    'all_types': 'Tutti i tipi',
    'start_date': 'Data di inizio',
    'end_date': 'Data di fine',
    'reset': 'Ripristina',
    'apply_filter': 'Applica filtro',
    'time': 'Ora',
    'user': 'Utente',
    'action': 'Azione',
    'entity': 'Entità',
    'details': 'Dettagli',
    'amount': 'Importo',
    'no_logs_matching_search': 'Nessun log corrisponde alla ricerca.',
    'no_logs_available': 'Nessun log attività disponibile.',
    'showing_range': 'Visualizzazione da {{start}} a {{end}} di {{total}}',
    'previous': 'Precedente',
    'next': 'Successivo',
    'exporting': 'Esportazione...',
    'export': 'Esporta',
    'filter': 'Filtro',
    'activity_logs': 'Log delle attività',
    'invitation_only_onboarding': 'Registrazione solo su invito',
    'approve_payment_msg': 'Sei sicuro di voler approvare questo pagamento?',
    'reject_payment_msg': 'Fornisci un motivo per rifiutare questo pagamento.',
    'errors_serverError': 'Errore interno del server',
    'timePeriods_month': 'Mese',
    'timePeriods_quarter': 'Trimestre',
    'timePeriods_year': 'Anno',
    'common_startDate': 'Data di inizio',
    'common_endDate': 'Data di fine',
    'common_type': 'Tipo',
    'common_all': 'Tutti',
    'common_tenant': 'Inquilino',

  
  
  
    // Auto-added translations
    'leases_expiring_90d': 'Locazioni in scadenza 90 gg',
    'left': 'A sinistra',
    'view_all_renewal_risks': 'Visualizza tutti i rischi di rinnovo',
    're_run_ai_scoring': 'Riesegui il punteggio Ai',
    'medium': 'Medio',
    'owed': 'Dovuto',
    'view_all_risk_scores': 'Visualizza tutti i punteggi di rischio',
    'at_12_pm': 'Alle 12:00',
    'unpaid_balance': 'Saldo non pagato',
    'lease_period': 'Periodo di locazione',
    'view_record': 'Visualizza registrazione',
    'apartment_created_successfully': 'Appartamento creato con successo',
    'apartment_updated_successfully': 'Appartamento aggiornato con successo',
    'manage_your_properties': 'Gestisci le tue proprietà',
    'filter_apartments': 'Filtra Appartamenti',
    'no_matching_apartments_message': 'Nessun messaggio relativo agli appartamenti corrispondenti',
    'furnished_apartment': 'Appartamento ammobiliato',
    'manage': 'Gestisci',
    'delete_apartment': 'Elimina appartamento',
    'select_at_least_one_floor': 'Seleziona almeno un piano',
    'add_at_least_one_unit_type': 'Aggiungi almeno un tipo di unità',
    'apartments_created': 'Appartamenti creati',
    'skipped_duplicates': 'Duplicati saltati',
    'apartments_created_successfully': 'Appartamenti creati con successo',
    'error_creating_apartments': 'Errore durante la creazione degli appartamenti',
    'select_floors': 'Seleziona Piani',
    'clear': 'Chiaro',
    'qty_per_floor': 'Quantità per piano',
    'units_per_floor': 'Unità per piano',
    'select_floors_and_types': 'Seleziona pavimenti e tipologie',
    'future_tenant_only': 'Solo futuro inquilino',
    'converted': 'Convertito',
    'confirmed': 'Confermato',
    'hold': 'Tieni',
    'failed_confirm_booking': 'Conferma prenotazione non riuscita',
    'failed_cancel_booking': 'Annullamento della prenotazione non riuscito',
    'failed_convert_tenant': 'Conversione tenant non riuscita',
    'converted_to_tenant': 'Convertito in inquilino',
    'cancellation_reason': 'Motivo della cancellazione',
    'hold_expired': 'Conservazione scaduta',
    'cancel_booking_question': 'Cancella la domanda di prenotazione',
    'yes_cancel': 'Sì Annulla',
    'keep_it': 'Tienilo',
    'booking_created': 'Prenotazione creata',
    'failed_save_booking': 'Salvataggio della prenotazione non riuscito',
    'building_created_successfully': 'Edificio creato con successo',
    'building_updated_successfully': 'Edificio aggiornato con successo',
    'bulk_add': 'Aggiunta in blocco',
    'total_buildings': 'Edifici totali',
    'avg_occupancy': 'Occupazione media',
    'building_has_no_apartments': 'L\'edificio non ha appartamenti',
    'add_apartments_hint': 'Aggiungi suggerimento appartamenti',
    'due': 'Dovuto',
    'description': 'Descrizione',
    'next_7_days': 'Prossimi 7 giorni',
    'next_14_days': 'Prossimi 14 giorni',
    'next_30_days': 'Prossimi 30 giorni',
    'view_arrow': 'Visualizza freccia',
    'search_unit_tenant': 'Cerca inquilino dell\'unità',
    'no_results_for_filters': 'Nessun risultato per i filtri',
    'charged': 'Caricato',
    'bank': 'Banca',
    'cheque': 'Controlla',
    'stripe': 'Striscia',
    'failed_to_load_revenue': 'Impossibile caricare le entrate',
    'no_tenant_logs': 'Nessun registro del tenant',
    'payment_record_error': 'Errore nel record del pagamento',
    'contract_not_found': 'Contratto non trovato',
    'back_to_owner': 'Ritorno al proprietario',
    'contract_id': 'Identificativo contratto',
    'summary_info': 'Informazioni riassuntive',
    'n_a': 'N A',
    'paid_progress': 'Progresso pagato',
    'total_installments': 'Rate totali',
    'paid_installments': 'Rate pagate',
    'pending_installments': 'Rate in sospeso',
    'legal_document': 'Documento legale',
    'signatures': 'Firme',
    'owner_signature': 'Firma del proprietario',
    'awaiting_owner_signature': 'In attesa della firma del proprietario',
    'admin_signature': 'Firma dell\'amministratore',
    'awaiting_admin_signature': 'In attesa della firma dell\'amministratore',
    'paid_amount': 'Importo pagato',
    'save_payment': 'Salva pagamento',
    'language': 'Lingua',
    'exportPDF': 'Esporta PDF',
    'print': 'Stampa',
    'receiptNo': 'Ricevuta n',
    'contractDetails': 'Dettagli del contratto',
    'contractNo': 'Contratto n',
    'contractType': 'Tipo di contratto',
    'startDate': 'Data di inizio',
    'endDate': 'Data di fine',
    'openEnded': 'Estremità aperta',
    'financialSummary': 'Riepilogo finanziario',
    'totalValue': 'Valore totale',
    'totalPaid': 'Totale pagato',
    'balanceDue': 'Saldo dovuto',
    'installmentSchedule': 'Programma delle rate',
    'dueDate': 'Data di scadenza',
    'paidAmt': 'Importo pagato',
    'paymentDate': 'Data di pagamento',
    'paidWatermark': 'Filigrana a pagamento',
    'paymentDetails': 'Dettagli di pagamento',
    'installmentNo': 'Rata n',
    'amountDue': 'Importo dovuto',
    'amountPaid': 'Importo pagato',
    'paymentStatus': 'Stato del pagamento',
    'paymentConfirmed': 'Pagamento confermato',
    'awaitingPayment': 'In attesa di pagamento',
    'balanceRemaining': 'Saldo rimanente',
    'authorizedSig': 'Autorizzato Sig',
    'ownerSig': 'Proprietario Sig',
    'generatedBy': 'Generato da',
    'informationalOnly': 'Solo informativo',
    'failed_to_load_owner_data': 'Impossibile caricare i dati del proprietario',
    'sending': 'Invio',
    'payment_reminder_message': 'Messaggio di promemoria del pagamento',
    'reminder_sent_success': 'Promemoria inviato con successo',
    'failed_to_send_reminder': 'Impossibile inviare il promemoria',
    'owner_has_no_email': 'Il proprietario non ha email',
    'portal_invitation_sent_successfully': 'Invito al portale inviato correttamente',
    'failed_to_send_portal_invite': 'Impossibile inviare l\'invito al portale',
    'owner_not_found': 'Proprietario non trovato',
    'total_income': 'Reddito totale',
    'residence': 'Residenza',
    'does_not_live_on_property': 'Non vive in una proprietà',
    'outstanding_fees_note': 'Nota sulle commissioni in sospeso',
    'pending_signature': 'Firma in sospeso',
    'fully_executed': 'Completamente eseguito',
    'error_loading_financials': 'Errore durante il caricamento dei dati finanziari',
    'due_soon': 'A breve',
    'owner_updated_successfully': 'Proprietario aggiornato correttamente',
    'invitation_sent': 'Invito inviato',
    'invitation_failed': 'Invito non riuscito',
    'owner_created_successfully': 'Proprietario creato con successo',
    'preferred_language': 'Lingua preferita',
    'drop_here': 'Lasciami qui',
    'failed_to_load_owners_data': 'Impossibile caricare i dati dei proprietari',
    'connection_error': 'Errore di connessione',
    'failed_to_delete_owner': 'Impossibile eliminare il proprietario',
    'failed_to_delete_owners': 'Impossibile eliminare i proprietari',
    'edit_owner': 'Modifica proprietario',
    'delete_owner': 'Elimina proprietario',
    'occupied_lowercase': 'Minuscolo occupato',
    'confirm_bulk_delete_title': 'Conferma l\'eliminazione collettiva del titolo',
    'refresh_owners': 'Aggiorna proprietari',
    'delete_selected_owners': 'Elimina proprietari selezionati',
    'export_to_pdf': 'Esporta in PDF',
    'print_owners': 'Proprietari di stampa',
    'min_zero': 'Min zero',
    'count_formatted': 'Conteggio formattato',
    'invalid_plan_selected': 'Piano selezionato non valido',
    'could_not_start_checkout': 'Impossibile avviare il pagamento',
    'checkout_failed': 'Pagamento non riuscito',
    'could_not_open_portal': 'Impossibile aprire il portale',
    'failed_to_open_portal': 'Impossibile aprire il portale',
    'payment_approved_success': 'Pagamento approvato con successo',
    'failed_to_approve_payment': 'Impossibile approvare il pagamento',
    'provide_rejection_reason': 'Fornire il motivo del rifiuto',
    'payment_rejected': 'Pagamento rifiutato',
    'failed_to_reject_payment': 'Impossibile rifiutare il pagamento',
    'stripe_connected': 'Striscia connessa',
    'redirecting': 'Reindirizzamento',
    'approve_payment': 'Approvare il pagamento',
    'reject_payment': 'Rifiuta il pagamento',
    'errors.serverError': 'Errore del server',
    'export_excel': 'Esporta Excel',
    'timePeriods.month': 'Mese',
    'timePeriods.quarter': 'Quarto',
    'timePeriods.year': 'Anno',
    'common.startDate': 'Data di inizio',
    'common.endDate': 'Data di fine',
    'common.type': 'Digitare',
    'common.all': 'Tutto',
    'common.tenant': 'Inquilino',
    'common.searchTenant': 'Cerca inquilino',
    'ledgerReport.netBalance': 'Saldo netto',
    'ledgerReport.entries': 'Voci',
    'common.noData': 'Nessun dato',
    'common.date': 'Data',
    'common.building': 'Edificio',
    'common.apartment': 'Appartamento',
    'common.description': 'Descrizione',
    'common.amount': 'Importo',
    'ledgerReport.balanceAfter': 'Saldo dopo',
    'ledgerReport.createdBy': 'Creato da',
    'common.page': 'Pagina',
    'metric': 'Metrico',
    'value': 'Valore',
    'failed_to_export': 'Impossibile esportare',
    'select_date_range': 'Seleziona Intervallo di date',
    'revenue_deep_dive_restricted': 'Approfondimento sulle entrate limitato',
    'showing_building_revenue': 'Mostra le entrate di costruzione',
    'showing_owner_revenue': 'Visualizzazione delle entrate del proprietario',
    'showing_monthly_revenue': 'Mostra entrate mensili',
    'receiptTitle': 'Titolo della ricevuta',
    'receiptDate': 'Data della ricevuta',
    'residentName': 'Nome residente',
    'servicePeriod': 'Periodo di servizio',
    'signature': 'Firma',
    'responsible': 'Responsabile',
    'thankYou': 'Grazie',
    'invalid_amount': 'Importo non valido',
    'payment_generated_successfully': 'Pagamento generato con successo',
    'failed_to_generate_payment': 'Impossibile generare il pagamento',
    'no_owner': 'Nessun proprietario',
    'rented': 'Affittato',
    'payer': 'Pagatore',
    'failed_to_load_service_data': 'Impossibile caricare i dati del servizio',
    'records': 'Record',
    'no_matching_payments_found': 'Nessun pagamento corrispondente trovato',
    'paid_count': 'Conte pagato',
    'unpaid_count': 'Conteggio non pagato',
    'no_data_to_export': 'Nessun dato da esportare',
    'export_successful': 'Esportazione riuscita',
    'months_with_data': 'Mesi con i dati',
    'data_refreshed_successfully': 'Dati aggiornati con successo',
    'payment_marked_as_paid': 'Pagamento contrassegnato come pagato con successo',
    'payment_marked_as_unpaid': 'Pagamento contrassegnato come non pagato con successo',
    'rented': 'Affittato',
    'service_charge_deleted': 'Addebito servizio eliminato con successo',
    'failed_to_delete_service_charge': 'Impossibile eliminare l\'addebito servizio',
    'service_payment_note_default': 'Pagamento servizio per {{month}} {{year}}',
    'failed_init_stripe': 'Stripe di avvio non riuscito',
    'refresh_status': 'Aggiorna stato',
    'failed_to_load_user_data': 'Impossibile caricare i dati utente',
    'error_updating_profile': 'Errore durante l\'aggiornamento del profilo',
    'error_updating_password': 'Errore durante l\'aggiornamento della password',
    'failed_to_load_system_data': 'Impossibile caricare i dati di sistema',
    'logo_upload_success': 'Caricamento del logo riuscito',
    'error_from_server': 'Errore dal server',
    'error_uploading_logo': 'Errore durante il caricamento del logo',
    'error_updating_system_settings': 'Errore durante l\'aggiornamento delle impostazioni di sistema',
    'contact_email': 'Contatto e-mail',
    'contact_phone': 'Contatta il telefono',
    'office_address': 'Indirizzo dell\'ufficio',
    'organization_logo': 'Logo dell\'organizzazione',
    'nameLabel': 'Etichetta con nome',
    'floorPre': 'Piano Pre',
    'aptPre': 'Adatto Pre',
    'periodLabel': 'Etichetta del periodo',
    'officeCommission': 'Commissione d\'ufficio',
    'invalid_date': 'Data non valida',
    'tenant_has_no_email': 'L\'inquilino non ha email',
    'portal_invitation_failed': 'Invito al portale non riuscito',
    'lease_extended_success': 'Successo prolungato del leasing',
    'failed_to_extend_lease': 'Impossibile estendere il contratto di locazione',
    'lease_renewed_success': 'Contratto di locazione rinnovato successo',
    'failed_to_renew_lease': 'Impossibile rinnovare il contratto di locazione',
    'ending_lease': 'Fine del contratto di locazione',
    'no_additional_fees': 'Nessun costo aggiuntivo',
    'electronic_signature': 'Firma elettronica',
    'no_maintenance_requests_message': 'Nessun messaggio di richiesta di manutenzione',
    'add_first_request': 'Aggiungi la prima richiesta',
    'extending': 'Estendendo',
    'renewing': 'Rinnovare',
    'tenant_updated_successfully': 'Tenant aggiornato correttamente',
    'tenant_created_successfully': 'Inquilino creato con successo',
    'no_phone': 'Niente telefono',
    'not_assigned': 'Non assegnato',
    'financial_details': 'Dettagli finanziari',
    'more_info': 'Ulteriori informazioni',
    'apartment_specs': 'Specifiche dell\'appartamento',
    'first_name_required': 'Nome obbligatorio',
    'last_name_required': 'Cognome obbligatorio',
    'email_required': 'E-mail obbligatoria',
    'invalid_email': 'E-mail non valida',
    'username_required': 'Nome utente obbligatorio',
    'user_created_email_failed': 'E-mail creata dall\'utente non riuscita',
    'user_created_email_failed_2': 'E-mail creata dall\'utente non riuscita 2',
    'invitation_email_could_not_be_sent': 'Impossibile inviare l\'e-mail di invito',
    'user_created_email_failed_3': 'E-mail creata dall\'utente non riuscita 3',
    'manual_onboarding_link': 'Collegamento di onboarding manuale',
    'manual_onboarding_desc': 'Onboarding manuale Desc',
    'link_copied_to_clipboard': 'Collegamento copiato negli appunti',
    'copy_link': 'Copia collegamento',
    'add_another_user': 'Aggiungi un altro utente',
    'invitation_only_onboarding_desc': 'Onboarding solo su invito Desc',
    'hide_inactive_users': 'Nascondi utenti inattivi',
    'show_inactive_users': 'Mostra utenti inattivi',
    'error_loading_users': 'Errore durante il caricamento degli utenti',
    'no_users_message': 'Nessun messaggio utente',
    'create_first_user': 'Crea primo utente',
    'enable_rent_reminders': 'Abilita promemoria affitto',
    'request_failed': 'Richiesta non riuscita',
    'failed_load_notification_settings': 'Impossibile caricare le impostazioni di notifica',
    'settings_save_failed': 'Salvataggio impostazioni non riuscito',
    'preview_failed': 'Anteprima non riuscita',
    'reminders_sent': 'Promemoria inviati',
    'loading_units': 'Unità di caricamento',
    'listed_rent': 'Affitto quotato',
    'portfolio_occupancy': 'Occupazione del portafoglio',
    'avg_renewal_increase': 'Aumento medio del rinnovo',
    'title': 'Titolo',
    'content': 'Contenuto',
    'marketing_links_desc': 'Collegamenti di marketing Desc',
    'download_failed': 'Download non riuscito',
    'run_report': 'Esegui rapporto',
    'downloading': 'Download in corso',
    'total_ar': 'Totale Ar',
    'total_balance': 'Saldo totale',
    'no_outstanding_balances_found': 'Nessun saldo in sospeso trovato',
    'totals': 'Totali',
    'subject_body_required': 'Corpo dell\'oggetto Obbligatorio',
    'no_active_tenants': 'Nessun inquilino attivo',
    'confirm_send_bulk': 'Conferma l\'invio in blocco',
    'message_sent_to_tenants': 'Messaggio inviato agli inquilini',
    'bulk_communications': 'Comunicazioni di massa',
    'message_sent_successfully': 'Messaggio inviato con successo',
    'in_app_announcement': 'Nell\'annuncio dell\'app',
    'dismiss': 'Ignora',
    'target_building': 'Costruzione di obiettivi',
    'all_buildings_count': 'Tutti gli edifici contano',
    'compose_message': 'Componi messaggio',
    'subject': 'Oggetto',
    'message_body': 'Corpo del messaggio',
    'markdown_hint': 'Suggerimento per il ribasso',
    'characters': 'Personaggi',
    'delivery_channels': 'Canali di consegna',
    'email_blast': 'Esplosione di e-mail',
    'send_to_tenants': 'Invia agli inquilini',
    'bulk_guidelines': 'Linee guida collettive',
    'in_app_announcements': 'Negli annunci dell\'app',
    'in_app_desc': 'Nella descrizione dell\'app',
    'email_blasts': 'Esplosioni di e-mail',
    'email_blast_desc': 'Descrizione esplosione e-mail',
    'send_immediate_desc': 'Invia immediata descrizione',
    'professional_desc': 'Descrizione professionale',
    'owner_balances': 'Saldi del proprietario',
    'deselect_all': 'Deseleziona tutto',
    'select_all': 'Seleziona tutto',
    'notes_optional': 'Note Facoltativo',
    'confirm_bulk_payout_title': 'Conferma pagamento in blocco',
    'error_loading_churn_data': 'Errore durante il caricamento dei dati sull\'abbandono',
    'running_scoring': 'Punteggio in esecuzione',
    'scored_tenants': 'Inquilini segnati',
    'scoring_failed': 'Punteggio fallito',
    'vendor_dashboard_subtitle': 'Sottotitolo dashboard fornitore',
    'view_your_work_orders': 'Visualizza i tuoi ordini di lavoro',
    'confirm_replace_content': 'Conferma Sostituisci contenuto',
    'applied_template': 'Modello applicato',
    'templates': 'Modelli',
    'editor': 'Editore',
    'desktop': 'Desktop',
    'mobile': 'Cellulare',
    'realistic_sample_data': 'Dati campione realistici',
    'template_logic': 'Logica dei modelli',
    'event_trigger_desc': 'Evento Trigger Desc',
    'admin_only': 'Solo amministratore',
    'click_to_insert': 'Fare clic per inserire',
    'body': 'Corpo',
    'template_deactivated': 'Modello disattivato',
    'failed_to_deactivate': 'Impossibile disattivare',
    'enter_test_email': 'Inserisci l\'e-mail di prova',
    'test_email_sent_to': 'E-mail di prova inviata a',
    'failed_to_send_test': 'Impossibile inviare il test',
    'active_templates_count': 'Conteggio dei modelli attivi',
    'send_test_email': 'Invia e-mail di prova',
    'save_failed': 'Salvataggio non riuscito',
    'description_required': 'Descrizione Obbligatorio',
    'post_failed': 'Inserimento non riuscito',
    'code': 'Codice',
    'create_account': 'Crea account',
    'apply': 'Applicare',
    'account': 'Conto',
    'debit': 'Addebito',
    'credit': 'Credito',
    'lines': 'Linee',
    'hide': 'Nasconditi',
    'reverse': 'Inverso',
    'run': 'Corri',
    'total_debits': 'Debiti totali',
    'total_credits': 'Crediti totali',
    'journal_entry': 'Voce nel diario',
    'building_id_label': 'Etichetta identificativa dell\'edificio',
    'units_count': 'Conteggio delle unità',
    'enable_in_settings': 'Abilita nelle Impostazioni',
    'unit_label': 'Etichetta dell\'unità',
    'no_messages_yet': 'Nessun messaggio ancora',
    'failed_to_load_notification_log': 'Impossibile caricare il registro delle notifiche',
    'no_notifications_found': 'Nessuna notifica trovata',
    'channel': 'Canale',
    'recipient': 'Destinatario',
    'discount_rent': 'Affitto scontato',
    'lease_start': 'Inizio locazione',
    'lease_end': 'Fine del contratto di locazione',
    'next_bill': 'Prossima fattura',
    'no_units_found': 'Nessuna unità trovata',
    'csv_download_failed': 'Download CSV non riuscito',
    'all_1099_downloaded': 'Tutti i 1099 scaricati',
    'no_reportable_owners': 'Nessun proprietario segnalabile',
    'pdf_download_failed': 'Download del PDF non riuscito',
    'pdf_generation_failed': 'Generazione PDF fallita',
    'generating_pdfs': 'Generazione di PDF',
    'download_all_pdfs': 'Scarica tutti i PDF',
    'important': 'Importante',
    'irs_1099_disclaimer': 'Dichiarazione di non responsabilità Irs 1099',
    'owner_payment_summary': 'Riepilogo dei pagamenti del proprietario',
    'irs_threshold': 'Soglia Irs',
    'total_paid': 'Totale pagato',
    'form': 'Modulo',
    'file_form': 'Modulo di archiviazione',
    'no_owner_payments_found': 'Nessun pagamento del proprietario trovato',
    'no_deposits_found': 'Nessun deposito trovato',
    'deposit_amount': 'Importo del deposito',
    'deductions': 'Detrazioni',
    'error_loading_showing': 'Errore durante il caricamento della visualizzazione',
    'required_fields_error': 'Errore nei campi obbligatori',
    'showing_updated': 'Visualizzazione aggiornata',
    'showing_scheduled': 'Visualizzazione pianificata',
    'time_conflict_error': 'Errore di conflitto temporale',
    'choose_unit': 'Scegli Unità',
    'agent_name_placeholder': 'Segnaposto nome agente',
    'schedule': 'Programma',
    'error_loading_showings': 'Errore durante il caricamento delle proiezioni',
    'marked_as': 'Contrassegnato come',
    'update_failed': 'Aggiornamento non riuscito',
    'delete_failed': 'Eliminazione non riuscita',
    'mark_completed': 'Segna come completato',
    'mark_no_show': 'Segna No Show',
    'confirm_delete': 'Conferma eliminazione',
    'confirm_delete_showing': 'Conferma l\'eliminazione della visualizzazione',
    'error_loading_surveys': 'Errore durante il caricamento dei sondaggi',
    'from_responses': 'Dalle risposte',
    'no_data_yet': 'Nessun dato ancora',
    'utility_type_required': 'Tipo di utilità obbligatorio',
    'failed_to_create_account': 'Impossibile creare un account',
    'select_tenant_error': 'Selezionare Errore tenant',
    'please_fix_errors': 'Correggi gli errori',
    'bill_issued_successfully': 'Fattura emessa con successo',
    'failed_to_issue_bill': 'Impossibile emettere fattura',
    'download_csv': 'Scarica Csv',
    'vendor_1099_disclaimer': 'Dichiarazione di non responsabilità del venditore 1099',
    'vendor': 'Venditore',
    'first_payment': 'Primo pagamento',
    'last_payment': 'Ultimo pagamento',
    'no_vendor_payments_recorded': 'Nessun pagamento fornitore registrato',
    'ok_200': 'Va bene 200',
    'failed_load_webhooks': 'Caricamento webhook non riuscito',
    'failed_load_deliveries': 'Consegne di carico non riuscite',
    'failed_update': 'Aggiornamento non riuscito',
    'delete_webhook_confirm': 'Conferma eliminazione webhook',
    'failed_delete': 'Eliminazione non riuscita',
    'rotate_secret_confirm': 'Ruota conferma segreta',
    'secret_rotated': 'Segreto ruotato',
    'failed_rotate': 'Rotazione non riuscita',
    'copied_to_clipboard': 'Copiato negli appunti',
    'add_endpoint': 'Aggiungi punto finale',
    'no_webhooks_yet': 'Nessun webhook ancora',
    'no_webhooks_desc': 'Nessuna descrizione webhook',
    'failures': 'Fallimenti',
    'disable': 'Disabilita',
    'enable': 'Abilita',
    'rotate_secret': 'Ruota segreto',
    'no_deliveries_yet': 'Nessuna consegna ancora',
    'event': 'Evento',
    'http': 'HTTP',
    'account_deactivated': 'Conto disattivato',
    'server_no_response': 'Server nessuna risposta',
    'logging_in': 'Accesso',
    'company_name_required': 'Nome azienda obbligatorio',
    'registration_failed': 'Registrazione non riuscita',
    'enter_company_name': 'Inserisci il nome dell\'azienda',
    'fully_signed_active': 'Attivo completamente firmato',
    'pending_owner_signature': 'Firma del proprietario in sospeso',
    'pending_admin_signature': 'Firma dell\'amministratore in sospeso',
    'terminated': 'Terminato',
    'back_to_contracts': 'Torniamo ai contratti',
    'contract_terms': 'Termini contrattuali',
    'payment_schedule': 'Programma di pagamento',
    'no_installments_defined': 'Nessuna rata definita',
    'signed_by': 'Firmato da',
    'awaiting_admin_review': 'In attesa di revisione da parte dell\'amministratore',
    'sign_contract': 'Firmare il contratto',
    'past': 'Passato',
    'tenant_signin_success': 'Accesso dell\'inquilino riuscito',

    // Auto-added mass translations from ESLint Codemod
    '10': '10/',
    '12': '/12',
    '16': '−16%',
    '25': '25/',
    '50': '50/',
    '100': '100/',
    '600': ': $ 600',
    'ai_assistant_pro_only': 'Assistente AI: solo Pro',
    'ask_questions_about_your_portfolio_in_pl': 'Fai domande sul tuo portafoglio in un inglese semplice. Ottieni risposte immediate su entrate, pagamenti scaduti, posti vacanti e altro ancora.',
    'upgrade_to_pro': 'Passa a Pro',
    'here_s_what_s_happening_across_your_port': 'Ecco cosa sta succedendo al tuo portafoglio oggi.',
    'portfolio_risk': 'Rischio del portafoglio',
    'pro_only': 'Solo professionisti',
    'pending_collections': 'Collezioni in sospeso',
    'ask_ai_assistant': 'Chiedi all\'Assistente AI',
    'unlock_ai_assistant_upgrade_to_pro': 'Sblocca l\'Assistente AI: passa a Pro',
    'download': 'Scarica',
    'd': 'd',
    'view_details_1': 'Visualizza dettagli',
    'export_data': 'Esporta dati',
    'refresh_data': 'Aggiorna dati',
    'property_pulse': 'Impulso della proprietà',
    'cash_flow_analysis_for_the_current_fisca': 'Analisi del flusso di cassa per l\'anno fiscale in corso',
    'yearly_report': 'Rapporto annuale',
    'analytics_pro_required': 'Analytics Pro richiesto',
    'unlock_deep_financial_insights_and_custo': 'Ottieni approfondimenti finanziari approfonditi e report di previsione personalizzati.',
    'upgrade_now': 'Aggiorna ora',
    'items_requiring_immediate_follow_up': 'Elementi che richiedono un follow-up immediato',
    'activity_log': 'Registro delle attività',
    'view_history': 'Visualizza cronologia',
    'no_recent_logs_found': 'Nessun registro recente trovato',
    'active_issues': 'Problemi attivi',
    'pro': 'Pro',
    'pro_1': 'Pro',
    'sell_unit': 'Vendi unità',
    'floor_1': 'Pavimento',
    'size_1': 'Dimensioni',
    'm': 'mq',
    'amenities': 'Servizi',
    'last_updated_today': 'Ultimo aggiornamento: oggi',
    'back_to_apartment': 'Ritorno all\'appartamento',
    'sell_unit_1': 'Vendi unità',
    'floor_2': 'Pavimento',
    'select_buyer': 'Seleziona Acquirente',
    'existing_owner': 'Proprietario esistente',
    'new_buyer': 'Nuovo acquirente',
    'no_owners_found_switch_to_new_buyer_to_c': 'Nessun proprietario trovato: passa a "Nuovo acquirente" per crearne uno',
    'edit_1': 'Modifica',
    'the_buyer_will_be_created_as_an_owner_an': 'L\'acquirente verrà creato come proprietario e collegato automaticamente a questa vendita.',
    'sale_terms': 'Condizioni di vendita',
    'total_sale_price': 'Prezzo totale di vendita *',
    'down_payment': 'Acconto',
    'annual_interest_rate': 'Tasso di interesse annuo (%)',
    'term_months': 'Durata (mesi) *',
    'yrs': 'anni)',
    'sale_start_date': 'Data di vendita/inizio *',
    'quick_preview': 'Anteprima rapida',
    'principal': 'Principale',
    'down_payment_1': 'Acconto',
    'term': 'Termine',
    'months_1': 'mesi',
    'amortization_schedule': 'Piano di ammortamento',
    'confirm_sale': 'Conferma vendita',
    'buyer': 'Acquirente',
    'floor_3': '— Pavimento',
    'financial_terms': 'Termini finanziari',
    'draft_sale_contract': 'bozza di contratto di vendita',
    'will_be_created_the_apartment_will_be_ma': 'verrà creato. L\'appartamento sarà contrassegnato come',
    'sold': 'Venduto',
    'only_after_both_you_and_the_buyer_digita': 'solo dopo che tu e l\'acquirente avete firmato digitalmente il contratto.',
    'sale_finalized': 'Vendita finalizzata!',
    'the_sale_contract_for_unit': 'Il contratto di vendita dell\'Unità',
    'has_been_created_use_the_links_below_to': 'è stato creato. Utilizza i link sottostanti per coinvolgere l\'acquirente.',
    'public_sign_link': 'Collegamento al cartello pubblico',
    'p_sign_owner': '/p/segno/proprietario/',
    'portal_invite_link': 'Collegamento di invito al portale',
    'portal_setup_password_type_owner_id': '/portal/setup-password?type=proprietario&id=',
    'email_1': '&e-mail=',
    'token': '&gettone=',
    'view_owner': 'Visualizza proprietario',
    'manage_contract': 'Gestisci contratto',
    '0_10': '(0–10,',
    'm_1': 'mq',
    'm_2': 'mq',
    'm_3': 'mq',
    'm_4': 'mq',
    'empty_key': '✕',
    'this_apartment_already_has': 'Questo appartamento lo ha già',
    'active_booking_s_for_these_dates': 'prenotazioni attive per queste date.',
    'levels': 'Livelli',
    'cap': 'Cap',
    'no_inventory_data': 'Nessun dato di inventario',
    'init_units': 'Unità iniziali',
    'm_5': 'mq',
    'm_6': 'mq',
    'supports_markdown_placeholders_e_g': 'Supporta MarkDown e segnaposto, ad es.',
    'empty_key_1': '✓',
    'trial_ends_in': 'La prova termina tra',
    'days_subscribe': 'giorni - Iscriviti',
    'new_lease_agreement': 'Nuovo contratto di locazione',
    'tenant_unit_assignment': 'Assegnazione inquilino e unità',
    'please_select_a_building_first': 'Seleziona prima un edificio',
    'lease_terms_duration': 'Termini e durata del contratto di locazione',
    'lease_type': 'Tipo di contratto di locazione',
    'fixed_term': 'Tempo determinato',
    'month_to_month': 'Mese per mese',
    'end_date_optional': 'Data di fine (facoltativa)',
    'financial_obligations': 'Obblighi finanziari',
    'empty_key_2': ') *',
    'notes_special_provisions': 'Note/Disposizioni particolari',
    'empty_key_3': ':#',
    'send_for_signature': 'Invia per la firma',
    'copy_sign_link': 'Copia il collegamento del segno',
    'download_contract_pdf': 'Scarica il PDF del contratto',
    'contract_summary': 'Riepilogo del contratto',
    'generated_from_template': 'Generato dal modello:',
    'digitally_executed': 'Eseguito digitalmente',
    'electronic_signatures': 'Firme elettroniche',
    'management_office': 'Ufficio di gestione',
    'authorized_signature': 'Firma autorizzata',
    'owner_landlord': 'Proprietario/Locatore',
    'email_2': 'E-mail:',
    'signed': 'Firmato:',
    'ip': 'IP:',
    'reason_for_voiding': 'Motivo dell\'annullamento',
    'building_agreement_for': 'Contratto di costruzione per',
    'contract_builder_rules': 'Regole per la creazione di contratti',
    'select_contract_template': 'Seleziona modello di contratto',
    'no_template_manual_mode': 'Nessun modello (modalità manuale)',
    'template_dynamic_variables': 'Variabili dinamiche del modello',
    'owner_default_commission': 'Commissione predefinita del proprietario:',
    'maintenance_threshold': 'Soglia di manutenzione:',
    'unit_1': 'Unità',
    'sale_unit_purchase': 'Vendita/Acquisto unità',
    'fixed_maintenance_contract': 'Contratto di manutenzione fisso',
    'lease_agreement': 'Contratto di locazione',
    'start_date_1': 'Data di inizio',
    'auto_generate_quarterly': 'Generazione automatica trimestrale',
    'add_custom_installment': 'Aggiungi rata personalizzata',
    'plan_total': 'Piano totale',
    'agreement': 'Accordo',
    'copy_portal_link': 'Copia collegamento al portale',
    'ledger': 'Registro',
    'empty_key_4': ') â†’',
    'owner_documents': 'Documenti del proprietario',
    'add_document': 'Aggiungi documento',
    'name_1': 'Nome *',
    'tax': 'Tassa',
    'file_url': 'URL del file *',
    'cancel_1': 'Annulla',
    'no_documents_yet': 'Nessun documento ancora',
    '30_days': '(30 giorni)',
    'view_1': 'Visualizza',
    'future_scheduled_installments': 'future rate previste',
    'unit_2': ', Unità',
    'no_investment_data_available_add_purchas': 'Nessun dato sugli investimenti disponibile. Aggiungi il prezzo di acquisto e il valore corrente agli appartamenti per visualizzare le metriche.',
    'click_the_edit_icon_on_any_unit_to_updat': 'Fai clic sull\'icona di modifica su qualsiasi unità per aggiornarne il valore di mercato corrente o il prezzo di acquisto.',
    'unit_3': 'Unità',
    'unit_mo': '/unità/mese',
    'save_16_billed_annually': 'Risparmia il 16% · fatturato annualmente',
    'reason_for_rejection': 'Motivo del rifiuto',
    'of_1': 'di',
    'error_loading_receipt': 'Errore nel caricamento della ricevuta',
    'go_back': 'Torna indietro',
    'receipt_not_found': 'Ricevuta non trovata',
    'the_requested_payment_receipt_could_not': 'Impossibile trovare la ricevuta di pagamento richiesta.',
    'go_back_1': 'Torna indietro',
    'payment_receipt': 'Ricevuta di pagamento',
    'issue_date': 'Data di emissione:',
    'from_1': 'Da',
    'phone_1': 'Telefono:',
    'to_1': 'A',
    'phone_2': 'Telefono:',
    'amount_1': 'Importo',
    'notes_1': 'Note',
    'thank_you_for_your_payment': 'Grazie per il pagamento!',
    'this_receipt_was_generated_automatically': 'Questa ricevuta è stata generata automaticamente.',
    'delete_template': 'Elimina modello',
    'cancel_2': 'Annulla',
    'delete_1': 'Elimina',
    'description_optional': 'Descrizione (facoltativa)',
    'report_type': 'Tipo di rapporto',
    'choosing_a_report_type_shows_the_relevan': 'Scegliendo un tipo di rapporto vengono visualizzati i filtri pertinenti di seguito.',
    'saved_filters': 'Filtri salvati',
    'select_a_report_type_above_to_set_saved': 'Seleziona un tipo di rapporto sopra per impostare i valori di filtro salvati per questo modello.',
    'cancel_3': 'Annulla',
    'saved_filter': 'filtro salvato',
    'saved_1': 'Salvato',
    'favourites': 'Preferiti',
    'all_templates': 'Tutti i modelli',
    'load_template': 'Carica modello',
    'favourites_1': 'Preferiti',
    'no_templates_for_this_report_type': 'Nessun modello per questo tipo di rapporto',
    'saved_filter_1': 'filtro salvato',
    'manage_apartment_sales_and_track_sold_un': 'Gestisci le vendite di appartamenti e monitora le unità vendute',
    'apartments_1': 'appartamenti',
    'available': 'disponibile',
    'sold_1': 'venduto',
    'sold_rate': '% tasso di vendita',
    'floor_4': 'Pavimento',
    'units_1': 'unità',
    'available_1': 'disponibile',
    'sold_2': 'venduto',
    'unit_4': 'Unità',
    'owner_buyer': 'Proprietario/Acquirente',
    'sale_price': 'Prezzo di vendita',
    'sale_date': 'Data di vendita',
    'sell_unit_2': 'Vendi unità',
    'view_details_2': 'Visualizza dettagli',
    'print_1': 'Stampa',
    'apartment_management_system': 'Sistema di gestione degli appartamenti',
    'erbil_kurdistan_region_iraq': 'Erbil, Regione del Kurdistan - Iraq',
    'tel_xxx_xxxxxxxx': 'Tel: +XXX XXXXXXXX',
    'receipt': 'Ricevuta n.:',
    'name_2': 'Nome:',
    'phone_3': 'Telefono:',
    'building_1': 'Edificio:',
    'payment_details_1': 'Dettagli di pagamento',
    'amount_2': 'Importo:',
    'payment_date_1': 'Data di pagamento:',
    'period_1': 'Periodo:',
    'notes_2': 'Note',
    'thank_you_for_your_payment_1': 'Grazie per il pagamento!',
    'tenant_information_1': 'Informazioni sull\'inquilino',
    'name_3': 'Nome:',
    'phone_4': 'Telefono:',
    'apartment_1': 'Appartamento:',
    'building_2': 'Edificio:',
    'furnished_1': 'Arredato:',
    'at_12_00_pm': 'alle 12:00',
    'monthly_rent_1': 'Affitto mensile:',
    'insurance_1': 'Assicurazione:',
    'additional_notes': 'Note aggiuntive',
    'tenant_signature': 'Firma dell\'inquilino',
    'this_receipt_is_electronically_generated': 'Questa ricevuta è generata elettronicamente ed è valida senza firma.',
    'apartment_management_system_all_rights_r': 'Sistema di gestione degli appartamenti. Tutti i diritti riservati.',
    'lease_renewal_risk': 'Rischio di rinnovo del contratto di locazione',
    'expiring_in_30_days': 'Con scadenza tra 30 giorni',
    'expiring_in_60_days': 'Scadenza tra 60 giorni',
    'expiring_in_90_days': 'Scadenza tra 90 giorni',
    'expiring_in_180_days': 'Scadenza tra 180 giorni',
    'all_risk_levels': 'Tutti i livelli di rischio',
    'no_leases_matching_the_selected_filters': 'Nessun contratto di locazione corrispondente ai filtri selezionati.',
    'd_1': 'd',
    'no_documents_uploaded_for_this_tenant': 'Nessun documento caricato per questo inquilino.',
    'empty_key_5': '✓',
    'empty_key_6': '✕',
    'empty_key_7': '($) *',
    'ai_lease_reader': 'Lettore di leasing AI',
    'upload_a_lease_pdf_to_auto_fill_the_form': 'Carica un PDF del contratto di locazione per compilare automaticamente il modulo',
    'empty_key_8': '●',
    'empty_key_9': '✓',
    '10_1': '10/',
    '25_1': '25/',
    '50_1': '50/',
    '100_1': '100/',
    'register_as_maintenance_provider_service': 'Registrarsi come fornitore di manutenzione (fornitore di servizi)',
    'this_will_automatically_create_a_record': 'Ciò creerà automaticamente un record nell\'hub di manutenzione in modo da poter assegnare ordini di lavoro a questo utente.',
    'assigned_buildings_portfolio': 'Edifici assegnati (Portfolio)',
    'select_the_buildings_this_portfolio_mana': 'Seleziona gli edifici a cui può accedere questo gestore di portafoglio. Vedranno SOLO i dati relativi a questi edifici.',
    'no_buildings_found_please_create_buildin': 'Nessun edificio trovato. Per favore crea prima gli edifici.',
    'building_3': 'edificio',
    'empty_key_10': '☀️',
    '1_315_333_7884': '+1 (315) 333-7884',
    'sent_sid': '✅ Inviato! ID:',
    'iraq_964_is_blocked_by_default_enable_it': '🌍 L\'Iraq (+964) è bloccato per impostazione predefinita. Abilitalo:',
    'twilio_messaging_geo_permissions_iraq_on': 'Twilio → Messaggi → Autorizzazioni geografiche → Iraq → ON → Salva',
    'trial_accounts_can_only_message': '🔒 Gli account di prova possono solo inviare messaggi',
    'verified_numbers': 'numeri verificati',
    'apt_1': '· Adatto',
    'mo_1': '/mese',
    'mo_2': '/mese',
    'manage_building_amenities_unit_features': 'Gestisci i servizi dell\'edificio, le caratteristiche dell\'unità e i posti auto',
    'all_buildings_1': 'Tutti gli edifici',
    'add_amenity': 'Aggiungi servizi',
    'no_building_amenities_found': 'Nessun servizio dell\'edificio trovato',
    'all_buildings_2': 'Tutti gli edifici',
    'all_units': 'Tutte le unità',
    'add_unit_amenity': 'Aggiungi servizi all\'unità',
    'no_unit_amenities_found': 'Nessun servizio dell\'unità trovato',

    'unit_amenities': 'Servizi unità',
    'col_monthly_fee': 'Canone mensile',
    'col_available': 'Disponibile',
    'all_buildings_3': 'Tutti gli edifici',
    'available_2': 'Disponibile',
    'reserved': 'Riservato',
    'add_space': 'Aggiungi spazio',
    'no_parking_spaces_found': 'Nessun parcheggio trovato',
    'assign': 'Assegnare',
    'unassign': 'Annulla assegnazione',
    'spaces': 'Spazi',
    'driveway_area': 'Zona carrabile',
    'cancel_4': 'Annulla',
    'complete': 'Completo',
    'confirm_1': 'Conferma',
    'cancel_5': 'Annulla',
    'complete_1': 'Completo',
    'assign_space': 'Assegna spazio',
    'select_tenant_1': 'Seleziona inquilino',
    'choose_tenant': '-- Scegli locatario --',
    'select_owner': 'Seleziona Proprietario',
    'choose_owner': '-- Scegli proprietario --',
    'cancel_6': 'Annulla',
    'assign_1': 'Assegnare',
    'new_amenity_booking': 'Nuova prenotazione di servizi',
    'amenity': 'Servizi *',
    'select_amenity': 'Seleziona servizi…',
    'tenant_1': 'Locatario *',
    'select_tenant_2': 'Seleziona inquilino...',
    'date_1': 'Data *',
    'notes_3': 'Note',
    'cancel_7': 'Annulla',
    'deactivated': 'Disattivato',
    'max_uses': 'Usi massimi',
    'generate_application_link': 'Genera collegamento all\'applicazione',
    'building_4': 'Edificio *',
    'specific_unit_optional': 'Unità specifica (opzionale)',
    'any_unit_in_building': 'Qualsiasi unità nell\'edificio',
    'unit_5': 'Unità',
    'floor_5': '– Pavimento',
    'label': 'Etichetta',
    'expires_at': 'Scade alle',
    'max_uses_1': 'Usi massimi',
    'cancel_8': 'Annulla',
    'label_unit': 'Etichetta/Unità',
    'token_url': 'URL del token',
    'uses': 'Usi',
    'status_1': 'Stato',
    'no_links_yet_click_generate_link_to_crea': 'Nessun collegamento ancora. Fai clic su "Genera collegamento" per crearne uno.',
    'link_generated': 'Link generato!',
    'failed_to_generate_link': 'Impossibile generare il link',
    'failed_to_load_links': 'Impossibile caricare i link',
    'link_deactivated': 'Link disattivato',
    'search_label_building_token': 'Cerca per etichetta, edificio o token…',
    'links_count': '{{count}} link',
    'untitled': 'Senza titolo',
    'open_form': 'Apri modulo',
    'no_links_match_filters': 'Nessun link corrisponde ai tuoi filtri.',
    'unit_6': '· Unità',
    '1_30': '1–30',
    '31_60': '31–60',
    '61_90': '61–90',
    'building_amenity': 'Amenità dell\'edificio',
    'amenity_details': 'Dettagli sui servizi',
    'building_5': 'Edificio *',
    'name_4': 'Nome *',
    'category_1': 'Categoria',
    'monthly_fee': 'Tariffa mensile ($)',
    'operating_hours': 'Orari di funzionamento',
    'capacity': 'Capacità',
    'description_1': 'Descrizione',
    'notes_4': 'Note',
    'available_for_booking': 'Disponibile per la prenotazione',
    'cancel_9': 'Annulla',
    'saving_1': 'Salvataggio…',
    'bulk_tenant_import': 'Importazione in blocco di tenant',
    'import_tenants_from_a_csv_file_apartment': 'Importa inquilini da un file CSV: gli appartamenti vengono abbinati per nome dell\'edificio + numero dell\'unità',
    'download_csv_template': 'Scarica il modello CSV',
    'use_this_template_to_format_your_data_co': 'Utilizza questo modello per formattare correttamente i tuoi dati',
    'template': 'Modello',
    'required_columns': 'Colonne obbligatorie',
    'optional_columns': 'Colonne facoltative',
    'payment_date_2': 'data_pagamento',
    'day_of_month_1_31': '= giorno del mese (1–31)  ·',
    'contract_start_contract_end': 'inizio_contratto / fine_contratto',
    'yyyy_mm_dd': '= AAAA-MM-GG  ·',
    'en_ar_fr_de_it_sp': '= en, ar, fr, de, it, sp',
    'parsing_csv': 'Analisi CSV in corso…',
    'or_click_to_browse_max_2_mb': 'oppure fai clic per sfogliare: massimo 2 MB',
    'import_preview': 'Importa anteprima',
    'rows_found_review_before_importing': 'righe trovate: verifica prima dell\'importazione',
    'start_over': 'Ricominciare daccapo',
    'name_5': 'Nome',
    'phone_5': 'Telefono',
    'building_unit': 'Edificio/Unità',
    'contract_1': 'Contratto',
    'status_2': 'Stato',
    'empty_key_11': '·#',
    'ready_to_import': 'Pronto per l\'importazione',
    'tenant_2': 'inquilino',
    'row': 'fila',
    'with_errors_will_be_skipped': 'con errori verranno saltati',
    'no_valid_rows_to_import': 'Nessuna riga valida da importare',
    'fix_the_errors_in_your_csv_and_try_again': 'Correggi gli errori nel tuo CSV e riprova',
    'upload_new_file': 'Carica nuovo file',
    'import_complete': 'Importazione completata',
    'tenants_successfully_imported': 'Inquilini importati con successo',
    'row_1': 'fila',
    'skipped_rows': 'Righe saltate',
    'row_2': 'Fila',
    'import_another_file': 'Importa un altro file',
    'view_tenants': 'Visualizza inquilini',
    'upload_document': 'Carica documento',
    'tenant_3': 'Locatario *',
    'select_tenant_3': 'Seleziona inquilino...',
    'document_name': 'Nome del documento *',
    'category_2': 'Categoria',
    'file_pdf_image_word_max_5mb': 'File * (PDF, Immagine, Word — massimo 5 MB)',
    'upload_document_1': 'Carica documento',
    'document_management': 'Gestione dei documenti',
    'document': 'documento',
    'across_all_tenants': 'tra tutti gli inquilini',
    'upload': 'Carica',
    'all_categories': 'Tutte le categorie',
    'document_1': 'Documento',
    'tenant_4': 'Inquilino',
    'category_3': 'Categoria',
    'status_3': 'Stato',
    'uploaded': 'Caricato',
    'actions_1': 'Azioni',
    'no_documents_found': 'Nessun documento trovato',
    'of_2': 'di',
    'prev': 'Prec',
    'next_1': 'Avanti',
    'select_tenant_required': 'Seleziona un inquilino',
    'document_name_required': 'Il nome del documento è obbligatorio',
    'select_file_required': 'Seleziona un file',
    'document_uploaded': 'Documento caricato',
    'upload_failed': 'Caricamento fallito',
    'failed_to_load_documents': 'Impossibile caricare i documenti',
    'document_status_updated': 'Stato del documento aggiornato',
    'failed_to_update_status': 'Impossibile aggiornare lo stato',
    'confirm_delete_doc': 'Eliminare "{{name}}"? Questa azione può essere annullata dall\'amministratore.',
    'failed_to_delete_document': 'Eliminazione fallita',
    'documents_count': '{{count}} documento/i',
    'search_by_tenant_name': 'Cerca per nome inquilino…',
    'doc_results_count': '{{count}} risultato/i',
    'uploaded_from': 'Caricato dal',
    'uploaded_to': 'Caricato fino al',
    'doc_cat_id': 'Documento d\'identità',
    'doc_cat_contract': 'Contratto',
    'doc_cat_financial': 'Finanziario',
    'doc_cat_insurance': 'Assicurazione',
    'doc_cat_other': 'Altro',
    'approved': 'Approvato',
    'file_1': 'File',
    'open_eviction_case': 'Caso di sfratto aperto',
    'tenant_5': 'Inquilino',
    'tenant_6': 'Locatario *',
    'building_apartment_auto_filled_from_tena': 'Edificio e appartamento compilati automaticamente dal registro dell\'inquilino',
    'case_details': 'Dettagli del caso',
    'reason': 'Motivo *',
    'notice_type': 'Tipo di avviso',
    'cancel_10': 'Annulla',
    'open_case': 'Caso aperto',
    'eviction_management': 'Gestione degli sfratti',
    'track_and_manage_eviction_cases_from_not': 'Tieni traccia e gestisci i casi di sfratto dall\'avviso al completamento',
    'new_case': 'Nuovo caso',
    'pipeline': 'Conduttura',
    'no_eviction_cases_found': 'Nessun caso di sfratto trovato',
    'advance': 'Avanza →',
    'eviction_case': 'Caso di sfratto n.',
    'tenant_7': 'Inquilino',
    'unit_7': '· Unità n.',
    'reason_1': 'Motivo',
    'amount_owed_1': 'Importo dovuto',
    'pipeline_status': 'Stato della pipeline',
    'notes_5': 'Note',
    'expense_details': 'Dettagli sulle spese',
    'payment_info': 'Informazioni sul pagamento',
    'description_2': 'Descrizione',
    'no_accounts_posted_yet': 'Nessun account ancora pubblicato.',
    'total_1': 'Totale',
    'assets': 'Beni',
    'liabilities': 'Passività',
    'select_a_date_and_click_run_to_generate': 'Selezionare una data e fare clic su Esegui per generare il bilancio.',
    'from_2': 'Da',
    'to_2': 'A',
    'run_1': 'Corri',
    'operating_activities': 'Attività operative',
    'net_operating_cash_flow': 'Flusso di cassa operativo netto',
    'financing_activities': 'Attività di finanziamento',
    'net_financing_cash_flow': 'Flusso di cassa netto del finanziamento',
    'net_change_in_cash': 'Variazione netta in contanti',
    'select_a_date_range_and_click_run': 'Seleziona un intervallo di date e fai clic su Esegui.',
    'balance_sheet': 'Stato patrimoniale',
    'cash_flow_statement': 'Flusso di cassa',
    'total_assets': 'Totale attività',
    'total_liabilities': 'Totale passività',
    'total_equity': 'Totale patrimonio netto',
    'bs_balanced_msg': '✓ Bilanciato — Attività = Passività + Patrimonio netto',
    'bs_unbalanced_msg': '⚠ Non bilanciato — verifica le scritture contabili',
    'operating_cash_flow': 'Flusso di cassa operativo',
    'financing_cash_flow': 'Flusso di cassa finanziario',
    'edit_expense': 'Modifica spesa',
    'expense_updated': 'Spesa aggiornata',
    'rated': 'valutato',
    'property_inspections': 'Ispezioni immobiliari',
    'move_in_move_out_periodic_20_item_standa': 'Trasferimento · Trasferimento · Periodico · Lista di controllo standardizzata di 20 elementi',
    'new_inspection': 'Nuova ispezione',
    'no_inspections_found': 'Nessuna ispezione trovata.',
    'adjust_the_filters_or_create_a_new_inspe': 'Regola i filtri o crea una nuova ispezione.',
    'showing_1': 'Mostrare',
    'of_3': 'di',
    'new_inspection_1': 'Nuova ispezione',
    'apartment_2': 'Appartamento',
    'nothing_found': 'Niente trovato.',
    'unit_8': '— Unità',
    'no_active_tenant_on_this_unit': 'Nessun inquilino attivo su questa unità.',
    'tenant_8': 'Inquilino',
    'no_tenant_vacant': 'Nessun inquilino (vacante)',
    'inspection_type': 'Tipo di ispezione',
    'overall_condition': 'Condizioni generali',
    'a_20_item_standardized_checklist_entranc': 'Verrà creata automaticamente una checklist standardizzata di 20 elementi (Ingresso, Soggiorno, Cucina, Bagno, Camera da letto, Generale).',
    'cancel_11': 'Annulla',
    'creating': 'Creazione…',
    'create_inspection': 'Crea ispezione',
    'unit_9': '· Unità',
    'tenant_9': 'Locatario:',
    'inspector': 'Ispettore:',
    'print_2': 'Stampa',
    'checklist_completion': 'Completamento della lista di controllo',
    'overall': 'Nel complesso:',
    'click_a_condition_button_to_rate_each_it': 'Fare clic sul pulsante di una condizione per valutare ciascun articolo. Le note vengono salvate automaticamente su sfocatura.',
    'general_notes_1': 'Note generali',
    'close_1': 'Chiudi',
    'completing': 'Completamento…',
    'mark_as_completed': 'Contrassegna come completato',
    'close_2': 'Chiudi',
    'signing': 'Firma…',
    'sign_inspection': 'Ispezione dei segni',
    'signing_is_final_and_cannot_be_undone': 'La firma è definitiva e non può essere annullata.',
    'covered_entity': 'Entità coperta',
    'select': 'Seleziona',
    'policy_details': 'Dettagli della politica',
    'insurer_name': 'Nome dell\'assicuratore *',
    'start_date_2': 'Data di inizio',
    'notes_6': 'Note',
    'cancel_12': 'Annulla',
    'manage_tenant_owner_and_building_insuran': 'Gestisci le polizze assicurative per inquilini, proprietari e edifici',
    'empty_key_12': '✓',
    'new_lease_application': 'Nuova richiesta di locazione',
    'applicant_information': 'Informazioni sul richiedente',
    'full_name_1': 'Nome completo *',
    'email_3': 'E-mail',
    'phone_6': 'Telefono',
    'date_of_birth': 'Data di nascita',
    'current_address': 'Indirizzo attuale',
    'employment': 'Occupazione',
    'employment_status': 'Stato occupazionale',
    'monthly_income': 'Reddito mensile ($)',
    'employer_name': 'Nome del datore di lavoro',
    'employer_phone': 'Telefono del datore di lavoro',
    'unit_preferences': 'Preferenze unità',
    'building_6': 'Edificio',
    'unit_10': 'Unità',
    'desired_move_in': 'Trasferimento desiderato',
    'desired_lease_months': 'Locazione desiderata (mesi)',
    'has_pets': 'Ha animali domestici',
    'pet_details': 'Dettagli sugli animali domestici',
    'notes_7': 'Note',
    'cancel_13': 'Annulla',
    'submit_application': 'Invia domanda',
    'review_and_approve_prospective_tenant_ap': 'Esaminare e approvare le domande dei potenziali inquilini',
    'all_buildings_4': 'Tutti gli edifici',
    'no_applications_found': 'Nessuna applicazione trovata',
    'showing_2': 'Mostrare',
    'of_4': 'di',
    'prev_1': 'Prec',
    'next_2': 'Avanti',
    'close_3': 'Chiudi',
    'unit_11': '· Unità n.',
    'monthly_rent_2': 'Affitto Mensile *',
    'discount_1': 'Sconto',
    'contract_start_1': 'Inizio contratto *',
    'contract_end_1': 'Fine contratto *',
    'payment_day_of_month': 'Giorno del mese di pagamento *',
    'application': 'Applicazione',
    'rejection_reason': 'Motivo del rifiuto',
    'cancel_14': 'Annulla',
    'app_search_placeholder': 'Cerca per nome, e-mail, telefono…',
    'app_status_submitted': 'Inviato',
    'app_status_under_review': 'In revisione',
    'app_status_approved': 'Approvato',
    'app_status_rejected': 'Rifiutato',
    'app_status_waitlisted': 'In lista d\'attesa',
    'app_status_withdrawn': 'Ritirato',
    'app_status_converted': 'Convertito',
    'sort_newest': 'Più recente prima',
    'sort_movein_asc': 'Ingresso ↑ Prima',
    'sort_movein_desc': 'Ingresso ↓ Ultima',
    'sort_income_asc': 'Reddito ↑ Più basso',
    'sort_income_desc': 'Reddito ↓ Più alto',
    'all_employment': 'Tutti i tipi di impiego',
    'emp_other': 'Altro',
    'move_in_from': 'Ingresso dal',
    'move_in_to': 'Ingresso al',
    'application_results_count': '{{count}} domanda/e',
    'failed_to_load_lease_applications': 'Caricamento domande non riuscito',
    'status_updated_to': 'Stato aggiornato a {{status}}',
    'rent_dates_payment_required': 'Affitto, date di inizio/fine e giorno di pagamento obbligatori',
    'converted_to_tenant_success': 'Convertito in inquilino',
    'conversion_failed': 'Conversione non riuscita',
    'lease_duration_months_label': 'Durata del contratto',
    'lease_duration_months': '{{n}} mesi',
    'details_not_provided': 'dettagli non forniti',
    'reviewed_by': 'Esaminato da',
    'reviewed_at': 'Esaminato il',
    'converting': 'Conversione in corso…',
    'applicant_name_required': 'Il nome del richiedente è obbligatorio',
    'failed_to_submit_application': 'Invio della domanda non riuscito',
    'submitting': 'Invio in corso…',
    'update_failed': 'Aggiornamento non riuscito',
    'nightly_scan_flags_leases_expiring_in_90': 'Scansione notturna dei contrassegni dei contratti di locazione con scadenza tra 90 giorni: bozze di offerte create automaticamente, inviate con un clic',
    'send_all_drafts': 'Invia tutte le bozze (',
    'expiring_within_90_days': 'con scadenza entro 90 giorni',
    'without_an_offer_yet': 'senza ancora un\'offerta',
    'd_2': 'd',
    'offer_sent': 'offerta inviata',
    'no_offer': 'nessuna offerta',
    'all_statuses_1': 'Tutti gli stati',
    'no_renewals_found': 'Nessun rinnovo trovato',
    'd_left': 'd lasciato',
    'convert_lease': 'Convertire contratto di locazione',
    'counter_offer': 'Controfferta',
    'tenant_10': 'Locatario:',
    'counter_rent_amount': 'Importo del contatore dell\'affitto *',
    'cancel_15': 'Annulla',
    'send_counter': 'Invia contatore',
    'error_loading_renewals': 'Impossibile caricare i rinnovi',
    'offer_sent_2': 'Offerta inviata',
    'error_sending_offer': 'Impossibile inviare l\'offerta',
    'renewal_accepted': 'Rinnovo accettato',
    'error_accepting_renewal': 'Impossibile accettare il rinnovo',
    'decline_renewal_title': 'Rifiuta rinnovo',
    'decline_renewal_msg': 'Sei sicuro di voler rifiutare questa offerta di rinnovo?',
    'renewal_declined': 'Rinnovo rifiutato',
    'error_declining_renewal': 'Impossibile rifiutare il rinnovo',
    'lease_converted_msg': 'Contratto convertito — record inquilino aggiornato!',
    'error_converting_renewal': 'Impossibile convertire il rinnovo',
    'drafts_created': '{{count}} bozza/e offerta create!',
    'no_new_drafts_needed': 'Nessuna nuova bozza necessaria — tutti i contratti in scadenza hanno già offerte.',
    'error_generating_drafts': 'Impossibile generare le bozze',
    'no_draft_renewals_to_send': 'Nessun rinnovo in bozza da inviare',
    'send_all_draft_offers_title': 'Invia tutte le offerte in bozza',
    'send_all_draft_offers_msg': 'Inviare offerte di rinnovo a tutti i {{count}} inquilini in bozza (email + WhatsApp)?',
    'offers_sent': '{{count}} offerta/e inviata/e!{{failed}}',
    'error_sending_offers': 'Impossibile inviare le offerte',
    'counter_offer_sent': 'Controfferta inviata',
    'error_sending_counter': 'Impossibile inviare la controfferta',
    'search_tenant_unit_building': 'Cerca inquilino, unità, edificio…',
    'all_risk': 'Tutti i rischi',
    'risk_low': 'Rischio basso',
    'risk_medium': 'Rischio medio',
    'risk_high': 'Rischio alto',
    'renewals_count': '{{count}} rinnovo/i',
    'leases_expiring_90d': '{{count}} contratto/i in scadenza entro 90 giorni',
    'viewed_1': 'Visualizzato',
    'accepted_1': 'Accettato',
    'counter_offered': 'Controfferta',
    'declined_1': 'Rifiutato',
    'full_lease_lifecycle_create_renew_termin': 'Ciclo di vita completo del leasing: creazione, rinnovo, risoluzione, cronologia',
    'new_lease': 'Nuovo contratto di locazione',
    'all_status_1': 'Tutti gli stati',
    'active_1': 'Attivo',
    'expired_1': 'Scaduto',
    'renewed': 'Rinnovato',
    'all_buildings_5': 'Tutti gli edifici',
    'no_leases_found': 'Nessun contratto di locazione trovato',
    'expired_2': 'Scaduto',
    'd_left_1': 'd lasciato',
    'd_left_2': 'd lasciato',
    'd_3': 'd',
    'renew': 'Rinnovare',
    'terminate': 'Terminare',
    'terminate_lease': 'Terminare il contratto di locazione',
    'this_action_cannot_be_undone_the_lease_w': 'Questa azione non può essere annullata. Il contratto di locazione verrà definitivamente risolto.',
    'cancel_16': 'Annulla',
    'empty_key_13': '—#',
    'new_start_date': 'Nuova data di inizio *',
    'monthly_rent_3': 'Affitto mensile ($) *',
    'lease_type_1': 'Tipo di contratto di locazione',
    'fixed_term_1': 'Tempo determinato',
    'month_to_month_1': 'Mese per mese',
    'annual_1': 'Annuale',
    'renew_lease_1': 'Rinnovare il contratto di locazione',
    'cancel_17': 'Annulla',
    'expiry_days': '{{days}}g',
    'leases_expiring_within_60d': '{{count}} contratto/i in scadenza entro 60 giorni',
    'sort_default': 'Ordina: Predefinito',
    'sort_expiry_asc': 'Scadenza ↑ Prima',
    'sort_expiry_desc': 'Scadenza ↓ Ultima',
    'sort_rent_asc': 'Affitto ↑ Più basso',
    'sort_rent_desc': 'Affitto ↓ Più alto',
    'sort_name_asc': 'Inquilino A → Z',
    'expiring_within': 'In scadenza entro',
    'any_expiry': 'Qualsiasi scadenza',
    'days_lte': '≤ {{n}} giorni',
    'create_tenant_for_lease': 'Aggiungi un inquilino per generare automaticamente un record di contratto.',
    'terminating': 'Risoluzione in corso…',
    'enter_termination_reason': 'Inserisci il motivo della risoluzione…',
    'failed_to_load_leases': 'Caricamento contratti non riuscito',
    'renewal_failed': 'Rinnovo non riuscito',
    'terminate_failed': 'Risoluzione non riuscita',
    'start_date_and_rent_required': 'Data di inizio e affitto mensile obbligatori',
    'lease_results_count': '{{count}} contratto/i',
    'description_3': 'Descrizione',
    'tenant_11': 'Inquilino',
    'close_4': 'Chiudi',
    'new_maintenance_schedule': 'Nuovo programma di manutenzione',
    'schedule_details': 'Dettagli del programma',
    'building_7': 'Edificio',
    'all_buildings_6': 'Tutti gli edifici',
    'frequency': 'Frequenza *',
    'first_due_date': 'Prima data di scadenza *',
    'description_4': 'Descrizione',
    'cancel_18': 'Annulla',
    'create_schedule': 'Crea pianificazione',
    'maintenance_schedules': 'Programmi di manutenzione',
    'preventive_maintenance_tracking': 'Monitoraggio della manutenzione preventiva',
    'new_schedule': 'Nuovo programma',
    'overdue_work_orders_will_be_auto_created': 'in ritardo: gli ordini di lavoro verranno creati automaticamente stasera',
    'no_schedules_found': 'Nessun programma trovato',
    'history': 'Storia —',
    'no_history_yet': 'Nessuna storia ancora',
    'wo': 'WO #',
    'empty_key_14': '✓',
    'owner_ledger': 'Registro del proprietario',
    'immutable_financial_history': '— storia finanziaria immutabile',
    'refresh_1': 'Aggiorna',
    'add_entry': 'Aggiungi voce',
    'payouts': 'Pagamenti',
    'add_manual_ledger_entry': 'Aggiungi inserimento contabile manuale',
    'amount_3': 'Importo *',
    'description_5': 'Descrizione *',
    'cancel_19': 'Annulla',
    'showing_3': 'Mostrare',
    'of_5': 'di',
    'prev_2': 'Prec',
    'next_3': 'Avanti',
    'new_parking_space': 'Nuovo parcheggio',
    'creation_mode': 'Modalità di creazione',
    'single_space': 'Spazio unico',
    'bulk_generation': 'Generazione di massa',
    'building_8': 'Edificio *',
    'select_building_1': 'Seleziona edificio...',
    'prefix': 'Prefisso',
    'start_number': 'Numero di partenza *',
    'end_number': 'Numero finale *',
    'pad_with_zeros_e_g_01_02': 'Pad con zeri? (es. 01, 02)',
    'space_number': 'Numero Spazio *',
    'level': 'Livello',
    'type_1': 'Digitare',
    'monthly_fee_1': 'Tariffa mensile ($)',
    'notes_8': 'Note',
    'cancel_20': 'Annulla',
    'saving_2': 'Salvataggio…',
    'create_space': 'Crea spazio',
    'tenant_screening': 'Screening degli inquilini',
    'identity_verification_background_checks': 'Verifica dell\'identità e controlli dei precedenti',
    'unit_12': 'Unità',
    'select_a_tenant_to_view_or_start_their_s': 'Seleziona un inquilino per visualizzarne o avviarne lo screening',
    'final_decision': 'Decisione finale',
    'set_on': 'Accendi',
    'identity_verification': 'Verifica dell\'identità',
    'document_2': 'Documento:',
    'name_6': 'Nome:',
    'start_identity_verification': 'Avvia la verifica dell\'identità',
    'link_was_shared_with_the_tenant_waiting': 'Il collegamento è stato condiviso con l\'affittuario, in attesa che lo completasse.',
    'background_check_checkr': 'Controllo dei precedenti (Checkr)',
    'adjudication': 'Giudizio:',
    'checks': 'Controlli:',
    'start_background_check': 'Avvia il controllo dei precedenti',
    'united_states': 'Stati Uniti',
    'canada': 'Canada',
    'fcra_consent_required': 'Consenso FCRA richiesto',
    'under_the_fair_credit_reporting_act_fcra': 'Ai sensi del Fair Credit Reporting Act (FCRA), è necessario ottenere il consenso scritto del richiedente prima di eseguire un controllo dei precedenti. L\'inquilino riceverà un\'e-mail da Checkr per completare il processo.',
    'i_confirm_the_applicant_has_provided_wri': 'Confermo che il richiedente ha fornito il consenso scritto per questo controllo dei precedenti',
    'cancel_21': 'Annulla',
    'invitation_sent_waiting_for_the_applican': 'Invito inviato: in attesa che il richiedente lo completi. Checkr lo aggiornerà automaticamente.',
    'set_final_decision': 'Imposta la decisione finale',
    'final_screening_decision': 'Decisione finale sullo screening',
    'manual_review': 'Revisione manuale',
    'cancel_22': 'Annulla',
    'no_screening_started_for_this_tenant_yet': 'Nessuno screening è ancora iniziato per questo inquilino.',
    'empty_key_15': '($) *',
    'prospect_information': 'Informazioni sul potenziale cliente',
    'showing_details': 'Visualizzazione dei dettagli',
    'empty_key_16': '·#',
    'empty_key_17': '·#',
    'add_unit_amenity_1': 'Aggiungi servizi all\'unità',
    'bulk_addition_mode': 'Modalità di aggiunta in blocco',
    'add_this_amenity_to_multiple_units_at_on': 'Aggiungi questa comodità a più unità contemporaneamente',
    'amenity_details_1': 'Dettagli sui servizi',
    'clear_all': 'Cancella tutto',
    'nothing_found_1': 'Niente trovato.',
    'amenity_name': 'Nome servizio *',
    'category_4': 'Categoria',
    'condition': 'Condizione',
    'notes_9': 'Note',
    'cancel_23': 'Annulla',
    'saving_3': 'Salvataggio…',
    'add_amenity_1': 'Aggiungi servizi',
    'n_more': '+{{n}} altro',
    'board_view': 'Vista bacheca',
    'main_level': 'Livello principale',
    'unassigned_1': 'Non assegnato',
    'unit_cat_appliance': 'Elettrodomestico',
    'unit_cat_climate': 'Climatizzazione',
    'unit_cat_view': 'Vista',
    'unit_cat_layout': 'Disposizione',
    'unit_cat_finish': 'Finitura',
    'unit_cat_storage': 'Deposito',
    'unit_cat_connectivity': 'Connettività',
    'unit_cat_safety': 'Sicurezza',
    'unit_cat_other': 'Altro',
    'bld_cat_general': 'Generale',
    'bld_cat_fitness': 'Fitness',
    'bld_cat_pool': 'Piscina',
    'bld_cat_common_area': 'Area comune',
    'bld_cat_outdoor': 'Esterno',
    'bld_cat_security': 'Sicurezza',
    'bld_cat_business': 'Business',
    'bld_cat_parking': 'Parcheggio',
    'bld_cat_pet': 'Animali domestici',
    'bld_cat_laundry': 'Lavanderia',
    'bld_cat_storage': 'Deposito',
    'all_fields_required': 'Tutti i campi sono obbligatori',
    'booking_failed': 'Prenotazione fallita',
    'failed_to_load_amenity': 'Impossibile caricare il servizio',
    'name_required': 'Il nome è obbligatorio',
    'amenity_updated': 'Servizio aggiornato',
    'amenity_added': 'Servizio aggiunto',
    'open_time': 'Apertura',
    'close_time': 'Chiusura',
    'max_occupancy': 'Occupazione massima',
    'edit_building_amenity': 'Modifica servizio edificio',
    'new_building_amenity': 'Nuovo servizio edificio',
    'unit_required': "L'unità è obbligatoria",
    'at_least_one_unit_required': 'È richiesta almeno una unità',
    'unit_amenity_updated': "Servizio dell'unità aggiornato",
    'amenity_bulk_added': 'Servizio aggiunto a {{count}} unità',
    'selected_units_label': 'Unità selezionate *',
    'unit_searchable_label': 'Unità * (ricercabile)',
    'search_add_multiple_units': 'Cerca e aggiungi più unità...',
    'search_unit_by_num': 'Cerca unità per n. o edificio...',
    'cond_new': 'Nuovo',
    'cond_excellent': 'Eccellente',
    'cond_good': 'Buono',
    'cond_fair': 'Discreto',
    'cond_needs_repair': 'Da riparare',
    'meter_accounts_rubs_billing_and_per_tena': 'Conti del contatore, fatturazione in RUB e spese di utilità per inquilino',
    'option_a_metered': 'Opzione A — Misurato:',
    'add_account_record_reading_generate_bill': 'Aggiungi account → registra la lettura → genera fatture → addebita sul registro',
    'option_c_rubs': 'Opzione B — RUBS:',
    'building_level_meter_split_equally_acros': 'Il contatore a livello di edificio è suddiviso equamente tra tutti gli inquilini attivi',
    'reading_recorded_for': 'Lettura registrata per',
    'no_utility_accounts_yet_add_one_to_start': 'Nessun account di utenza ancora: aggiungine uno per avviare la fatturazione a consumo.',
    'no_readings': 'Nessuna lettura',
    'shared': 'Condiviso',
    'reading': 'Lettura',
    'all_statuses_2': 'Tutti gli stati',
    'no_bills_yet_generate_from_meter_readings': 'Ancora nessuna fattura — aggiungi conti contatore, registra letture, poi genera fatture.',
    'accounts': 'Conti',
    'bills': 'Fatture',
    'benchmarking': 'Benchmarking',
    'total_bills': 'Totale fatture',
    'total_billed': 'Totale fatturato',
    'charge': 'Carica',
    'unit_13': 'Unità',
    'notes_10': 'Note',
    'cancel_24': 'Annulla',
    'loading_1': 'Caricamento…',
    'accounts_tracked': 'conti tracciati',
    'monthly_consumption_last_6_months': 'Consumo mensile: ultimi 6 mesi',
    'monthly_cost': 'Costo mensile ($)',
    'no_readings_recorded_yet_for': 'Nessuna lettura ancora registrata per',
    'valuation_details': 'Dettagli sulla valutazione',
    'building_9': 'Edificio *',
    'market_value': 'Valore di mercato ($) *',
    'valuation_method': 'Metodo di valutazione',
    'notes_11': 'Note',
    'cancel_25': 'Annulla',
    'portal': 'Portale ✓',
    'invite_as_system_user_full_portal_access': 'Invita come utente di sistema (accesso completo al portale)',
    'this_will_create_a_staff_account_with_th': 'Ciò creerà un account staff con il ruolo di "venditore". Riceveranno un invito via email per impostare la password.',
    'record_violation': 'Violazione del record',
    'tenant_unit': 'Inquilino e unità',
    'tenant_12': 'Locatario *',
    'unit_14': '— Unità',
    'apartment_id': 'Identificativo dell\'appartamento',
    'auto_filled': 'compilato automaticamente',
    'violation_details': 'Dettagli della violazione',
    'title_1': 'Titolo *',
    'type_2': 'Tipo *',
    'severity': 'Gravità *',
    'incident_date': 'Data dell\'incidente *',
    'fine_amount_optional': 'Importo della multa (facoltativo)',
    'description_6': 'Descrizione *',
    'if_a_fine_amount_is_entered_it_will_be_a': 'Se viene inserito un importo di multa, verrà automaticamente addebitato sul registro dell\'inquilino.',
    'cancel_26': 'Annulla',
    'record_violation_1': 'Violazione del record',
    'violations_notices': 'Violazioni e avvisi',
    'track_lease_violations_and_issue_formal': 'Tieni traccia delle violazioni del contratto di locazione ed emetti avvisi legali formali',
    'new_violation': 'Nuova violazione',
    'how_it_works_1': 'Come funziona',
    'all_statuses_3': 'Tutti gli stati',
    'notice': 'Avviso',
    'resolve': 'Risolvi',
    'issue_legal_notice': 'Emettere avviso legale',
    'cancel_27': 'Annulla',
    'add_webhook_endpoint': 'Aggiungi endpoint webhook',
    'push_events_to_your_external_systems': 'Invia eventi ai tuoi sistemi esterni',
    'successfully_created': 'Creato con successo!',
    'save_your_signing_secret_now_it_won_t_be': 'Salva subito il segreto della tua firma: non verrà più mostrato.',
    'copy_secret': 'Copia segreto',
    'done_return': 'Fatto e restituito',
    'connection_details': 'Dettagli di connessione',
    'payload_url': 'URL del carico utile',
    'description_7': 'Descrizione',
    'event_subscriptions': 'Abbonamenti agli eventi',
    'you_can_always_add_more_events_later': 'Puoi sempre aggiungere altri eventi in seguito.',
    'register_endpoint': 'Registra l\'endpoint',
    'cancel_28': 'Annulla',
    'assign_a_new_task_to_a_maintenance_provi': 'Assegnare una nuova attività a un fornitore di manutenzione',
    'work_order_details': 'Dettagli dell\'ordine di lavoro',
    'work_order_title': 'Titolo dell\'ordine di lavoro',
    'task_description': 'Descrizione dell\'attività',
    'scheduling_reference': 'Pianificazione e riferimento',
    'maintenance_request_id': 'ID della richiesta di manutenzione',
    'assignment': 'Compito',
    'select_a_maintenance_provider': 'Seleziona un fornitore di servizi di manutenzione',
    'priority_level_level': 'Livello di priorità Livello',
    'dispatch_work_order': 'Ordine di lavoro di spedizione',
    'discard_changes': 'Annulla modifiche',
    'pro_tip': 'Suggerimento professionale',
    'dispatching_a_work_order_will_immediatel': 'L\'invio di un ordine di lavoro avviserà immediatamente il fornitore tramite il suo portale e tramite e-mail, se abilitato.',
    'update_work_order': 'Aggiorna ordine di lavoro',
    'status_priority': 'Stato e priorità',
    'status_4': 'Stato',
    'completed_date': 'Data di completamento',
    'invoice': 'Fattura',
    'invoice_amount': 'Importo della fattura',
    'invoice_status': 'Stato della fattura',
    'cancel_29': 'Annulla',
    'vendor_work_order_management': 'Gestione degli ordini di lavoro dei fornitori',
    'refresh_2': 'Aggiorna',
    'new_work_order': 'Nuovo ordine di lavoro',
    'all_statuses_4': 'Tutti gli stati',
    'no_work_orders_found': 'Nessun ordine di lavoro trovato',
    'mr': 'SIGNOR:',
    'work_order': 'Ordine di lavoro n.',
    'priority_1': 'priorità',
    'description_8': 'Descrizione',
    'linked_maintenance_request': 'Richiesta di manutenzione collegata',
    'unit_15': 'Unità',
    'invoice_1': 'Fattura',
    'view_invoice_document': 'Visualizza il documento fattura',
    'review_approve_invoice': 'Revisione e approvazione della fattura',
    'edit_work_order': 'Modifica ordine di lavoro',
    'approve_invoice': 'Approva fattura',
    'you_are_approving_a_vendor_invoice_of': 'Stai approvando una fattura fornitore di',
    'for': 'per',
    'charge_to_tenant_ledger': 'Addebito sul registro dell\'inquilino',
    'the_cost_will_be_automatically_added_as': 'Il costo verrà automaticamente aggiunto come addebito sul registro dell\'inquilino affinché possa pagarlo.',
    'organization_absorbs_cost': 'L’organizzazione assorbe i costi',
    'the_tenant_will_not_be_charged_this_crea': 'L\'affittuario non verrà addebitato. Ciò crea una voce di contabilità fornitori per l\'organizzazione.',
    'cancel_30': 'Annulla',
    'loading_2': 'Caricamento…',
    'page_not_found': 'Pagina non trovata',
    'the_page_you_re_looking_for_doesn_t_exis': 'La pagina che stai cercando non esiste.',
    'go_to_dashboard': 'Vai alla dashboard',
    'clear_signature': 'Firma chiara',
    'i_consent_to_use_electronic_signatures_a': 'Acconsento all\'uso delle firme elettroniche e accetto che la mia firma elettronica',
    'cancel_31': 'è l\'equivalente legale della mia firma manuale su questo contratto. Capisco',
    'sign_contract_1': 'di avere il diritto di ricevere copia cartacea del presente documento.',
    'by_signing_this_document_electronically': 'Annulla',
    'subscription_locked': 'Firmare il contratto',
    'your_subscription_status_is': 'Firmando questo documento elettronicamente, riconosci che la tua firma elettronica',
    'please_renew_your_subscription_to_contin': 'è giuridicamente vincolante e ha lo stesso effetto di una firma autografa. Il tuo indirizzo IP',
    'payment_options': 'e il timestamp verranno registrati a scopo di verifica.',
    'please_contact_the_administrator_to_proc': 'Abbonamento bloccato',
    'contact_admin_to_renew': 'Lo stato del tuo abbonamento è',
    'request_sent_pending_approval': '.',
    'need_help_contact_support_at_support_qua': 'Rinnova il tuo abbonamento per continuare a gestire le tue proprietà.',
    'requires_the': 'Opzioni di pagamento',
    'is_a_pro_feature': 'Contatta l\'amministratore per elaborare il pagamento e riattivare l\'abbonamento.',
    'upgrade_to_pro_to_unlock_ai_powered_inte': 'Contatta l\'amministratore per rinnovare',
    'upgrade_to_pro_1': 'Richiesta inviata! In attesa di approvazione.',
    'starting_at_3_20_unit_month_no_minimum_u': 'Hai bisogno di aiuto? Contatta l\'assistenza all\'indirizzo support@quadcores.com',
    'our_narrative': 'richiede il',
    'reimagined': 'è una funzionalità Pro',
    'quadcores_properties_is_an_elite_operati': 'Passa a Pro per sbloccare l\'intelligenza basata sull\'intelligenza artificiale nell\'intero portafoglio.',
    'core_capabilities': 'Passa a Pro',
    'our_approach_to': 'A partire da $ 3,20/unità/mese · Non sono richieste unità minime',
    'operations': 'La nostra narrazione',
    'we_believe_property_management_should_be': 'reinventato.',
    'whether_you_manage_10_units_or_10_000_qu': 'Quadcores Properties è un livello operativo d\'élite per il moderno portafoglio immobiliare.',
    'complete_platform': 'Costruito per la scala, progettato per la precisione e progettato per coloro che fanno sul serio.',
    'all_features': 'Capacità fondamentali',
    '35_powerful_features_organized_into_7_co': '35 potenti funzionalità organizzate in 7 categorie complete.',
    'link_unavailable': 'Collegamento non disponibile',
    'application_submitted': 'Domanda presentata!',
    'your_application_has_been_received_our_t': 'La tua richiesta è stata ricevuta. Il nostro team lo esaminerà e ti ricontatterà al più presto.',
    'your_application_id': 'Il tuo ID applicazione',
    'successfully_registered': 'Registrato con successo',
    'track_application_status': 'Tieni traccia dello stato dell\'applicazione',
    'rental_application': 'Domanda di noleggio',
    'unit_16': 'Unità',
    'applying_for': 'Fare domanda per',
    'full_name_2': 'Nome completo *',
    'email_address': 'Indirizzo e-mail *',
    'national_id_passport': 'Carta d\'identità/passaporto nazionale',
    'date_of_birth_1': 'Data di nascita',
    'current_address_1': 'Indirizzo attuale',
    'employment_income': 'Occupazione e reddito',
    'employment_status_1': 'Stato occupazionale',
    'employed': 'Impiegato',
    'self_employed': 'Lavoratore autonomo',
    'retired': 'Pensionato',
    'student': 'Studente',
    'unemployed': 'Disoccupato',
    'monthly_income_1': 'Reddito mensile',
    'employer_name_1': 'Nome del datore di lavoro',
    'employer_phone_1': 'Telefono del datore di lavoro',
    'lease_preferences': 'Preferenze di locazione',
    'desired_move_in_date': 'Data di trasloco desiderata',
    'lease_duration_months': 'Durata del leasing (mesi)',
    'months_2': 'mesi',
    'i_have_pets': 'Ho animali domestici',
    'emergency_contact': 'Contatto di emergenza',
    'name_7': 'Nome',
    'phone_7': 'Telefono',
    'relation': 'Relazione',
    'additional_notes_1': 'Note aggiuntive',
    'your_information_is_kept_private_and_use': 'Le tue informazioni vengono mantenute private e utilizzate solo per la valutazione del noleggio.',
    'track_application': 'Tieni traccia dell\'applicazione',
    'ref_id': 'ID rif: #',
    'verification_email': 'E-mail di verifica',
    'review': 'Recensione',
    'approval': 'Approvazione',
    'notice_from_the_team': 'Avviso da parte del Team',
    'applicant': 'Richiedente',
    'property_1': 'Proprietà',
    'submitted_1': 'Inviato',
    'approved_for_lease': 'Approvato per il noleggio',
    'next_steps_sign_lease': 'Passaggi successivi: firmare il contratto di locazione',
    'questions_contact': 'Domande? Contatto',
    'support': 'Supporto',
    'or_call_our_leasing_office': 'oppure chiama il nostro ufficio leasing.',
    'verification_code': 'Codice di verifica',
    'verify_code': 'Verifica codice',
    'resend_code': 'Invia nuovamente il codice',
    'back_to_login': 'Torna all\'accesso',
    'invalid_link': 'Collegamento non valido',
    'go_to_login': 'Vai su Accedi',
    'welcome_aboard': 'Benvenuto a bordo!',
    'secure_onboarding': 'Onboarding sicuro',
    'welcome_to_the_quadcores_property_manage': 'Benvenuti nel portale di gestione delle proprietà Quadcores. Concludiamo la configurazione del tuo account interno.',
    'account_role': 'Ruolo dell\'account',
    'email_address_1': 'Indirizzo e-mail',
    'set_your_password': 'Imposta la tua password',
    'please_choose_a_secure_password_for_your': 'Scegli una password sicura per il tuo account.',
    'show_password': 'Mostra password',
    'complete_account_setup': 'Completa la configurazione dell\'account',
    'password_requirement_minimum_8_character': 'Requisito password: minimo 8 caratteri. Ti consigliamo di utilizzare un mix di lettere, numeri e simboli per la massima sicurezza.',
    'thank_you_for_your_subscription_your_acc': 'Grazie per la tua iscrizione Il tuo account è stato aggiornato.',
    'go_to_dashboard_1': 'Vai alla dashboard',
    'back_to_home': 'Ritorno a casa',
    'pricing_plans': 'Prezzi + Piani',
    'pay_for_what': 'Pagare per cosa',
    'you_actually_use': 'usi effettivamente.',
    'annual_2': 'Annuale',
    '16_1': '−16%',
    'per_unit_pricing_no_minimum_portfolio_si': 'Prezzo per unità. Nessuna dimensione minima del portafoglio. Annulla in qualsiasi momento.',
    'current_1': 'Corrente',
    'unit_17': '/unità',
    'from_3': 'da',
    'mo_3': '/mese',
    'minimum': 'minimo',
    '2_months_free_annual_billing': '2 mesi gratuiti · Fatturazione annuale',
    'includes': 'Include',
    'enterprise_custom_contract': 'Contratto aziendale/personalizzato',
    '10_000_units_custom_sla_dedicated_suppor': 'Oltre 10.000 unità, SLA personalizzato, supporto dedicato, opzione on-premise.',
    'talk_to_sales': 'Parla con le vendite →',
    'feature_matrix': 'Matrice delle caratteristiche',
    'full_capability': 'Piena capacità',
    'breakdown': 'rottura.',
    'starter': 'Antipasto',
    'growth': 'Crescita',
    'pro_2': 'Pro',
    'no_minimum_units_no_setup_fees_enterpris': 'Nessuna unità minima. Nessun costo di installazione. Sicurezza di livello aziendale su ogni piano.',
    'legal': 'Legale',
    'privacy': 'Privacy',
    'policy': 'Politica.',
    'we_are_committed_to_protecting_your_prof': 'Ci impegniamo a proteggere i tuoi dati professionali e personali con lo stesso rigore che applichiamo alle operazioni immobiliari.',
    'principles': 'La trasparenza è il nostro fondamento.',
    'section_0': 'Principi',
    'legal_and_compliance': 'SEZIONE 0',
    'inquiries': 'Legale e conformità',
    'if_you_have_questions_about_how_we_handl': 'domande.',
    'info_quadcores_com': 'Se hai domande su come gestiamo i tuoi dati o se hai bisogno di esercitare i tuoi diritti sulla privacy, contatta il nostro team di conformità.',
    'please_review_the_full_contract_terms_be': 'Siamo qui per garantire la tua tranquillità.',
    'link_expired_or_invalid': 'info@quadcores.com',
    'we_couldn_t_find_the_contract_associated': 'Si prega di rivedere i termini contrattuali completi di seguito.',
    'your_signature_has_been_recorded_a_copy': 'Collegamento scaduto o non valido',
    'setup_your_portal': 'Non siamo riusciti a trovare il contratto associato a questo collegamento. Si prega di contattare l\'ufficio di gestione della proprietà per un nuovo collegamento per la firma.',
    'access_your_payments_installments_and_do': 'La tua firma è stata registrata. Una copia del contratto firmato verrà inviata al tuo indirizzo email a breve.',
    'activate_my_account': 'Configura il tuo portale',
    'go_to_dashboard_2': 'Accedi ai tuoi pagamenti, rate e documenti in qualsiasi momento configurando il tuo account sul portale.',
    'id_1': 'Attiva il mio account',
    'contract_signature_portal': 'Vai alla dashboard',
    'review_sign': 'ID: #',
    'hello': 'Portale per la firma dei contratti',
    'please_review_your_contract_details_for': 'Rivedi e firma',
    'property_2': 'Ciao',
    'contract_value': ', ti preghiamo di rivedere i dettagli del contratto per la proprietà di seguito.',
    'timeline': 'Proprietà',
    'to_3': 'Valore del contratto',
    'legal_terms': 'Cronologia',
    'en_ar': 'EN/AR',
    'legal_disclaimer': 'Dichiarazione di non responsabilità legale',
    'electronic_signatures_are_legally_equiva': 'Le firme elettroniche sono giuridicamente equivalenti a quelle autografe.',
    'your_ip_address_and_device_information_w': 'Il tuo indirizzo IP e le informazioni sul dispositivo verranno registrati per motivi di sicurezza.',
    'you_can_download_the_pdf_anytime_after_c': 'Puoi scaricare il PDF in qualsiasi momento dopo il completamento.',
    'ready_to_complete': 'Pronto per completare?',
    'continue_to_plans': 'Continua ai Piani',
    'next_step': 'Passo successivo...',
    'complete_registration': 'Completa la registrazione',
    'verify_phone_number': 'Verifica il tuo numero di telefono',
    'verification_code_sent_to_phone': 'Codice di verifica inviato al tuo telefono. Inseriscilo qui sotto.',
    'popular': 'Popolare',
    'mo_4': '/mese',
    'up_to': 'Fino a',
    'units_2': 'unità',
    'back_to_info': 'Torna alle informazioni',
    'verification_code_1': 'Codice di verifica',
    'please_enter_the_6_digit_code_sent_to': 'Inserisci il codice di 6 cifre inviato a',
    'verify_phone': 'Verifica telefono',
    'guidelines': 'Linee guida',
    'terms_of': 'Termini di',
    'use': 'Utilizzare.',
    'our_terms_are_designed_to_ensure_a_secur': 'I nostri termini sono progettati per garantire un ambiente sicuro, affidabile ed equo per proprietari, inquilini e gestori di proprietà.',
    'conditions': 'Condizioni',
    'clause_0': 'CLAUSOLA 0',
    'agreement_to': 'Accordo a',
    'arbitration': 'arbitrato.',
    'by_using_the_platform_you_agree_that_any': 'Utilizzando la piattaforma, accetti che eventuali controversie saranno risolte attraverso una mediazione professionale o un arbitrato vincolante, garantendo un\'efficace risoluzione dei conflitti operativi.',
    'last_updated_march_2026': 'Ci impegniamo a mantenere un rapporto di collaborazione con tutti i nostri utenti.',
    'system_architecture': 'Ultimo aggiornamento: marzo 2026',
    'refined': 'Architettura del sistema',
    'operations_1': 'Raffinato',
    'a_masterclass_in_property_management_we': 'Operazioni.',
    'complete_platform_1': 'Una masterclass sulla gestione immobiliare. Abbiamo eliminato il rumore per lasciare solo ciò che è necessario, potente e progettato in modo impeccabile.',
    'everything_you_need_to_manage': 'Tutto ciò di cui hai bisogno per gestire',
    'your_properties': 'le tue proprietà.',
    'a_comprehensive_property_management_syst': 'Un sistema completo di gestione immobiliare creato per garantire efficienza, automazione e scalabilità.',
    'view_all_24_features': 'Visualizza tutte le 24 funzionalità',
    'get_started': 'Inizia',
    'take_control_of': 'Prendi il controllo di',
    'your_entire_portfolio': 'il tuo intero portafoglio.',
    'hundreds_of_property_managers_have_alrea': 'Centinaia di gestori di proprietà hanno già spostato le loro operazioni su QuadProperties.',
    'start_free_trial': 'Inizia la tua prova gratuita: non è necessaria la carta di credito.',
    'already_have_an_account': 'Inizia la prova gratuita',
    'quadcores_properties': 'Hai già un account?',
    'the_apartment_management_platform_built': 'Proprietà dei quadcore',
    'quadcores': 'La piattaforma di gestione degli appartamenti creata per operazioni serie.',
    'quadcores_properties_1': 'Quadcore',
    'every_property': 'Proprietà dei quadcore',
    'under_control': 'Ogni proprietà.',
    'one_platform_for_leases_rent_collection': 'Sotto controllo.',
    'start_free_trial_1': 'Una piattaforma per locazioni, riscossione degli affitti, manutenzione e inquilini ��',
    'view_dashboard': 'costruito per gestori di proprietà che fanno sul serio.',
    'scroll': 'Inizia la prova gratuita',
    'quadcores_properties_2': 'Visualizza dashboard',
    'tenant_login': 'Scorri',
    'owner_login': 'Proprietà dei quadcore',
    'sign_in': 'Accesso inquilino',
    'get_started_1': 'Accesso proprietario',
    'sign_in_1': 'Accedi',
    'menu': 'Inizia →',
    'get_started_2': 'Accedi',
    'tenant_13': 'Menù',
    'owner_1': 'Inizia',
    'nav_features': 'Funzionalità',
    'nav_pricing': 'Prezzi',
    'nav_about': 'Chi siamo',
    'our_tiers': 'I nostri livelli',
    'choose_the_right': 'Scegli il giusto',
    'plan_for_you': 'pianificare per te.',
    'monthly_1': 'Mensile',
    'annual_3': 'Annuale',
    'mo_5': '/mese',
    '20_off_annual_billing': '-20% di sconto sulla fatturazione annuale',
    'quadcores_properties_3': 'Proprietà dei quadcore',
    'the_apartment_management_platform_built_1': 'La piattaforma di gestione degli appartamenti creata per operazioni serie.',
    'quadcores_1': 'Quadcore',
    'solutions': 'Soluzioni',
    'built_for_every_property_professional': 'Costruito per ogni professionista immobiliare.',
    'empty_key_18': '✦',
    'set_up_your_password': 'Imposta la tua password',
    'create_a_strong_password_for': 'Crea una password complessa per',
    'email_address_2': 'Indirizzo e-mail',
    'new_password_1': 'Nuova parola d\'ordine',
    'confirm_password_1': 'Conferma password',
    'back_to_login_1': 'Torna all\'accesso',
    'view_all_announcements': 'Visualizza tutti gli annunci →',
    'session_expiring_soon': 'Sessione in scadenza a breve',
    'you_will_be_logged_out_automatically': 'Verrai disconnesso automaticamente',
    'log_out': 'Esci',
    'stay_logged_in': 'Rimani connesso',
    'id_2': 'ID: #',
    'to_4': 'a',
    'ip_1': 'IP:',
    'ip_2': 'IP:',
    'contract_already_signed': 'Contratto già firmato',
    'you_have_already_signed_this_contract': 'Hai già firmato questo contratto.',
    'review_sign_contract': 'Rivedi e firma il contratto',
    'awaiting_your_signature': 'In attesa della tua firma',
    'contract_summary_1': 'Riepilogo del contratto',
    'property_3': 'Proprietà',
    'start_date_3': 'Data di inizio',
    'end_date_1': 'Data di fine',
    'terms_and_conditions': 'Termini e condizioni',
    'important_information': 'Informazioni importanti',
    'by_signing_you_agree_to_all_terms_and_co': '• Firmando, accetti tutti i termini e le condizioni sopra indicati',
    'your_electronic_signature_is_legally_bin': '• La vostra firma elettronica è giuridicamente vincolante',
    'you_will_receive_a_signed_copy_via_email': '• Riceverai una copia firmata via e-mail',
    'you_can_download_the_signed_contract_any': '• Puoi scaricare il contratto firmato in qualsiasi momento dal tuo portale',
    'cancel_32': 'Annulla',
    'sign_contract_2': 'Firmare il contratto',
    'units_3': 'unità',
    'unit_18': 'Unità',
    'tenant_14': 'Locatario:',
    'empty_key_19': '·$',
    'mo_6': '/mese',
    'no_properties_found_in_your_portfolio': 'Nessun immobile trovato nel tuo portafoglio.',
    'my_ledger': 'Il mio registro',
    'complete_history_of_your_financial_trans': 'Cronologia completa delle tue transazioni finanziarie',
    'current_balance_1': 'Saldo attuale',
    'no_ledger_entries_yet_1': 'Nessuna voce contabile ancora',
    'transactions_will_appear_here_once_recor': 'Le transazioni appariranno qui una volta registrate.',
    'unit_19': 'Unità',
    'bal': 'Bal',
    'professional_access': 'Accesso professionale',
    'owner_2': 'Proprietario',
    'secure_identify_for_property_executives': 'Identificazione sicura per i dirigenti e la gestione della proprietà.',
    'email_or_phone_number': 'E-mail o numero di telefono',
    'secure_password': 'Password sicura',
    'switch_to_resident_login': 'Passa all\'accesso residente',
    'institutional_oversight': 'Vigilanza istituzionale.',
    'portfolio_suite': 'Suite Portafoglio',
    'full_control_over_your': 'Pieno controllo sul tuo',
    'property_assets': 'patrimonio immobiliare.',
    'audited_secure_compliant': 'Controllato. Sicuro. Compiacente.',
    'empty_key_20': ': $',
    'per_unit_p_l_last_12_months': 'P&L per unità: ultimi 12 mesi',
    'loading_report': 'Caricamento rapporto...',
    'no_properties_found': 'Nessun immobile trovato',
    'unit_20': '· Unità n.',
    'mo_lease_ends': '/mese · Il contratto di locazione termina',
    '12_mo_noi': '12 mesi NOI',
    'empty_key_21': '▾',
    'monthly_collections_last_6_months': 'Raccolte mensili (ultimi 6 mesi)',
    'tax_documents': 'Documenti fiscali',
    'annual_payment_summary_for_tax_reporting': 'Riepilogo dei pagamenti annuali per la rendicontazione fiscale (1099-NEC)',
    'total_paid_1': 'Totale pagato',
    'this_is_your_personal_payment_summary_fo': 'Questo è il tuo riepilogo personale dei pagamenti. Per il modulo ufficiale 1099-NEC, contatta il tuo responsabile della proprietà. Solo i pagamenti pari o superiori a $ 600 in un anno solare sono segnalabili all\'IRS.',
    'unit_21': 'Unità',
    'no_payments_recorded_for': 'Nessun pagamento registrato per',
    'select_a_different_year_to_view_your_pay': 'Seleziona un anno diverso per visualizzare la cronologia dei pagamenti.',
    'browse_facilities_and_book_time_slots': 'Sfoglia le strutture e prenota le fasce orarie',
    'no_amenities_available_in_your_building': 'Nessun servizio disponibile nel tuo edificio',
    'mo_7': '/mese',
    'capacity_1': 'Capacità:',
    'book_time_slot': 'Prenota fascia oraria',
    'book_an_amenity': 'Prenota un servizio',
    'amenity_1': 'Servizi *',
    'select_amenity_1': 'Seleziona servizi',
    'date_2': 'Data *',
    'start_time_1': 'Orario di inizio *',
    'end_time_1': 'Orario di fine *',
    'notes_optional_1': 'Note (facoltativo)',
    'cancel_33': 'Annulla',
    'no_upcoming_bookings': 'Nessuna prenotazione imminente',
    'browse_amenities': 'Sfoglia i servizi',
    'cancel_34': 'Annulla',
    'history_1': 'Storia',
    'property_assistant': 'Assistente immobiliare',
    'ask_about_your_account': 'Chiedi informazioni sul tuo account',
    'lease_history': 'Storia del contratto di locazione',
    'your_current_and_past_lease_agreements': 'I tuoi contratti di locazione attuali e passati',
    'active_lease': 'Locazione attiva',
    'unit_22': 'Unità',
    'building_10': 'Edificio',
    'monthly_rent_4': 'Affitto mensile',
    'expires_1': 'Scade',
    'open_ended': 'A tempo indeterminato',
    'start_date_4': 'Data di inizio',
    'security_deposit_1': 'Deposito cauzionale',
    'type_3': 'Digitare',
    'no_active_lease_on_file': 'Nessun contratto di locazione attivo in archivio',
    'history_2': 'Storia',
    'mo_8': '/mese',
    'no_lease_records_found': 'Nessun record di locazione trovato',
    'secure_access': 'Accesso sicuro',
    'hello_1': 'Ciao',
    'again': 'Ancora.',
    'enter_your_details_to_manage_your_home_a': 'Inserisci i tuoi dati per gestire la tua casa e i pagamenti.',
    'your_email': 'La tua e-mail',
    'your_password': 'La tua password',
    'switch_to_owner_login': 'Passa all\'accesso proprietario',
    'everything_in_one_place': 'Tutto in un unico posto.',
    'tools_for_you': 'Strumenti per te',
    'everything_you_need': 'Tutto ciò di cui hai bisogno',
    'to_manage_your_home': 'per gestire la tua casa',
    'safe_private_reliable': 'Sicuro. Privato. Affidabile.',
    'we_use_professional_grade_encryption_to': 'Utilizziamo la crittografia di livello professionale per garantire che i tuoi dati e i tuoi pagamenti siano sempre protetti.',
    'empty_key_22': ':#',
    'auto_pay_is_on': 'Il pagamento automatico è attivo',
    'your_rent_is_charged_automatically_on_th': '· L\'affitto viene addebitato automaticamente alla data di scadenza.',
    'enable_auto_pay': 'Abilita il pagamento automatico',
    'save_a_card_or_bank_account_and_never_mi': 'Salva una carta o un conto bancario e non perdere mai più il pagamento dell\'affitto.',

    'autopay_enabled_toast': 'Pagamento automatico attivato! Il tuo affitto verra addebitato automaticamente alla scadenza.',
    'autopay_setup_canceled': 'Configurazione del pagamento automatico annullata.',
    'autopay_setup_failed': 'Impossibile avviare la configurazione del pagamento automatico.',
    'autopay_start_failed': 'Avvio della configurazione del pagamento automatico fallito.',
    'confirm_disable_autopay': 'Sei sicuro di voler disattivare il pagamento automatico? Il metodo di pagamento salvato verra rimosso.',
    'autopay_disabled_success': 'Il pagamento automatico e stato disattivato.',
    'autopay_disable_failed': 'Impossibile disattivare il pagamento automatico.',
    'card_ending_label': '{{brand}} che termina con ••••{{last4}}',
    'payment_method_saved': 'Metodo di pagamento salvato',
    'disable_auto_pay': 'Disattiva pagamento automatico',
    'set_up_auto_pay': 'Configura pagamento automatico',
    'due_colon': 'Scadenza:',
    'disabling': 'Disattivazione…',
    'renewal_offers': 'Offerte di rinnovo',
    'review_and_respond_to_lease_renewal_offe': 'Esamina e rispondi alle offerte di rinnovo del contratto di locazione del tuo proprietario',
    'no_renewal_offers_yet': 'Nessuna offerta di rinnovo ancora',
    'your_property_manager_will_send_a_renewa': 'Il tuo gestore della proprietà invierà qui un\'offerta di rinnovo quando il contratto di locazione si avvicina alla data di fine.',
    'unit_23': 'Unità',
    'offer_sent_1': 'Offerta inviata',
    'per_month': 'al mese',
    'offered_rent': 'Affitto offerto',
    'per_month_1': 'al mese',
    'new_term': 'Nuovo termine:',
    'note_from_management': 'Nota della direzione',
    'decline': 'Rifiutare',
    'past_offers': 'Offerte passate',
    'unit_24': 'Unità',
    'mo_9': '/mese',
    'responded': 'Risposto',
    'share_feedback': 'Condividi feedback',
    'your_opinion_helps_us_improve': 'La tua opinione ci aiuta a migliorare',
    'thank_you': 'Grazie!',
    'your_feedback_has_been_submitted': 'Il tuo feedback è stato inviato.',
    'submit_another': 'Inviane un altro',
    'category_5': 'Categoria',
    'your_rating': 'La tua valutazione',
    'comment_optional': 'Commento (facoltativo)',
    'your_past_feedback': 'Il tuo feedback passato',

    'general': 'Generale',
    'submit_feedback': 'Invia valutazione',
    'please_select_rating': 'Seleziona una valutazione a stelle',
    'submission_failed': 'Invio fallito',
    'tell_us_placeholder': 'Dicci cosa ne pensi…',
    'rating_very_poor': 'Molto scarso',
    'rating_poor': 'Scarso',
    'rating_okay': 'Accettabile',
    'rating_good': 'Buono',
    'rating_excellent': 'Eccellente',
    'utility_bills_1': 'Bollette delle utenze',
    'electricity_water_gas_and_other_utility': 'Spese per luce, acqua, gas e altre utenze',
    'paid_on_time': 'Pagato in tempo',
    'monthly_utility_spend': 'Spesa mensile per le utenze',
    'no_utility_bills_yet': 'Ancora nessuna bolletta',
    'bills_will_appear_here_once_issued_by_ma': 'Le fatture appariranno qui una volta emesse dalla direzione.',
    'due_now': 'Scadenza adesso (',
    'history_3': 'Storia (',
    'due_1': 'Dovuto',
    'violations_notices_1': 'Violazioni e avvisi',
    'view_violations_and_official_notices_iss': 'Visualizza le violazioni e gli avvisi ufficiali che ti sono stati emessi',
    'no_violations_on_record': 'Nessuna violazione registrata',
    'you_have_a_clean_record_keep_it_up': 'Hai la fedina pulita: continua così!',
    'fine': 'Bene:',
    'resolution': 'Risoluzione',
    'unit_25': 'Unità',
    'no_notices': 'Nessun avviso',
    'no_official_notices_have_been_issued_to': 'Non ti sono state rilasciate comunicazioni ufficiali.',
    'here_s_an_overview_of_your_operations_to': 'Ecco una panoramica delle tue operazioni oggi.',
    'system_live': 'Sistema in diretta',
    'active_operations': 'Operazioni attive',
    'priority_task_queue': 'Coda di attività prioritarie',
    'no_active_tasks_in_your_queue': 'Nessuna attività attiva nella tua coda.',
    'compliance_alert': 'Avviso di conformità',
    'insurance_expires_in_12_days_please_uplo': 'L\'assicurazione scade tra 12 giorni. Carica i documenti aggiornati.',
    'upgrade_1': 'Aggiorna',
    'service_score': 'Punteggio del servizio',
    'detailed_analysis': 'Analisi dettagliata',
    'system_activity': 'Attività di sistema',
    'profile_load_error': 'Errore di caricamento del profilo',
    'the_registry_could_not_verify_your_ident': 'Il registro non è riuscito a verificare la tua identità. Contatta gli amministratori di sistema.',
    'operator': 'Operatore',
    'tier_platinum': 'Livello: Platino',
    'identity_matrix': 'Matrice d\'identità',
    'logistical_data': 'Dati logistici',
    'verified_credentials': 'Credenziali verificate',
    'profile_modifications_are_managed_by_ins': 'Le modifiche al profilo sono gestite da protocolli di sicurezza istituzionali. Richiedi aggiornamenti tramite la postazione di controllo per l\'integrità della rete.',
    'invalid_or_expired_link': 'Collegamento non valido o scaduto',
    'security_established': 'Sicurezza stabilita',
    'your_portal_access_key_has_been_successf': 'La tua chiave di accesso al portale è stata creata con successo.',
    'proceed_to_login': 'Procedi all\'accesso',
    'access_setup': 'Accedi a Configurazione',
    'finalize_your_credentials_for': 'Finalizza le tue credenziali per',
    'new_access_key': 'Nuova chiave di accesso',
    'confirm_authorization': 'Conferma l\'autorizzazione',
    'finalize_connection': 'Finalizzare la connessione',
    'w_9_tax_form': 'Modulo fiscale W-9',
    'request_for_taxpayer_identification_numb': 'Richiesta di numero di identificazione del contribuente: richiesto per la presentazione del documento 1099-NEC',
    'w_9_on_file': 'W-9 in archivio',
    'certified_on': 'Certificato il',
    'you_can_update_and_re_certify_at_any_tim': '. Puoi aggiornare e ricertificare in qualsiasi momento.',
    'this_form_is_required_by_the_irs_if_you': 'Questo modulo è richiesto dall\'IRS. Se ricevi $ 600 o più in un anno solare, verrà emesso un 1099-NEC utilizzando queste informazioni. Il tuo SSN completo non viene mai memorizzato: solo le ultime 4 cifre, se fornite.',
    '1_legal_name_as_shown_on_income_tax_retu': '1. Denominazione legale (come riportata nella dichiarazione dei redditi) *',
    '3_federal_tax_classification': '3. Classificazione fiscale federale *',
    'employer_id_number_ein': 'Numero identificativo del datore di lavoro (EIN)',
    'ssn_last_4_digits_only': 'SSN: solo le ultime 4 cifre',
    'we_only_store_the_last_4_for_your_privac': 'Conserviamo solo gli ultimi 4 per la tua privacy',
    '5_address': '5. Indirizzo',
    'city': 'Città',
    'state': 'Stato',
    'certification': 'Certificazione',
    'under_penalties_of_perjury_i_certify_tha': 'Sotto pena di spergiuro, certifico che: (1) il numero mostrato è il mio corretto numero di identificazione fiscale; (2) Non sono soggetto a ritenuta d\'acconto; (3) Sono un cittadino statunitense o un altro soggetto statunitense; (4) Sono esente dalla segnalazione FATCA (se applicabile).',
    'by_clicking': 'Facendo clic',
    'save_certify': 'Salva e certifica',
    'you_are_electronically_signing_this_w_9': 'stai firmando elettronicamente questo W-9. Il tuo indirizzo IP e il timestamp verranno registrati.',
    'core_operations': 'Operazioni principali',
    'work_orders_1': 'Ordini di lavoro',
    'execute_your_assignments_with_efficiency': 'Esegui i tuoi incarichi con efficienza e precisione.',
    'all_assignments': 'Tutti gli incarichi',
    'assigned_tasks': 'Compiti assegnati',
    'currently_active': 'Attualmente attivo',
    'completed_history': 'Storia completata',
    'no_assignments_found': 'Nessun compito trovato',
    'your_current_view_filters_haven_t_matche': 'I filtri di visualizzazione attuali non corrispondono ad alcun record.',
    'unit_26': 'Unità',
    'task_description_1': 'Descrizione dell\'attività',
    'completion_evidence': 'Prova di completamento',
    'logistics_control': 'Controllo della logistica',
    'start_mission': 'Inizia missione',
    'mark_finished': 'Segna finito',
    'submit_invoice': 'Invia fattura',
    'view_brief': 'Visualizza breve',
    'notice_1': 'Avviso',
    'safety_protocols_are_active_wear_authori': 'I protocolli di sicurezza sono attivi. Indossare sempre i DPI autorizzati.',
    'page_1': 'Pagina',
    'of_6': 'di',
    'next_4': 'Avanti',
    'submit_settlement': 'Invia transazione',
    'claim_amount_for': 'Importo del reclamo per',
    'cancel_35': 'Annulla',
    'live': 'Vivi',
    'sign_out_1': 'Esci',
    'sign_out_2': 'Esci',

    // Missing translations added
    'BULK_ADD': 'Aggiunta in blocco',
    'QTY_PER_FLOOR': 'Q.tà / Piano',
    'SELECT_FLOORS': 'Seleziona piani',
    'SIZE': 'Dimensione',
    'bill_charged': 'Fattura addebitata al conto del locatario',
    'billing_day': 'Giorno di fatturazione del mese',
    'building_meter_hint': 'Contatore dell\'edificio — usa RUBS per suddividere il costo tra tutti i locatari',
    'calculating': 'Calcolo in corso…',
    'charge_all': 'Addebita tutto',
    'charging': 'Addebito in corso…',
    'deleted': 'Eliminato',
    'done': 'Fatto',
    'generate_bills': 'Genera fatture',
    'generate_bills_now': 'Genera fatture ora',
    'individual_meter_hint': 'Contatore individuale — genera una fattura per questa unità',
    'run_rubs_btn': 'Esegui suddivisione RUBS',
    'utility_step1': 'Aggiungi un account utenza (elettricità, acqua, gas…)',
    'utility_step2': 'Registra una lettura del contatore',
    'utility_step3': 'Genera fatture dalle letture',
    'utility_step4': 'Addebita le fatture direttamente al conto del locatario',
    'view_application': 'Visualizza domanda',

    'confirm_charge_bill': 'Addebitare questa bolletta utenza al conto del locatario?',

    'all_tenants_compliant_desc': 'Tutti i locatari sono attualmente conformi',
    'audit_compliance': 'Audit di conformità',
    'compliant': 'Conforme',
    'confirm_delete_policy': 'Eliminare questa polizza?',
    'entity_name': 'Nome entità',
    'error_loading_insurance': 'Impossibile caricare le polizze assicurative',
    'expiration': 'Scadenza',
    'no_insurance_records': 'Nessun documento assicurativo trovato',
    'non_compliant': 'Non conforme',
    'policy_added': 'Polizza aggiunta',
    'policy_updated': 'Polizza aggiornata',
    'send_notice': 'Invia avviso',
    'view_policy': 'Visualizza polizza',

    'generate_drafts': 'Genera bozze ora',

    // Sfratti
    'ev_initiated': 'Avviato',
    'ev_notice_served': 'Diffida notificata',
    'ev_court_filed': 'Ricorso presentato',
    'ev_court_ruling': 'Sentenza del tribunale',
    'ev_completed': 'Completato',
    'ev_dismissed': 'Respinto',
    'ev_notice_pay_or_quit': 'Paga o lascia',
    'ev_notice_cure_or_quit': 'Risolvi o lascia',
    'ev_notice_unconditional': 'Sfratto incondizionato',
    'ev_active_cases': 'Casi attivi',
    'ev_total_owed': 'Totale dovuto',
    'ev_notice_type': 'Tipo di diffida',
    'ev_amount_owed': 'Importo dovuto',
    'ev_status_updated': 'Stato aggiornato',
    'ev_dismiss_case': 'Archivia caso',
    'ev_dismiss_confirm': 'Sei sicuro di voler archiviare questo caso di sfratto? Questa azione non può essere annullata.',
    'ev_case_dismissed': 'Caso di sfratto archiviato',
    'ev_dismiss_failed': 'Impossibile archiviare il caso',
    'ev_case_timeline': 'Cronologia del caso',
    'ev_notice_served_date': 'Notifica inviata',
    'ev_court_filing_date': 'Deposito in tribunale',
    'ev_court_date': 'Data udienza',
    'ev_ruling': 'Sentenza',
    'ev_ruling_date': 'Data sentenza',
    'ev_vacate_date': 'Sgombero entro',
    'ev_edit_notes': 'Modifica note',
    'ev_save_notes': 'Salva note',
    'ev_add_notes': 'Aggiungi nota',
    'ev_notes_saved': 'Note salvate',
    'ev_save_failed': 'Salvataggio fallito',
    'filed': 'Depositato',

    // Ispezioni
    'insp_move_in': 'Ingresso',
    'insp_move_out': 'Uscita',
    'insp_periodic': 'Periodica',
    'insp_maintenance': 'Manutenzione',
    'all_types': 'Tutti i tipi',
    'all_status': 'Tutti gli stati',
    'unit_building': 'Unità / Edificio',
    'checklist_progress': 'Avanzamento checklist',
    'condition_1': 'Condizione',

    // Violazioni
    'tenant_unit': 'Inquilino / Unità',
    'severity': 'Gravità',
    'fine': 'Multa',

    // Contratti
    'start': 'Inizio',
    'end': 'Fine',
    'expiry': 'Scadenza',
    'rent_mo': 'Affitto/mese',
    'open_ended': 'A tempo indeterminato',

    // Rinnovi
    'offered_rent': 'Affitto proposto',
    'risk': 'Rischio',
    'offer_expires': "Scadenza dell'offerta",

    // Candidature
    'applicant': 'Candidato',
    'employment': 'Impiego',

    // Link candidatura
    'total_links': 'Link totali',
    'active_links': 'Link attivi',
    'total_uses': 'Utilizzi totali',
    'generating': 'Generazione in corso...',
    'generate_link': 'Genera link',
    'deactivate_link': 'Disattiva link',
    'deactivate_link_confirm': 'Disattivare il link "{{label}}"? Non accetterà più candidature.',
    'deactivate': 'Disattiva',

    // Procedura di vendita
    'sw_step_buyer': 'Acquirente',
    'sw_step_terms': 'Condizioni',
    'sw_step_schedule': 'Piano di pagamento',
    'sw_step_confirm': 'Conferma',
    'back': 'Indietro',
    'creating': 'Creazione in corso...',
    'create_sale_contract': 'Crea contratto di vendita',
    'hash': '#',
    'due_date': 'Data di scadenza',
    'principal': 'Capitale',
    'interest': 'Interessi',
    'monthly_payment': 'Rata mensile',
    'total_interest': 'Interessi totali',
    'total_cost': 'Costo totale',
    'down_payment': 'Acconto',
    'sale_price': 'Prezzo di vendita',
    'financed_amount': 'Importo finanziato',
    'interest_rate': 'Tasso di interesse',
    'term': 'Durata',

    // Validation errors
    'val_first_name_min': 'Il nome deve contenere almeno 2 caratteri',
    'val_first_name_max': 'Il nome non può superare 50 caratteri',
    'val_last_name_min': 'Il cognome deve contenere almeno 2 caratteri',
    'val_last_name_max': 'Il cognome non può superare 50 caratteri',
    'val_username_min': 'Il nome utente deve contenere almeno 3 caratteri',
    'val_username_max': 'Il nome utente non può superare 30 caratteri',
    'val_username_no_spaces': 'Il nome utente non può contenere spazi',
    'val_email_invalid': 'Inserisci un indirizzo email valido',
    'val_company_name_min': "Il nome dell'azienda deve contenere almeno 2 caratteri",
    'val_password_min': 'La password deve contenere almeno 8 caratteri',
    'val_password_max': 'La password non può superare 128 caratteri',
    'val_name_max_100': 'Il nome non può superare 100 caratteri',
    'val_close_time_required': "Imposta l'orario di chiusura",
    'val_open_time_required': "Imposta l'orario di apertura",
    'val_close_after_open': "L'orario di chiusura deve essere dopo quello di apertura",
    'val_title_max_200': 'Il titolo non può superare 200 caratteri',
    'val_description_max_2000': 'La descrizione non può superare 2000 caratteri',
    'val_fine_non_negative': "L'importo della multa deve essere zero o positivo",
    'val_prospect_name_max': 'Il nome del potenziale cliente non può superare 200 caratteri',
    'val_end_after_start': "L'ora di fine deve essere dopo l'ora di inizio",
    'val_notes_max_2000': 'Le note non possono superare 2000 caratteri',
    'val_expiry_after_start': 'La data di scadenza deve essere dopo la data di inizio',
    'val_url_invalid': "L'URL deve iniziare con http:// o https://",
    'val_notes_max_1000': 'Le note non possono superare 1000 caratteri',
    'val_webhook_url_https': "L'URL del webhook deve iniziare con https://",

    'error_loading_violations': 'Errore nel caricamento delle violazioni',
    'marked_as_resolved': 'Contrassegnato come risolto',
    'error_updating_violation': 'Errore nell\'aggiornamento della violazione',
    'title_and_notice_body_required': 'Il titolo e il contenuto dell\'avviso sono obbligatori',
    'notice_issued': 'Avviso emesso',
    'error_issuing_notice': 'Errore nell\'emissione dell\'avviso',
    'search_violations': 'Cerca per inquilino, titolo o descrizione...',
    'loading_violations': 'Caricamento violazioni...',
    'no_violations_recorded': 'Nessuna violazione registrata',
    'no_status_violations': 'Nessuna violazione {{status}}',
    'notice_type_required': 'Tipo di avviso *',
    'delivery_method_required': 'Metodo di consegna *',
    'notice_title_required': 'Titolo dell\'avviso *',
    'notice_deadline_optional': 'Scadenza conformità (opzionale)',
    'notice_body_required': 'Testo dell\'avviso *',
    'issuing': 'Emissione in corso...',
    'issue_notice_btn': 'Emetti avviso',
    'violations_count': '{{count}} violazioni',
    'open_tickets': 'Ticket aperti',
    'has_balance': 'Ha un saldo',
    'perfect_payments': 'Pagamenti perfetti',
    'risk_score': 'Punteggio di rischio',
    'failed_to_load_evictions': 'Errore nel caricamento degli sfratti',
    'failed_to_update_status': 'Errore nell\'aggiornamento dello stato',
    'please_select_a_tenant': 'Seleziona un inquilino',
    'tenant_must_have_apartment': 'L\'inquilino selezionato deve avere un appartamento e un edificio assegnati per essere sfrattato.',
    'reason_is_required': 'Il motivo è obbligatorio',
    'eviction_case_opened': 'Caso di sfratto aperto',
    'failed_to_create_eviction': 'Errore nella creazione dello sfratto',

    'wo_stat_total': 'Totale',
    'wo_stat_assigned': 'Assegnato',
    'wo_stat_in_progress': 'In corso',
    'wo_stat_completed': 'Completato',
    'wo_col_title': 'Titolo',
    'wo_col_vendor': 'Fornitore',
    'wo_col_priority': 'Priorità',
    'wo_col_status': 'Stato',
    'wo_col_scheduled': 'Pianificato',
    'wo_col_invoice': 'Fattura',
    'wo_col_assigned_by': 'Assegnato da',
    'wo_detail_scheduled': 'Pianificato',
    'wo_detail_completed': 'Completato',
    'wo_detail_created': 'Creato',
    'wo_failed_to_load': 'Impossibile caricare gli ordini di lavoro',
    'wo_invoice_approved': 'Fattura approvata con successo!',
    'wo_confirm_approval': 'Conferma approvazione',
    'wo_status_assigned': 'Assegnato',
    'wo_status_in_progress': 'In corso',
    'wo_status_on_hold': 'In attesa',
    'inv_status_received': 'Ricevuta',
    'view_detail': 'Visualizza dettaglio',
    'wo_failed_approve': 'Impossibile approvare la fattura',
    'wo_failed_load_vendors': 'Impossibile caricare la lista dei fornitori',
    'wo_vendor_required': 'Il fornitore è obbligatorio',
    'wo_title_required': 'Il titolo è obbligatorio',
    'wo_created': 'Ordine di lavoro creato con successo',
    'wo_failed_to_create': "Impossibile creare l'ordine di lavoro",
    'wo_title_placeholder': 'es. Riparare una perdita nel edificio A unità 302',
    'wo_description_placeholder': 'Fornire istruzioni dettagliate al fornitore...',
    'wo_linked_id_placeholder': 'ID collegato opzionale',
    'wo_nothing_to_update': 'Niente da aggiornare',
    'wo_updated': 'Ordine di lavoro aggiornato',
    'wo_update_failed': 'Aggiornamento fallito',
    'sch_col_title': 'Titolo',
    'sch_col_building': 'Edificio',
    'sch_col_frequency': 'Frequenza',
    'sch_col_next_due': 'Prossima scadenza',
    'sch_col_est_cost': 'Costo stimato',
    'sch_col_status': 'Stato',
    'sch_col_actions': 'Azioni',
    'sch_error_loading': 'Errore nel caricamento dei piani',
    'sch_mark_complete_success': 'Contrassegnato come completato, data successiva avanzata',
    'sch_error_complete': 'Errore nel completamento del piano',
    'sch_confirm_remove': 'Rimuovere questo piano?',
    'sch_removed': 'Piano rimosso',
    'sch_error_remove': 'Errore nella rimozione del piano',
    'sch_error_history': 'Errore nel caricamento dello storico',
    'sch_search_placeholder': 'Cerca piani...',
    'sch_status_active': 'Attivo',
    'sch_status_inactive': 'Inattivo',
    'sch_edit_success': 'Piano aggiornato',
    'sch_error_edit': 'Errore nell\'aggiornamento del piano',
    'sch_edit_schedule': 'Modifica piano',
    'sch_title_freq_due_required': 'Titolo, frequenza e prima data sono obbligatori',
    'schedule_created': 'Piano creato',
    'sch_failed_to_create': 'Impossibile creare il piano',
    'sch_history_title': 'Cronologia',
    'sch_remove_title': 'Rimuovi',
    'describe_task_placeholder': 'Descrivi il compito di manutenzione...',
    'vendor_instructions_placeholder': 'Istruzioni specifiche per il fornitore...',
    'freq_daily': 'Giornaliero',
    'freq_weekly': 'Settimanale',
    'freq_biweekly': 'Bisettimanale',
    'freq_monthly': 'Mensile',
    'freq_quarterly': 'Trimestrale',
    'freq_semiannual': 'Semestrale',
    'freq_biannual': 'Semestrale',
    'freq_annual': 'Annuale',

    'search_conversations': 'Cerca conversazioni...',
    'load_more': 'Carica altro',
    'no_results': 'Nessun risultato trovato',
    'BULK_ADD': 'Aggiunta massiva',
    'QTY_PER_FLOOR': 'Qtà / Piano',
    'SELECT_FLOORS': 'Seleziona piani',
    'SIZE': 'Dimensione',
    'bill_charged': 'Fattura addebitata al registro del conduttore',
    'billing_day': 'Giorno di fatturazione del mese',
    'building_meter_hint': 'Contatore dell\'edificio — usa RUBS per dividere il costo tra tutti gli inquilini',
    'calculating': 'Calcolo in corso…',
    'charge_all': 'Addebita tutto',
    'charging': 'Addebito in corso…',
    'deleted': 'Eliminato',
    'done': 'Fatto',
    'generate_bills': 'Genera fatture',
    'generate_bills_now': 'Genera fatture ora',
    'individual_meter_hint': 'Contatore individuale — genera una fattura per questa unità',
    'run_rubs_btn': 'Esegui suddivisione RUBS',
    'utility_step1': 'Aggiungi un account utenza (elettricità, acqua, gas…)',
    'utility_step2': 'Registra una lettura del contatore',
    'utility_step3': 'Genera fatture dalle letture',
    'utility_step4': 'Addebita fatture direttamente al registro del conduttore',
    'view_application': 'Visualizza domanda',
    'failed_to_update_document_status': 'Impossibile aggiornare lo stato del documento',
    'buyer_name_placeholder': 'es. Ahmed Al-Rashidi',
    'col_amenity': 'Servizio',
    'col_space': 'Spazio',
    'delete_document': 'Elimina documento',
    'delete_draft_confirm': 'Sei sicuro di voler eliminare questa bozza di ispezione?',
    'delete_draft_inspection': 'Elimina bozza ispezione',
    'document_added': 'Documento aggiunto',
    'document_name_placeholder': 'Nome documento',
    'edit_unit_amenity': 'Modifica servizio unità',
    'failed_create_inspection': 'Impossibile creare l\'ispezione',
    'failed_delete_inspection': 'Solo le bozze di ispezione possono essere eliminate',
    'failed_generate_invite_link': 'Impossibile generare il link di invito',
    'failed_load_bookings': 'Impossibile caricare le prenotazioni',
    'failed_load_inspections': 'Impossibile caricare le ispezioni',
    'failed_save_checklist': 'Impossibile salvare la checklist',
    'failed_sign_inspection': 'Impossibile firmare l\'ispezione',
    'failed_update_condition': 'Impossibile aggiornare la condizione',
    'fair': 'Discreto',
    'inspection_completed': 'Ispezione contrassegnata come completata',
    'inspection_created': 'Ispezione creata',
    'inspection_deleted': 'Ispezione eliminata',
    'inspection_notes_placeholder': 'Osservazioni o note iniziali…',
    'inspection_signed': 'Ispezione firmata',
    'investment': 'Investimento',
    'item_notes_placeholder': 'Aggiungi note per questo elemento…',
    'name_and_url_required': 'Nome e URL sono obbligatori',
    'poor': 'Scarso',
    'portal_link_copied': 'Link di configurazione del portale copiato negli appunti',
    'prospect_email_placeholder': 'john@example.com',
    'prospect_name_placeholder': 'es. Mario Rossi',
    'prospect_phone_placeholder': '+964 770 000 0000',
    'sale_notes_placeholder': 'Note opzionali...',
    'search_apartment_placeholder': 'Cerca appartamento...',
    'search_inspections_placeholder': 'Cerca per unità, edificio o inquilino…',
    'search_owners_placeholder': 'Cerca proprietari per nome, telefono o e-mail...',
    'search_unit_or_buyer': 'Cerca unità o acquirente...',
    'sign_inspection_message': 'Contrassegnare questa ispezione come firmata? Questa azione è definitiva e non può essere annullata.',
    'stat_available_to_sell': 'Disponibile per la vendita',
    'stat_sold_units': 'Unità vendute',
    'status_all': 'Tutti',
    'status_available': 'Disponibile',
    'status_sold': 'Venduto',
    'uploaded_by': 'Caricato da',
    'hw_record_violation': '1. Registra violazione',
    'hw_record_violation_desc': 'Registra una violazione con tipo, gravità e multa opzionale. La multa viene addebitata automaticamente al conto del locatario.',
    'hw_issue_notice': '2. Emetti avviso formale',
    'hw_issue_notice_desc': 'Allega un avviso legale e invia via e-mail o WhatsApp.',
    'hw_track_resolution': '3. Tieni traccia della risoluzione',
    'hw_track_resolution_desc': 'Aggiorna lo stato: riconosciuto → escalato → risolto. Viene mantenuta una traccia di audit completa.',
    'hw_escalate': '4. Escalate se necessario',
    'hw_escalate_desc': 'Le violazioni escalate possono alimentare il flusso di lavoro per le richieste di sfratto.',
    'notice_title_placeholder': 'es. Avviso di pagamento o sfratto — Affitto scaduto',
    'notice_body_placeholder': 'Inserisci il testo completo dell\'avviso legale...',
    'failed_to_load_tenants': 'Impossibile caricare i locatari. Controlla la tua connessione.',
    'please_select_tenant': 'Seleziona prima un locatario',
    'title_is_required': 'Il titolo è obbligatorio',
    'violation_recorded_notice_sent': 'Violazione registrata — avviso inviato automaticamente al locatario',
    'violation_recorded': 'Violazione registrata',
    'error_creating_violation': 'Errore durante la creazione della violazione',
    'select_tenant_placeholder': 'Seleziona locatario...',
    'violation_title_placeholder': 'es. Reclamo per rumore — musica alta dopo mezzanotte',
    'violation_desc_placeholder': 'Descrivi la violazione in dettaglio...',
    'saving_ellipsis': 'Salvataggio...',
    'violation_status_open': 'Aperto',
    'violation_status_acknowledged': 'Riconosciuto',
    'violation_status_resolved': 'Risolto',
    'violation_status_escalated': 'Escalato',
    'violation_status_closed': 'Chiuso',
    'violation_type_noise': 'Rumore',
    'violation_type_pets': 'Animali',
    'violation_type_damage': 'Danno',
    'violation_type_unauthorized_occupant': 'Occupante non autorizzato',
    'violation_type_parking': 'Parcheggio',
    'violation_type_smoking': 'Fumo',
    'violation_type_cleanliness': 'Pulizia',
    'violation_type_lease_breach': 'Violazione del contratto',
    'violation_type_late_payment': 'Pagamento tardivo',
    'violation_type_general': 'Generale',
    'violation_severity_warning': 'Avvertimento',
    'violation_severity_minor': 'Minore',
    'violation_severity_major': 'Maggiore',
    'violation_severity_critical': 'Critico',
    'notice_type_pay_or_quit': 'Paga o lascia',
    'notice_type_cure_or_quit': 'Correggi o lascia',
    'notice_type_unconditional_quit': 'Sgombero incondizionato',
    'notice_type_entry_notice': 'Avviso di accesso',
    'notice_type_non_renewal': 'Non rinnovo',
    'notice_type_eviction_filing': 'Richiesta di sfratto',
    'notice_type_lease_termination': 'Rescissione del contratto',
    'notice_type_rent_increase': 'Aumento dell\'affitto',
    'notice_type_general': 'Generale',
    'delivery_method_email': 'E-mail',
    'delivery_method_whatsapp': 'WhatsApp',
    'delivery_method_hand_delivered': 'Consegnato a mano',
    'delivery_method_certified_mail': 'Posta raccomandata',
    'delivery_method_posted_on_door': 'Affisso sulla porta',
    'delivery_method_sms': 'SMS',
    'ev_reason_placeholder': 'Mancato pagamento dell\'affitto, violazione del contratto, ecc.',
    'select_placeholder': 'Seleziona...',
    'opening_ellipsis': 'Apertura...',
    'err_loading_tenants': 'Errore durante il caricamento dei locatari',
    'identity_link_opened': 'Link di verifica identità aperto — condividilo con il locatario',
    'failed_identity_verification': 'Impossibile avviare la verifica dell\'identità',
    'fcra_consent_required_toast': 'Devi confermare il consenso FCRA prima di eseguire un controllo dei precedenti',
    'bg_invitation_sent': 'Invito per controllo dei precedenti inviato all\'e-mail del locatario',
    'failed_bg_check': 'Impossibile avviare il controllo dei precedenti',
    'screening_decision_set': 'Decisione di screening impostata su: ',
    'failed_to_save_decision': 'Impossibile salvare la decisione',
    'search_tenants_placeholder': 'Cerca locatari...',
    'loading_ellipsis': 'Caricamento...',
    'loading_screening_data': 'Caricamento dati di screening...',
    'dob_optional': 'Data di nascita (opzionale)',
    'zipcode_optional': 'CAP (opzionale)',
    'state_optional': 'Stato/Regione (opzionale)',
    'country_label': 'Paese',
    'sending_ellipsis': 'Invio...',
    'send_to_tenant': 'Invia al locatario',
    'decision_label': 'Decisione',
    'add_notes_decision_placeholder': 'Aggiungi note su questa decisione...',
    'save_decision': 'Salva decisione',
    'badge_not_started': 'Non avviato',
    'badge_verified': 'Verificato',
    'badge_action_needed': 'Azione necessaria',
    'badge_canceled': 'Annullato',
    'badge_clear': 'Chiaro',
    'badge_consider': 'Da considerare',
    'badge_dispute': 'Contestato',
    'badge_suspended': 'Sospeso',
    'badge_approved': 'Approvato',
    'badge_rejected': 'Rifiutato',
    'badge_manual_review': 'Revisione manuale',
}
};
